const zh = {
    'chatAiDevis.qualityIncell': 'InCell',
    'chatAiDevis.qualityOled': 'OLED',
    'chatAiDevis.qualityOriginal': '原装 / OEM',
    'chatAiDevis.qualityCompatible': '兼容',
    'chatAiDevis.qualityReconditionné': '翻新',
    'chatAiDevis.qualityPremium': '高级',
    'chatAiDevis.qualityStandard': '标准',
    'chatAiDevis.fieldName': '姓名',
    'chatAiDevis.fieldPhone': '电话',
    'chatAiDevis.fieldEmail': '电子邮箱',
    'chatAiDevis.familyAccessoryStock': '配件 · 有货',
    'chatAiDevis.familyAccessoryCapped': '配件 · ≤49€',
    'chatAiDevis.familyAccessory': '配件',
    'chatAiDevis.familyPart': '零件',
    'chatAiDevis.familyScreen': '屏幕',
    'chatAiDevis.badgeFallback': '估算价格（回退）',
    'chatAiDevis.badgeModelScore': '型号匹配分 {{score}}',
    'chatAiDevis.badgeModelScoreShort': '型号匹配分',
    'chatAiDevis.badgeNeedsReview': '待核实',
    'chatAiDevis.altOtherParts': '其他配件（全部供应商）',
    'chatAiDevis.altSelected': '已选',
    'chatAiDevis.useBtn': '使用',
    'chatAiDevis.compareTitle': '对比 Jens / Mobilax / LCD-Phone',
    'chatAiDevis.compareCurrentLabel': '当前：',
    'chatAiDevis.htSuffix': '不含税',
    'chatAiDevis.compareNoneFound': '在三家供应商处均未找到配件。',
    'chatAiDevis.colSupplier': '供应商',
    'chatAiDevis.colPart': '配件',
    'chatAiDevis.colPurchaseHt': '采购价（不含税）',
    'chatAiDevis.colTtcEst': '含税（估算）',
    'chatAiDevis.colStock': '库存',
    'chatAiDevis.colExactModel': '精确型号',
    'chatAiDevis.badgeCheapest': '最便宜',
    'chatAiDevis.badgeCurrent': '当前',
    'chatAiDevis.scoreInline': '匹配分 {{score}}',
    'chatAiDevis.compareNoResultFor': '无结果：{{suppliers}}',
    'chatAiDevis.cadbotEmptyCache': 'CADBOT 请求 — 供应商缓存为空。请输入采购价（不含税），然后点击验证发送报价。',
    'chatAiDevis.purchaseMissingZero': '缺少采购价（0 €）— 请刷新配件或手动输入采购价。',
    'chatAiDevis.supplierPrimary': '主要',
    'chatAiDevis.supplierAlternate': '备选',
    'chatAiDevis.defaultRepair': '维修',
    'chatAiDevis.defaultPart': '零件',
    'chatAiDevis.defaultClient': '客户',
    'chatAiDevis.identityIncompleteInline': '客户资料不完整（{{fields}}）— 验证前必填',
    'chatAiDevis.willSendTo': '报价将发送至 {{email}}',
    'chatAiDevis.phName': '姓名 *',
    'chatAiDevis.phPhone': '电话 *',
    'chatAiDevis.phEmail': '电子邮箱 *',
    'chatAiDevis.saveIdentityBtn': '保存客户资料',
    'chatAiDevis.ttcCalcul': '含税 · /calcul',
    'chatAiDevis.selectedPart': '所选配件',
    'chatAiDevis.purchasePriceHt': '采购价（不含税）',
    'chatAiDevis.labor': '工时费',
    'chatAiDevis.recalcTotal': '重新计算总额',
    'chatAiDevis.hideCompare': '隐藏对比',
    'chatAiDevis.compareBtn': '对比 Jens / Mobilax / LCD-Phone',
    'chatAiDevis.showAlternatives': '查看备选（列表）',
    'chatAiDevis.hideAlternatives': '隐藏备选（列表）',
    'chatAiDevis.botStaff': '员工机器人',
    'chatAiDevis.bestPartAuto': '自动选最优配件',
    'chatAiDevis.pdf': 'PDF',
    'chatAiDevis.approveSingle': '单独验证',
    'chatAiDevis.reject': '拒绝',
    'chatAiDevis.print': '打印',
    'chatAiDevis.dirAdminTitle': '管理层 / 门店管理员',
    'chatAiDevis.delete': '删除',
    'chatAiDevis.approvedShort': '已验证',
    'chatAiDevis.rejectedShort': '已拒绝',
    'chatAiDevis.batchLabel': '批次 {{count}} 份报价',
    'chatAiDevis.clientChat': '客户聊天',
    'chatAiDevis.approveAllSend': '验证全部 {{count}} 份并发送',
    'chatAiDevis.deleteBatch': '删除批次',
    'chatAiDevis.pageTitle': 'AI 报价 — 验证',
    'chatAiDevis.pageSubtitle': '每个屏幕请求 4 个选项 · InCell · OLED · 翻新 · 原装',
    'chatAiDevis.filterPending': '待处理',
    'chatAiDevis.filterApproved': '已验证',
    'chatAiDevis.filterRejected': '已拒绝',
    'chatAiDevis.filterAll': '全部',
    'chatAiDevis.infoTitle': 'AI 聊天与 Auto-Devis — 供应商',
    'chatAiDevis.infoJensPrimary': '是主要供应商（评分优先）。',
    'chatAiDevis.infoAnd': '和',
    'chatAiDevis.infoMobilaxLcd': '在匹配更佳或 Jens 没有该配件时会被查询。',
    'chatAiDevis.infoEachRange': '每个档位（InCell、OLED 等）可能来自不同供应商 — 验证前请核对。',
    'chatAiDevis.infoCompareExplain': '“对比 Jens / Mobilax / LCD-Phone”会显示每家供应商的不含税采购价、估算含税总额、库存和精确型号 — “使用”可切换草稿。',
    'chatAiDevis.infoBadgesLabel': '标签：',
    'chatAiDevis.infoBadgesCheck': '— 验证前请检查配件。',
    'chatAiDevis.infoBotStaffExplain': '（右侧面板）— 描述一次维修以创建草稿，或输入“comparer”查看全部供应商。',
    'chatAiDevis.loading': '加载中…',
    'chatAiDevis.noQuotesPending': '没有待处理的报价。',
    'chatAiDevis.noQuotes': '没有报价。',
    'chatAiDevis.emptyHint': '使用右侧的 Auto-Devis 机器人创建一个（例如“屏幕 iPhone 14”）。',
    'chatAiDevis.backToStaff': '← 返回员工区',
    'chatAiDevis.botAutoDevis': 'Auto-Devis 机器人',
    'chatAiDevis.staffSpace': '← 员工区',
    'chatAiDevis.errPdfPreview': 'PDF 预览出错',
    'chatAiDevis.alertPurchaseMissingPrint': '缺少采购价 — 打印前请输入价格或刷新配件。',
    'chatAiDevis.errPrintTicket': '80mm 小票打印出错',
    'chatAiDevis.errRecalc': '重新计算出错',
    'chatAiDevis.errPartNotFound': '在供应商缓存中未找到配件',
    'chatAiDevis.errCompare': '供应商对比出错',
    'chatAiDevis.errAlternatives': '加载备选出错',
    'chatAiDevis.errSaveIdentity': '保存客户资料出错',
    'chatAiDevis.alertIdentityIncomplete': '客户资料不完整：{{fields}}。验证并发送报价前，姓名、电话和电子邮箱为必填项。',
    'chatAiDevis.mailWillSend': '将向以下地址发送含 PDF 的电子邮件：{{email}}',
    'chatAiDevis.noClientEmail': '（无客户电子邮箱 — 仅通过聊天验证）',
    'chatAiDevis.confirmApprove': '验证此报价并发送给客户？',
    'chatAiDevis.sumupWarn': '注意：无法创建 SumUp 付款链接（{{error}}）。邮件中的按钮将在点击时提供付款；请检查设置中的 SumUp API 密钥。',
    'chatAiDevis.sumupUnavailable': 'SumUp 不可用',
    'chatAiDevis.approvedMailSent': '报价已验证 — 电子邮件已发送至 {{email}}。',
    'chatAiDevis.approvedSent': '报价已验证并发送给客户。',
    'chatAiDevis.errApprove': '验证出错',
    'chatAiDevis.confirmApproveBatch': '验证这 {{count}} 份报价并将汇总发送给客户？',
    'chatAiDevis.batchApproved': '{{count}} 份报价已验证并发送给客户。',
    'chatAiDevis.errApproveBatch': '批次验证出错',
    'chatAiDevis.promptRejectReason': '拒绝原因（可选）：',
    'chatAiDevis.errGeneric': '出错',
    'chatAiDevis.confirmDeleteDevis': '永久删除报价 {{ref}}？\n\n此操作不可撤销。',
    'chatAiDevis.errDelete': '删除出错',
    'chatAiDevis.confirmDeleteBatch': '永久删除该批次中的 {{count}} 份报价？\n\n此操作不可撤销。',
    'chatAiDevis.errDeleteBatch': '批次删除出错',
    'saLayout.nav_dashboard': '仪表板',
    'saLayout.nav_analytics': '分析',
    'saLayout.nav_companies': '企业',
    'saLayout.nav_subscriptions': '订阅',
    'saLayout.nav_users': '用户',
    'saLayout.nav_stats': '统计',
    'saLayout.nav_communications': '通讯',
    'saLayout.nav_impersonation': '支持模式',
    'saLayout.nav_config': '配置',
    'saLayout.nav_integrations': 'API 集成',
    'saLayout.nav_security': '安全 (2FA)',
    'saLayout.nav_logs': '日志与审计',
    'saLayout.super_admin': '超级管理员',
    'saLayout.role_super_admin': '超级管理员',
    'saLayout.logout': '退出登录',
    'saLayout.top_bar_title': '超级管理员面板',
    'saConfig.error': '错误',
    'saConfig.confirmMaintenance': '启用维护模式？客户将无法再访问平台。',
    'saConfig.title': '配置',
    'saConfig.subtitle': '平台全局设置',
    'saConfig.saved': '已保存',
    'saConfig.saving': '保存中...',
    'saConfig.save': '保存',
    'saConfig.maintenanceTitle': '维护模式',
    'saConfig.maintenanceDesc': '暂时阻止客户访问',
    'saConfig.generalSettings': '常规设置',
    'saConfig.platformName': '平台名称',
    'saConfig.gracePeriod': '宽限期（天）',
    'saConfig.plans': '价格方案',
    'saConfig.planPrice': '价格（欧元/月）',
    'saConfig.maxShops': '最多门店',
    'saConfig.maxUsers': '最多用户',
    'saConfig.features': '功能',
    'saImpersonation.title': '支持模式（身份模拟）',
    'saImpersonation.subtitle': '临时访问某个企业的账户',
    'saImpersonation.confirmEnter': '进入该企业的支持模式？',
    'saImpersonation.errorGeneric': '错误',
    'saImpersonation.activeBannerTitle': '支持模式已启用',
    'saImpersonation.connectedAs': '当前身份：{{name}}',
    'saImpersonation.stopSupport': '退出支持模式',
    'saImpersonation.warningTitle': '注意 — 敏感功能',
    'saImpersonation.warningText': '身份模拟将使您获得客户账户的完全访问权限。您的所有操作都会被记录。客户的密码永远不会被修改。',
    'saImpersonation.searchPlaceholder': '搜索企业...',
    'saImpersonation.emptyList': '未找到任何企业',
    'saImpersonation.companyMeta': '{{email}} - 套餐 {{plan}}',
    'saImpersonation.enterBtn': '进入',
    'saPackages.title': '包管理',
    'saPackages.subtitle': '直接替换生产环境中提供的 ZIP 文件和 Windows 代理程序。',
    'saPackages.refresh': '刷新',
    'saPackages.statAvailable': '可用构件',
    'saPackages.statTotalSize': '总大小',
    'saPackages.statAlert': '警告',
    'saPackages.alertText': '替换会直接覆盖线上文件。没有单独的删除操作。',
    'saPackages.statusAvailable': '可用',
    'saPackages.statusMissing': '缺失',
    'saPackages.download': '下载',
    'saPackages.activeFile': '当前文件',
    'saPackages.size': '大小',
    'saPackages.lastUpdate': '最后更新',
    'saPackages.uploadedBy': '上传者',
    'saPackages.replaceLiveFile': '替换线上文件',
    'saPackages.uploading': '上传中…',
    'saPackages.replace': '替换',
    'saPackages.replaceHint': '所选文件会直接替换 remobiles.com 上向用户提供的文件。',
    'saPackages.selectedFile': '已选文件：{{name}}',
    'saPackages.errorLoad': '加载文件出错',
    'saPackages.downloadLinkUnavailable': '下载链接不可用',
    'saPackages.downloadFailed': '下载失败',
    'saPackages.selectFileFor': '请为 {{label}} 选择一个文件。',
    'saPackages.confirmReplace': '现在用 {{name}} 替换 {{label}} 吗？',
    'saPackages.replaceSuccess': '{{label}} 替换成功。',
    'saPackages.errorUpload': '上传过程中出错',
    'saPackages.superAdminOnly': '仅限超级管理员访问',
    'saPackages.superAdminDesc': '此页面可用于更新 remobiles.com 当前提供的文件。公开下载链接仍由后端的签名路由控制。',
    'saDashboard.title': '仪表盘',
    'saDashboard.subtitle': '{{brand}} 平台概览',
    'saDashboard.companies': '企业',
    'saDashboard.activeCount': '{{count}} 家活跃',
    'saDashboard.users': '用户',
    'saDashboard.shops': '门店',
    'saDashboard.mrr': 'MRR',
    'saDashboard.mrrSub': '月度经常性收入',
    'saDashboard.newThisMonth': '本月新增',
    'saDashboard.expired': '已过期',
    'saDashboard.suspended': '已暂停',
    'saDashboard.recentCompanies': '最近的企业',
    'saDashboard.viewAll': '查看全部',
    'saDashboard.noCompanies': '暂无企业',
    'saDashboard.recentActivity': '最近活动',
    'saDashboard.noActivity': '暂无最近活动',
    'saAnalytics.title': '平台分析',
    'saAnalytics.subtitle': '全局关键指标及各企业绩效',
    'saAnalytics.kpiRepairsToday': '今日维修',
    'saAnalytics.kpiActiveRepairs': '进行中的维修',
    'saAnalytics.kpiRevenueMonth': '本月营收',
    'saAnalytics.kpiClientsTotal': '客户总数',
    'saAnalytics.kpiRepairsWeek': '本周维修',
    'saAnalytics.kpiRepairsMonth': '本月维修',
    'saAnalytics.kpiRepairsTotal': '维修总数',
    'saAnalytics.kpiRevenueTotal': '总营收',
    'saAnalytics.kpiActiveCompanies': '活跃企业',
    'saAnalytics.companyPerformance': '各企业绩效',
    'saAnalytics.companiesCount': '{{count}} 家企业',
    'saAnalytics.emptyCompanies': '没有活跃企业',
    'saAnalytics.colCompany': '企业',
    'saAnalytics.colPlan': '套餐',
    'saAnalytics.colRepairs': '维修',
    'saAnalytics.colActive': '进行中',
    'saAnalytics.colClients': '客户',
    'saAnalytics.colStock': '库存',
    'saAnalytics.colSales': '销售',
    'saAnalytics.colRevenue': '营收',
    'saAnalytics.colAvgTime': '平均时长',
    'saAnalytics.daysShort': '{{n}}天',
    'saLogs.title': '日志与安全',
    'saLogs.subtitle': '操作审计与系统健康',
    'saLogs.systemHealth': '系统健康',
    'saLogs.database': '数据库',
    'saLogs.statusOk': '正常',
    'saLogs.statusError': '错误',
    'saLogs.filterAll': '所有操作',
    'saLogs.filterCreateCompany': '创建企业',
    'saLogs.filterUpdateCompany': '修改企业',
    'saLogs.filterSuspend': '暂停',
    'saLogs.filterActivate': '重新激活',
    'saLogs.filterImpersonate': '身份模拟',
    'saLogs.filterCreateUser': '创建用户',
    'saLogs.filterDeleteUser': '删除用户',
    'saLogs.filterResetPassword': '重置密码',
    'saLogs.filterUpdateSubscription': '修改订阅',
    'saLogs.filterUpdateConfig': '修改配置',
    'saLogs.entriesCount': '{{count}} 条记录',
    'saLogs.empty': '日志中没有记录',
    'saLogs.onTarget': '针对 {{target}}',
    'saLogs.byUserAt': '由 {{user}} - {{date}}',
    'saComm.title': '通讯',
    'saComm.messagesSent': '已发送 {{count}} 条消息',
    'saComm.newMessage': '新消息',
    'saComm.emptyList': '尚未发送任何通讯',
    'saComm.noSubject': '无主题',
    'saComm.allClients': '所有客户',
    'saComm.companiesCount': '{{count}} 家企业',
    'saComm.modalTitle': '发送通讯',
    'saComm.typeLabel': '类型',
    'saComm.typeNotification': '通知',
    'saComm.typeMaintenance': '维护',
    'saComm.typeUpdate': '更新',
    'saComm.recipients': '收件人',
    'saComm.targetSelected': '选择',
    'saComm.targetedCompanies': '目标企业',
    'saComm.subjectLabel': '主题 *',
    'saComm.messageLabel': '消息 *',
    'saComm.cancel': '取消',
    'saComm.send': '发送',
    'saComm.errorGeneric': '错误',
    'saSecurity.pageTitle': '账户安全',
    'saSecurity.pageSubtitle': '双重验证、IP 限制和安全设置',
    'saSecurity.errorGeneric': '错误',
    'saSecurity.twoFAEnabledSuccess': '双重验证已成功启用！',
    'saSecurity.invalidCode': '验证码无效',
    'saSecurity.twoFADisabled': '双重验证已停用',
    'saSecurity.saveError': '保存时出错',
    'saSecurity.twoFATitle': '双重身份验证 (2FA)',
    'saSecurity.statusEnabled': '已启用',
    'saSecurity.statusDisabled': '已停用',
    'saSecurity.setupBtn': '设置双重验证',
    'saSecurity.scanQrInstruction': '使用 Google Authenticator 扫描此二维码：',
    'saSecurity.qrCodeAlt': '二维码',
    'saSecurity.manualKeyInstruction': '或手动输入此密钥：',
    'saSecurity.verificationCodeLabel': '验证码',
    'saSecurity.verifyBtn': '验证',
    'saSecurity.disableInstruction': '要停用双重验证，请输入您当前的验证码：',
    'saSecurity.ipRestrictionTitle': 'IP 限制（可选）',
    'saSecurity.ipRestrictionSubtitle': '将超级管理员访问限制为特定 IP 地址',
    'saSecurity.ipPlaceholder': '每行一个 IP（例如：192.168.1.1）',
    'saSecurity.saved': '已保存',
    'saSecurity.save': '保存',
    'saStats.title': '业务统计',
    'saStats.subtitle': '财务分析与预测',
    'saStats.mrrTitle': '每月经常性收入 (MRR)',
    'saStats.planDistTitle': '套餐分布',
    'saStats.emptyData': '暂无数据',
    'saStats.churnTitle': '流失率 (Churn)',
    'saStats.cancelledCount': '{{count}} 个已取消',
    'saStats.growthTitle': '增长 - 新公司',
    'repairUi.repairs': '维修',
    'repairUi.repairSheet': '维修单',
    'repairUi.edit': '编辑',
    'repairUi.print': '打印',
    'repairUi.backToRepairs': '返回维修',
    'repairUi.editRepair': '编辑维修',
    'repairUi.newDeposit': '新收件',
    'repairUi.ref': '编号',
    'saSubscriptions.title': '订阅',
    'saSubscriptions.count': '{{count}} 个订阅',
    'saSubscriptions.filter_all_statuses': '所有状态',
    'saSubscriptions.filter_all_plans': '所有套餐',
    'saSubscriptions.status_active': '有效',
    'saSubscriptions.status_suspended': '已暂停',
    'saSubscriptions.status_expired': '已过期',
    'saSubscriptions.status_overdue': '逾期',
    'saSubscriptions.status_cancelled': '已取消',
    'saSubscriptions.col_company': '企业',
    'saSubscriptions.col_plan': '套餐',
    'saSubscriptions.col_price': '价格',
    'saSubscriptions.col_status': '状态',
    'saSubscriptions.col_next_billing': '下次计费',
    'saSubscriptions.col_discount': '折扣',
    'saSubscriptions.col_actions': '操作',
    'saSubscriptions.empty': '暂无订阅',
    'saSubscriptions.action_edit': '修改',
    'saSubscriptions.action_extend': '延长',
    'saSubscriptions.modal_title': '修改订阅',
    'saSubscriptions.label_discount': '折扣 (%)',
    'saSubscriptions.plan_option_start': 'Start ({{price}})',
    'saSubscriptions.plan_option_pro': 'Pro ({{price}})',
    'saSubscriptions.plan_option_super': 'Super ({{price}})',
    'saSubscriptions.cancel': '取消',
    'saSubscriptions.save': '保存',
    'saSubscriptions.prompt_extend_days': '要添加的天数：',
    'saSubscriptions.error': '错误',
    'saUsers.title': '用户',
    'saUsers.totalUsers': '{{count}} 个用户',
    'saUsers.newUser': '新建用户',
    'saUsers.searchPlaceholder': '搜索...',
    'saUsers.filterAllRoles': '所有角色',
    'saUsers.roleSuperAdmin': '超级管理员',
    'saUsers.roleAdmin': '管理员',
    'saUsers.roleUser': '员工',
    'saUsers.roleTechnicien': '技术员',
    'saUsers.roleClient': '客户',
    'saUsers.roleB2b': 'B2B',
    'saUsers.emptyState': '未找到用户',
    'saUsers.colUser': '用户',
    'saUsers.colRole': '角色',
    'saUsers.colCompany': '公司',
    'saUsers.colCreatedAt': '创建于',
    'saUsers.colActions': '操作',
    'saUsers.resetPassword': '重置密码',
    'saUsers.delete': '删除',
    'saUsers.labelUsername': '用户名',
    'saUsers.labelEmail': '邮箱',
    'saUsers.labelPassword': '密码',
    'saUsers.companyNone': '无',
    'saUsers.cancel': '取消',
    'saUsers.create': '创建',
    'saUsers.labelNewPassword': '新密码',
    'saUsers.reset': '重置',
    'saUsers.error': '错误',
    'saUsers.resetSuccess': '密码重置成功',
    'saUsers.confirmDelete': '删除用户 {{username}}？',
    'saCompanies.status_active': '活跃',
    'saCompanies.status_suspended': '已暂停',
    'saCompanies.status_overdue': '逾期',
    'saCompanies.status_archived': '已归档',
    'saCompanies.error': '错误',
    'saCompanies.confirm_suspend': '暂停这家公司？',
    'saCompanies.suspend_reason_manual': '手动暂停',
    'saCompanies.confirm_archive': '归档这家公司？此操作不可撤销。',
    'saCompanies.reminder_sent': '提醒邮件已发送',
    'saCompanies.reminder_error': '发送时出错',
    'saCompanies.title': '公司',
    'saCompanies.total_companies': '共 {{count}} 家公司',
    'saCompanies.new_company': '新建公司',
    'saCompanies.search_placeholder': '搜索...',
    'saCompanies.filter_all_status': '所有状态',
    'saCompanies.filter_overdue': '逾期',
    'saCompanies.filter_all_plans': '所有套餐',
    'saCompanies.empty': '未找到公司',
    'saCompanies.col_company': '公司',
    'saCompanies.col_plan': '套餐',
    'saCompanies.col_status': '状态',
    'saCompanies.col_users': '用户',
    'saCompanies.col_registered': '注册于',
    'saCompanies.col_actions': '操作',
    'saCompanies.action_view': '查看',
    'saCompanies.action_reminder': '发送付款提醒',
    'saCompanies.action_suspend': '暂停',
    'saCompanies.action_reactivate': '重新启用',
    'saCompanies.action_archive': '归档',
    'saCompanies.field_company_name': '公司名称',
    'saCompanies.field_contact': '主要联系人',
    'saCompanies.field_email': '邮箱',
    'saCompanies.field_phone': '电话',
    'saCompanies.field_address': '地址',
    'saCompanies.field_plan': '订阅套餐',
    'saCompanies.plan_option_start': 'Start（{{price}}/月）',
    'saCompanies.plan_option_pro': 'Pro（{{price}}/月）',
    'saCompanies.plan_option_super': 'Super（{{price}}/月）',
    'saCompanies.field_shop_count': '店铺数量',
    'saCompanies.admin_account': '公司管理员账户',
    'saCompanies.field_admin_email': '管理员邮箱',
    'saCompanies.field_password': '密码',
    'saCompanies.field_notes': '内部备注',
    'saCompanies.cancel': '取消',
    'saCompanies.create_company': '创建公司',
    'saCompanies.users_count': '{{count}} 个用户',
    'saCompanies.subscription': '订阅',
    'saCompanies.monthly_price': '月费',
    'saCompanies.next_billing': '下次计费',
    'saCompanies.no_users': '暂无用户',
    'qrRouter.redirecting': '正在跳转...',
    'subscriptionPages.verifyingPayment': '正在验证付款…',
    'subscriptionPages.successTitle': '支付成功！',
    'subscriptionPages.successBody': '您的订阅现已生效。',
    'subscriptionPages.goToDashboard': '前往仪表板',
    'subscriptionPages.processingPayment': '正在处理付款…',
    'subscriptionPages.errorTitle': '错误',
    'subscriptionPages.errorBody': '无法验证付款。',
    'subscriptionPages.backToDashboard': '返回仪表板',
    'subscriptionPages.cancelTitle': '支付已取消',
    'subscriptionPages.cancelBody': '支付已取消。您可以随时重试。',
    'common.error': '错误',
    'notes.uploadError': '上传时出错',
    'notes.downloadError': '下载时出错',
    'notes.confirmDeleteFile': '删除此文件？',
    'notes.uploading': '上传中...',
    'notes.attach': '添加附件',
    'notes.addedBy': '由 {{author}} 添加 — {{date}}',
    'notes.sizeBytes': '{{size}} 字节',
    'notes.sizeKb': '{{size}} KB',
    'notes.sizeMb': '{{size}} MB',
    'historique.subtitle': '销售、小票和定金',
    'historique.centreActivite': '活动中心',
    'historique.filtresRecherche': '筛选和搜索',
    'historique.rechercher': '搜索',
    'historique.searchPlaceholder': '商品、参考号…',
    'historique.vendeur': '销售员',
    'historique.tous': '全部',
    'historique.dateDebut': '开始日期',
    'historique.dateFin': '结束日期',
    'historique.magasin': '门店',
    'historique.filtrer': '筛选',
    'historique.reinitialiser': '重置',
    'historique.totalVentes': '销售总额',
    'historique.totalAcomptes': '定金总额',
    'historique.totalRetraits': '取款总额',
    'historique.totalGlobal': '总计',
    'historique.commVentes': '销售佣金（{{pct}}%）',
    'historique.commReparations': '维修佣金（{{pct}}%）',
    'historique.commCommandes': '订单佣金（{{pct}}%）',
    'historique.totalCommissions': '佣金合计',
    'historique.popupsAutoriser': '请允许弹出窗口以便打印。',
    'historique.erreurTelechargement': '下载时出错',
    'historique.vendeurDatesRequis': '请填写销售员和日期',
    'historique.erreurImpressionRapport': '打印报告出错',
    'historique.erreurConfirmationSumup': '确认 SumUp 时出错',
    'historique.confirmRefusPaiement': '将此付款标记为拒绝 / 取消？',
    'historique.erreurRefusSumup': '拒绝 SumUp 时出错',
    'dash.forceOpen': '强制开启',
    'dash.force': '强制',
    'dash.forceOpenTitle': '强制开启收银台 {{magasin}}',
    'dash.forceOpenWarning': '任何已开启的收银台都将自动关闭。系统会以输入的金额创建一个新的收银台。',
    'dash.noOpenCaisseToForce': '{{magasin}} 没有可强制关闭的已开启收银台。',
    'dash.thisMagasin': '本店',
    'dash.statusOpenF': '已开启',
    'dash.statusClosedF': '已关闭',
    'dash.openMagasin': '开启 {{magasin}}',
    'dash.forceOpenShort': '强制开启',
    'dash.closeMagasin': '关闭 {{magasin}}',
    'dash.forceCloseShort': '强制关闭',
    'dash.subtitleNetwork': '网络视图 · 收银台 · 关键指标',
    'dash.subtitleWorkshop': '维修车间 · 维修',
    'dash.subtitleDefault': '仪表盘 · 销售与动态',
    'dash.caisseActionsByStore': '按门店的收银台操作',
    'devisFactures.printPopupBlocked': '请允许弹出窗口以进行打印。',
    'devisFactures.errorPrintTicket': '打印小票出错',
    'devisFactures.errorPrintA4': '打印 A4 出错',
    'devisFactures.errorConvert': '转换为订单时出错',
    'devisFactures.errorDelete': '删除出错',
    'devisFactures.errorInvalidEmail': '电子邮箱地址无效',
    'devisFactures.emailSent': '已将 {{type}} 发送至 {{email}}',
    'devisFactures.errorSendEmail': '发送电子邮件出错',
    'devisFactures.linkedTo': '已关联到 {{ref}}',
    'devisFactures.sendByEmail': '通过电子邮件发送',
    'devisFactures.detachConfirm': '要将此报价单与 {{ref}} 取消关联吗？',
    'devisFactures.error': '出错',
    'devisFactures.attachToRepair': '关联到维修单',
    'devisFactures.emailModalTitle': '通过电子邮件发送 {{type}}',
    'devisFactures.refLabel': '参考号：',
    'devisFactures.a4PdfNote': '该文档将以 A4 PDF 格式发送',
    'devisFactures.clientEmailLabel': '客户电子邮箱地址',
    'devisFactures.emailPlaceholder': 'client@example.com',
    'devisFactures.labelDevis': '报价单',
    'devisFactures.labelFacture': '发票',
    'devisFactures.labelCommande': '订单',
    'devisFactures.labelAvoir': '贷记单',
    'devisFactures.labelPaye': '已付款',
    'devisFactures.labelAnnule': '已取消',
    'devisFactures.labelEnAttente': '待处理',
    'clients.tabPins': 'PIN 码 / 密码',
    'clients.pin': 'PIN 码',
    'clients.error': '错误',
    'clients.loadError': '加载出错',
    'clients.saveError': '保存出错',
    'clients.sendError': '发送出错',
    'clients.noIdLegacy': '该客户没有 ID（旧数据）。请编辑以更新。',
    'clients.ficheAccessDenied': '访问被拒绝：只有管理员可以查看客户档案。',
    'clients.pinGenerated': '已为 {{nom}} 生成 PIN {{pin}}',
    'clients.ficheClient': '客户档案',
    'clients.optional': '可选',
    'clients.genNewPin': '生成新 PIN',
    'clients.sendPinEmail': '通过邮件发送 PIN',
    'clients.loyaltyLine': '会员忠诚度：{{level}} — {{points}} 分 — {{purchases}} 次购买',
    'clients.repairs': '维修',
    'clients.commandes': '订单',
    'clients.devis': '报价',
    'clients.ventesPos': 'POS 销售',
    'clients.acomptes': '定金',
    'clients.noneFem': '无',
    'clients.noneMasc': '无',
    'cmd.clientPartsTitle': '客户配件订单',
    'cmd.pageIntro': '像维修一样添加配件（库存或需订购）。定金将从总额中扣除。',
    'cmd.deposits': '定金',
    'cmd.remainingShort': '余额',
    'cmd.statusConverting': '转换中',
    'cmd.repairBadge': '维修 {{ref}}',
    'cmd.toOrderShort': '待订',
    'cmd.stockOutShort': '已出库',
    'cmd.inStockShort': '有库存',
    'cmd.view': '查看',
    'cmd.addDeposit': '+ 定金',
    'cmd.settled': '已结清',
    'cmd.convertToRepair': '转为维修',
    'cmd.trackingWith': '物流单号：{{num}}',
    'cmd.trackingNumber': '物流单号',
    'cmd.newClientParts': '新建配件订单',
    'cmd.partsSectionTitle': '配件（与维修相同）',
    'cmd.searchStockPlaceholder': '搜索库存配件…',
    'cmd.noRef': '无编号',
    'cmd.toOrder': '需订购',
    'cmd.stock': '库存',
    'cmd.qtyShort': '数量',
    'cmd.unitPriceLabel': '单价 (€)',
    'cmd.stockSection': '库存',
    'cmd.alreadyOut': '已从库存取出',
    'cmd.decrementOnSave': '保存时扣减',
    'cmd.stillInStock': '仍在库存',
    'cmd.outOnConvert': '转为维修时出库',
    'cmd.addPendingBtn': '需订购配件（无库存）',
    'cmd.pendingTitle': '需订购配件',
    'cmd.designationPlaceholder': '名称 *',
    'cmd.refOptPlaceholder': '编号（可选）',
    'cmd.salePricePlaceholder': '售价 €',
    'cmd.partsTotal': '配件合计',
    'cmd.depositsPaid': '已付定金',
    'cmd.addDepositTitle': '添加定金',
    'cmd.orderLabel': '订单',
    'cmd.alreadyPaid': '已付',
    'cmd.depositAmount': '定金金额 (€)',
    'cmd.paymentMode': '付款方式',
    'cmd.payCash': '现金',
    'cmd.payCard': '银行卡',
    'cmd.payTransfer': '转账',
    'cmd.payCheck': '支票',
    'cmd.newRemainingAfter': '付定金后的新余额：',
    'cmd.depositsPaidTitle': '已付定金',
    'cmd.noDeposits': '暂无已付定金',
    'cmd.trackingPlaceholder': '例如 8R123456789FR',
    'cmd.trackingEmailNote': '如果客户已填写邮箱，将向其发送电子邮件。',
    'cmd.error': '错误',
    'cmd.errDesignationRequired': '需填写需订购配件的名称',
    'cmd.errClientPhoneRequired': '需填写客户和电话',
    'cmd.errAddPart': '请至少添加一个配件（库存搜索或需订购配件）',
    'cmd.errDelete': '删除时出错',
    'cmd.cancelConfirm': '取消此订单？',
    'cmd.errInvalidAmount': '金额无效',
    'cmd.errDepositExceeds': '定金不能超过应付余额（{{reste}}）',
    'cmd.errPrintTicket': '打印小票出错',
    'cmd.errPrintDepositTicket': '打印定金小票出错',
    'cmd.convertConfirm': '将此订单转为维修？',
    'cmd.errConvert': '转为维修出错',
    'cmd.promptClientEmail': '客户邮箱：',
    'cmd.emailSent': '订单已发送至 {{email}}',
    'cmd.errSendEmail': '发送邮件出错',
    'cmd.errTracking': '物流单号出错',
    'pos.insufficientStock': '库存不足',
    'pos.partialPaymentConfirm': '已付金额（{{paid}}）低于总额（{{total}}）。\n\n尚需支付：{{remaining}}\n\n确认为部分付款？',
    'pos.loyaltyRewardEarned': '\n\n会员积分：恭喜！奖励已解锁！下次购买享 15% 优惠或下次维修享 10% 优惠！',
    'pos.loyaltyRewardPending': '\n\n会员积分：奖励待领取（下次收银台购买享 15% 或维修享 10%）',
    'pos.loyaltyProgress': '\n\n会员积分：已购 {{points}}/10 次。再购 {{remaining}} 次即可获得奖励！',
    'pos.partialPaymentLine': '\n部分付款 - 尚需支付：{{remaining}}',
    'pos.invoiceSentAuto': '\n发票已自动发送至 {{email}}',
    'pos.offlineSaleMsg': '\n\n离线模式 - 销售已本地保存。\n网络恢复后将自动同步。\n（邮件发送和库存更新将在此时进行。）',
    'pos.refLabel': '编号：{{ref}}',
    'pos.totalLabel': '总计：{{total}}',
    'pos.saleError': '销售过程中出错。\nHTTP 代码：{{code}}\n该销售可能未保存。请检查历史记录。',
    'pos.unknownStatus': '未知',
    'pos.invalidEmailEnter': '请输入有效的电子邮件地址',
    'pos.accountCreated': '客户账户已创建！登录凭据已通过电子邮件发送。',
    'pos.accountCreateError': '创建账户时出错',
    'pos.invalidAmount': '金额无效',
    'pos.acompteDesignation': '维修定金 {{ref}}',
    'pos.designationPriceRequired': '需填写名称和价格',
    'pos.manualAddError': '手动添加出错',
    'pos.adminValidationFailed': '管理员验证失败',
    'pos.printTicketError': '小票打印出错',
    'pos.notAllTicketsPrintedConfirm': '⚠️ 您还没有打印所有小票。\n\n顾客需要拿到每一张小票。仍要关闭吗？',
    'pos.invalidEmail': '电子邮件地址无效',
    'pos.invoiceSentTo': '发票已发送至 {{email}}',
    'pos.sendEmailError': '邮件发送出错',
    'pos.caisseClosedOffline': '收银台已关闭。请连接网络并从仪表板打开收银台以进行销售。',
    'pos.caisseCachedHint': '收银台状态来自本地缓存（离线模式）。网络恢复后将进行最终校验。',
    'pos.catalog': '目录',
    'pos.available': '有货 {{count}}',
    'pos.outOfStockShort': '缺货',
    'pos.acompteRepair': '维修定金',
    'pos.rewardAvailable': '奖励可用！',
    'pos.rewardAutoApplied': '-15% 自动应用',
    'pos.purchases': '次购买',
    'pos.beforeReward': '（还差 {{count}} 次获得奖励）',
    'pos.searchClientPlaceholder': '搜索...',
    'pos.clientName': '客户姓名',
    'pos.phone': '电话',
    'pos.emailOptional': '电子邮件（可选）',
    'pos.totalCaps': '总计',
    'pos.willGenerateTickets': '本次销售将生成 {{count}} 张独立小票：',
    'pos.neutralItems': '中性',
    'pos.attachedToSession': '（归入当前会话）',
    'pos.clientEmailPlaceholder': '客户电子邮件',
    'pos.sent': '已发送',
    'pos.send': '发送',
    'pos.alsoAddToStock': '同时加入库存',
    'pos.offlineCbHint': '离线模式 — 银行卡支付已禁用（终端需要网络）。',
    'pos.whichMagasinTitle': '这笔销售记入哪个门店？',
    'pos.close': '关闭',
    'pos.magasinChoiceHelp': '选择记录本次销售的门店。所选门店将用于本次销售以及未指定门店的商品。',
    'pos.magasinLabel': '门店 {{code}}',
    'pos.currentPosSessionFull': '当前 POS 会话：{{code}}。若选择其他门店，POS 会话将切换到该门店进行销售。',
    'pos.validateFor': '确认（{{magasin}}）',
    'pos.createClientAccount': '创建客户账户？',
    'pos.createAccountPrompt': '该客户还没有账户。是否为其创建账户以便在线查看发票？',
    'pos.creating': '创建中...',
    'pos.yesSendCredentials': '是，发送登录凭据',
    'pos.noThanks': '不用了',
    'pos.searchRepair': '搜索维修单',
    'pos.searchRepairPlaceholder': 'REP0047、客户姓名、型号...',
    'pos.priceLabel': '价格：{{price}}',
    'pos.alreadyPaid': '已付：{{amount}}',
    'pos.remainingDue': '尚欠：{{amount}}',
    'pos.changeSelection': '更改',
    'pos.totalPrice': '总价',
    'pos.alreadyPaidShort': '已付',
    'pos.remainingDueShort': '尚欠',
    'pos.acompteAmountLabel': '定金金额（欧元）',
    'pos.addToCart': '加入购物车',
    'pos.saleRecordedTickets': '销售已记录 — 已生成 {{count}} 张小票',
    'pos.printAllForClient': '为顾客打印这 {{count}} 张小票。',
    'pos.printed': '已打印',
    'pos.scanToFind': '扫码查找 {{ref}}',
    'pos.detailUnavailable': '详情不可用（离线模式？）',
    'pos.payment': '付款',
    'pos.printing': '正在打印...',
    'pos.printTicketFor': '打印小票 {{magasin}}',
    'pos.allTicketsSentToPrint': '所有小票已发送打印。',
    'pos.ticketsPrintedCount': '已打印 {{printed}} / {{total}} 张小票。',
    'pos.printAllTickets': '打印全部小票',
    'pos.articlesCount': '{{count}} 件商品',
    'activite.pageTitle': '活动中心',
    'activite.pageSubtitle': '统一时间线 · 销售 · 付款 · 收银 · 库存 · 维修',
    'activite.historiqueDetaille': '详细历史',
    'remcaches.err_connexion': '服务器连接错误',
    'remcaches.err_champs_requis': '用户名和 PIN 码为必填项',
    'remcaches.err_pin_court': 'PIN 码至少需包含 4 位数字',
    'remcaches.err_creation': '创建时出错',
    'remcaches.config_initiale': '初始配置',
    'remcaches.deja_config': '配置已完成',
    'remcaches.admin_existe': '管理员已存在。此页面已停用。',
    'remcaches.aller_connexion': '前往登录',
    'remcaches.admin_cree': '管理员创建成功！',
    'remcaches.label_utilisateur': '用户：',
    'remcaches.label_role': '角色：',
    'remcaches.conserver_identifiants': '请将这些凭据妥善保管。此页面将不再可访问。',
    'remcaches.se_connecter': '登录',
    'remcaches.label_username': '用户名 *',
    'remcaches.ph_username': '例如：carlos',
    'remcaches.label_pin': 'PIN 码（密码） *',
    'remcaches.ph_pin': '4 到 6 位数字',
    'remcaches.label_email': '电子邮箱（可选）',
    'remcaches.label_telephone': '电话（可选）',
    'remcaches.btn_creer_admin': '创建管理员',
    'remcaches.footer': 'R.E.Mobiles - 安全配置',
    'blog.page_title': '手机维修博客',
    'blog.subtitle': '法属圭亚那智能手机维修的技巧、窍门与资讯。',
    'blog.cta_title': '需要维修吗？',
    'blog.cta_desc': '联系 Resurrection Mobile 获取免费报价。',
    'blog.loading': '加载中...',
    'blog.article_not_found': '找不到文章',
    'blog.back_to_blog': '返回博客',
    'blog.home': '首页',
    'blog.see_pricing': '查看我们的价格',
    'blog.footer_pricing': '我们的价格',
    'blog.empty_title': '暂无文章',
    'blog.empty_subtitle': '请稍后再来查看我们的建议！',
    'brandsModels.error': '错误',
    'brandsModels.deleteBrandConfirm': '删除品牌"{{name}}"及其所有型号？',
    'brandsModels.noModels': '暂无型号。',
    'brandsModels.home': '主页',
    'brandsModels.title': '品牌和型号',
    'brandsModels.countBrands': '{{count}} 个品牌',
    'brandsModels.countSeries': '{{count}} 个系列',
    'brandsModels.countModels': '{{count}} 个型号',
    'brandsModels.searchPlaceholder': '搜索品牌、系列或型号……',
    'brandsModels.newBrandPlaceholder': '新品牌……',
    'brandsModels.addBrand': '添加',
    'brandsModels.loading': '加载中……',
    'brandsModels.rename': '重命名',
    'brandsModels.delete': '删除',
    'brandsModels.addModelPlaceholder': '添加 {{brand}} 型号……',
    'brandsModels.addModel': '型号',
    'brandsModels.deleteModel': '删除此型号',
    'brandsModels.noResults': '没有找到匹配的结果',
    'brandsModels.empty': '暂无品牌。请在上方添加。',
    'allDocs.title': '所有文档',
    'allDocs.docsCount': '{{count}} 个文档',
    'allDocs.stat.devis': '报价单',
    'allDocs.stat.factures': '发票',
    'allDocs.stat.bonsCmd': '采购单',
    'allDocs.stat.tickets': '小票',
    'allDocs.stat.total': '合计',
    'allDocs.searchPlaceholder': '按编号、客户、电话搜索...',
    'allDocs.filter': '筛选',
    'allDocs.filterAll': '全部',
    'allDocs.type.devis': '报价单',
    'allDocs.type.facture': '发票',
    'allDocs.type.bonCommande': '采购单',
    'allDocs.type.ticket': '小票',
    'allDocs.col.reference': '编号',
    'allDocs.col.type': '类型',
    'allDocs.col.client': '客户',
    'allDocs.col.telephone': '电话',
    'allDocs.col.total': '合计',
    'allDocs.col.statut': '状态',
    'allDocs.col.liaisons': '关联',
    'allDocs.col.date': '日期',
    'allDocs.col.actions': '操作',
    'allDocs.loading': '加载中...',
    'allDocs.empty': '未找到文档',
    'allDocs.status.devis': '报价单',
    'allDocs.status.enAttente': '待处理',
    'allDocs.status.accepte': '已接受',
    'allDocs.status.refuse': '已拒绝',
    'allDocs.status.payee': '已付款',
    'allDocs.status.commande': '已下单',
    'allDocs.status.enCours': '进行中',
    'allDocs.status.recu': '已收到',
    'allDocs.status.livre': '已交付',
    'allDocs.status.termine': '已完成',
    'allDocs.action.print': '打印 / 查看 PDF',
    'allDocs.action.download': '下载 PDF',
    'allDocs.action.email': '通过电子邮件发送',
    'allDocs.footerCount': '显示 {{count}} 个文档',
    'allDocs.footerCountPlural': '显示 {{count}} 个文档',
    'allDocs.printUnavailable': '此文档无法打印 80 毫米小票（source={{source}}）。',
    'allDocs.downloadUnavailable': '此类文档无法下载（source={{source}}）。',
    'allDocs.emailUnavailable': '此类文档无法通过电子邮件发送（source={{source}}）。',
    'allDocs.emailPrompt': '收件人电子邮件：',
    'allDocs.emailSent': '电子邮件已发送！',
    'allDocs.error': '错误：{{msg}}',
    'themeSettings.title': '颜色自定义',
    'themeSettings.subtitle': '调整您平台的外观',
    'themeSettings.cancel': '取消',
    'themeSettings.saved': '已保存',
    'themeSettings.saving': '正在保存...',
    'themeSettings.save': '保存',
    'themeSettings.presetsTitle': '预设调色板',
    'themeSettings.customTitle': '自定义颜色',
    'themeSettings.previewTitle': '实时预览',
    'themeSettings.previewCompany': '我的公司',
    'themeSettings.previewPrimaryBtn': '主按钮',
    'themeSettings.previewSecondaryBtn': '次要按钮',
    'themeSettings.previewNavDashboard': '仪表盘',
    'themeSettings.previewNavRepairs': '维修',
    'themeSettings.previewNavStock': '库存',
    'themeSettings.previewNavClients': '客户',
    'themeSettings.previewStatusInProgress': '进行中',
    'themeSettings.previewStatusPending': '等待中',
    'themeSettings.fieldPrimaryLabel': '主色',
    'themeSettings.fieldPrimaryDesc': '按钮、链接、主要强调色',
    'themeSettings.fieldSecondaryLabel': '辅助色',
    'themeSettings.fieldSecondaryDesc': '徽章、指示器、辅助强调色',
    'themeSettings.fieldAccentLabel': '强调色',
    'themeSettings.fieldAccentDesc': '页眉背景、对比文字',
    'themeSettings.fieldSidebarBgLabel': '侧边栏背景',
    'themeSettings.fieldSidebarBgDesc': '侧边菜单的背景',
    'themeSettings.fieldSidebarTextLabel': '侧边栏文字',
    'themeSettings.fieldSidebarTextDesc': '菜单中的文字颜色',
    'themeSettings.fieldHeaderBgLabel': '页眉背景',
    'themeSettings.fieldHeaderBgDesc': '顶部栏的背景',
    'themeSettings.presetRougeJaune': '红与黄',
    'themeSettings.presetGuyane': '圭亚那',
    'themeSettings.presetOceanBleu': '蓝色海洋',
    'themeSettings.presetRoyalViolet': '皇家紫',
    'themeSettings.presetEmeraude': '祖母绿',
    'themeSettings.presetSunset': '日落',
    'boutiqueCmd.pageTitle': '网店订单',
    'boutiqueCmd.deleteSelection': '删除所选 ({{count}})',
    'boutiqueCmd.confirmDelete': '删除 {{count}} 个订单？',
    'boutiqueCmd.errUpdate': '更新时出错',
    'boutiqueCmd.errDelete': '删除时出错',
    'boutiqueCmd.noteSent': '✅ 备注已成功发送给客户',
    'boutiqueCmd.errSendNote': '发送备注时出错',
    'boutiqueCmd.trackingSavedEmail': '✅ 物流单号已保存并已向客户发送邮件！',
    'boutiqueCmd.trackingSaved': '✅ 物流单号已保存！',
    'boutiqueCmd.errSaveTracking': '保存时出错',
    'boutiqueCmd.confirmValidateProof': '确认此付款凭证？',
    'boutiqueCmd.confirmRejectProof': '拒绝此付款凭证？',
    'boutiqueCmd.errGeneric': '错误',
    'boutiqueCmd.errDownload': '下载时出错',
    'boutiqueCmd.statutEnAttente': '待处理',
    'boutiqueCmd.statutProofUploaded': '凭证已上传',
    'boutiqueCmd.statutPayee': '已付款',
    'boutiqueCmd.statutConfirmee': '已确认',
    'boutiqueCmd.statutPreparee': '已备货',
    'boutiqueCmd.statutExpediee': '已发货',
    'boutiqueCmd.statutLivree': '已送达',
    'boutiqueCmd.statutAnnulee': '已取消',
    'boutiqueCmd.colReference': '参考号',
    'boutiqueCmd.colClient': '客户',
    'boutiqueCmd.colArticles': '商品',
    'boutiqueCmd.colTotal': '合计',
    'boutiqueCmd.colAdresse': '地址',
    'boutiqueCmd.colStatut': '状态',
    'boutiqueCmd.colSuivi': '物流追踪',
    'boutiqueCmd.colPaiement': '付款',
    'boutiqueCmd.colDate': '日期',
    'boutiqueCmd.colActions': '操作',
    'boutiqueCmd.noOrders': '暂无订单',
    'boutiqueCmd.editTracking': '修改',
    'boutiqueCmd.addTrackingTitle': '添加物流单号',
    'boutiqueCmd.addTrackingBtn': '+ 物流',
    'boutiqueCmd.viewProof': '查看凭证',
    'boutiqueCmd.validatePayment': '确认付款',
    'boutiqueCmd.rejectProof': '拒绝凭证',
    'boutiqueCmd.validated': '已确认',
    'boutiqueCmd.notesMessages': '备注/消息',
    'boutiqueCmd.notesModalTitle': '备注与消息 - 订单 {{ref}}',
    'boutiqueCmd.clientLabel': '客户：',
    'boutiqueCmd.phoneLabel': '电话：',
    'boutiqueCmd.deliveryAddressLabel': '配送地址：',
    'boutiqueCmd.notSpecified': '未指定',
    'boutiqueCmd.exchangeHistory': '往来记录',
    'boutiqueCmd.noNote': '此订单暂无备注',
    'boutiqueCmd.staff': '👤 员工',
    'boutiqueCmd.client': '👥 客户',
    'boutiqueCmd.clientResponse': '客户回复：',
    'boutiqueCmd.sendMessageTitle': '✉️ 向客户发送消息',
    'boutiqueCmd.notePlaceholder': '例如：您好，能否确认您的配送地址？谢谢。',
    'boutiqueCmd.noteHint': '💡 客户将收到此消息，并可在其客户中心回复',
    'boutiqueCmd.close': '关闭',
    'boutiqueCmd.sending': '发送中...',
    'boutiqueCmd.sendToClient': '发送给客户',
    'boutiqueCmd.trackingNumber': '物流单号',
    'boutiqueCmd.orderShortLabel': '订单：',
    'boutiqueCmd.clientShortLabel': '客户：',
    'boutiqueCmd.trackingPlaceholder': '例如：LA123456789FR',
    'boutiqueCmd.trackingHint': '客户将在其客户中心看到此单号',
    'boutiqueCmd.cancel': '取消',
    'boutiqueCmd.saving': '保存中...',
    'boutiqueCmd.save': '保存',
    'blogAdmin.confirmDelete': '删除这篇文章？',
    'blogAdmin.pageTitle': '博客与 SEO 文章',
    'blogAdmin.pageSubtitle': '发布文章并管理博客内容',
    'blogAdmin.viewBlog': '查看博客',
    'blogAdmin.newArticle': '新文章',
    'blogAdmin.tabArticles': '文章',
    'blogAdmin.tabContent': '页面内容',
    'blogAdmin.editArticle': '编辑文章',
    'blogAdmin.fieldTitle': '标题 *',
    'blogAdmin.titlePlaceholder': '例如：卡宴 iPhone 屏幕维修：价格与工期',
    'blogAdmin.fieldExcerpt': '摘要（预览）',
    'blogAdmin.excerptPlaceholder': '用于列表的简短描述...',
    'blogAdmin.fieldContent': '内容 *（支持 Markdown）',
    'blogAdmin.contentPlaceholder': '在此撰写您的文章...',
    'blogAdmin.fieldTags': '标签（用逗号分隔）',
    'blogAdmin.tagsPlaceholder': '维修, iphone, cayenne',
    'blogAdmin.fieldMeta': 'SEO 元描述',
    'blogAdmin.metaPlaceholder': '用于 Google 的描述（最多 160 个字符）',
    'blogAdmin.publishNow': '立即发布',
    'blogAdmin.update': '更新',
    'blogAdmin.save': '保存',
    'blogAdmin.loading': '加载中...',
    'blogAdmin.noArticles': '暂无文章',
    'blogAdmin.noArticlesHint': '创建您的第一篇文章以提升 SEO',
    'blogAdmin.statusPublished': '已发布',
    'blogAdmin.statusDraft': '草稿',
    'blogAdmin.byAuthor': '作者：{{author}}',
    'blogAdmin.unpublish': '取消发布',
    'blogAdmin.publish': '发布',
    'blogAdmin.loadingContent': '正在加载内容...',
    'blogAdmin.contentNotice1': '在此编辑公开页面 ',
    'blogAdmin.contentNotice2': ' 上显示的内容。修改将立即生效。',
    'blogAdmin.blogHeader': '博客页眉',
    'blogAdmin.mainTitle': '主标题',
    'blogAdmin.accentWord': '彩色词（强调）',
    'blogAdmin.description': '描述',
    'blogAdmin.ctaSection': '行动号召（文章中的 CTA）',
    'blogAdmin.ctaTitle': 'CTA 标题',
    'blogAdmin.ctaDescription': 'CTA 描述',
    'blogAdmin.footerSection': '页脚',
    'blogAdmin.footerText': '页脚文字',
    'blogAdmin.hidePreview': '隐藏预览',
    'blogAdmin.livePreview': '实时预览',
    'blogAdmin.savedSuccess': '保存成功！',
    'blogAdmin.saving': '正在保存...',
    'blogAdmin.saveContent': '保存内容',
    'blogAdmin.previewLabel': '博客页面预览',
    'businessCard.title': '名片',
    'businessCard.subtitle': '模板、编辑与 A4 打印（10 张名片）',
    'businessCard.previewBtn': '预览',
    'businessCard.edit': '编辑',
    'businessCard.printA4': '打印 A4（10 张名片）',
    'businessCard.chooseTemplate': '选择模板（{{count}} 个可用）',
    'businessCard.tplName.classic': '经典',
    'businessCard.tplName.modern': '现代',
    'businessCard.tplName.gradient': '渐变',
    'businessCard.tplName.minimal': '极简',
    'businessCard.tplName.gold': '黄金尊享',
    'businessCard.tplName.ocean': '海洋',
    'businessCard.tplName.forest': '森林',
    'businessCard.tplName.sunset': '日落',
    'businessCard.tplName.corporate': '企业',
    'businessCard.tplName.pastel': '粉彩玫瑰',
    'businessCard.tplDesc.classic': '简约专业',
    'businessCard.tplDesc.modern': '简洁青色点缀',
    'businessCard.tplDesc.gradient': '鲜艳渐变背景',
    'businessCard.tplDesc.minimal': '洁白清晰',
    'businessCard.tplDesc.gold': '奢华黑金',
    'businessCard.tplDesc.ocean': '深邃舒缓的蓝',
    'businessCard.tplDesc.forest': '优雅自然绿',
    'businessCard.tplDesc.sunset': '温暖橙色',
    'businessCard.tplDesc.corporate': '专业藏蓝',
    'businessCard.tplDesc.pastel': '柔和女性化',
    'businessCard.logoTransparent': '透明背景的标志',
    'businessCard.cardInfo': '名片信息',
    'businessCard.field.companyName': '公司名称',
    'businessCard.field.subtitle': '副标题 / 业务',
    'businessCard.field.ownerName': '负责人姓名',
    'businessCard.field.ownerTitle': '职衔 / 职务',
    'businessCard.field.phone': '电话',
    'businessCard.field.email': '电子邮箱',
    'businessCard.field.address': '地址',
    'businessCard.field.city': '城市 / 邮编',
    'businessCard.field.website': '网站',
    'businessCard.field.siret': 'SIRET',
    'businessCard.reset': '重置',
    'businessCard.previewTitle': '预览 — {{name}}',
    'businessCard.viewFront': '查看正面',
    'businessCard.viewBack': '查看背面',
    'businessCard.standardFormat': '标准尺寸：85 x 55 毫米',
    'businessCard.allTemplates': '所有模板',
    'businessCard.printTitle': '名片',
    'businessCard.recto': '正面',
    'businessCard.verso': '背面',
    'hub.title': '工作台',
    'hub.refresh': '刷新',
    'hub.kpiTicketsOpen': '{{n}} 个待处理工单',
    'hub.kpiFacturesToday': '今日 {{n}} 张发票（{{total}}）',
    'hub.kpiDevisOpen': '{{n}} 个未结报价',
    'hub.magasinDefaultName': '店铺 1',
    'hub.magasinBadgeTitle': '当前店铺（POS）— {{name}}',
    'hub.counterViewDetailed': '详细视图',
    'hub.counterViewCompact': '紧凑视图',
    'hub.counterMagasinTitle': '{{name}} — {{tickets}} 工单 · {{devis}} 报价 · {{total}}',
    'hub.counterCompact': '{{tickets}}单·{{devis}}报·{{total}}',
    'hub.counterTickets': '工单',
    'hub.counterDevis': '报价',
    'hub.counterPerDay': '€/天',
    'hub.searchPlaceholder': '搜索编号（REM0143、POS-...、DEV-00002）、客户或电话…',
    'hub.filterAll': '全部',
    'hub.filterToday': '今天',
    'hub.filterOverdue': '逾期',
    'hub.filterPaid': '已付款',
    'hub.filterUnpaid': '未付款',
    'hub.columnReparations': '维修',
    'hub.columnFactures': '发票',
    'hub.columnDevis': '报价单',
    'hub.seeAll': '查看全部',
    'hub.empty': '没有项目',
    'hub.actionView': '查看',
    'hub.actionPrint': '打印',
    'hub.actionMail': '通过电子邮件发送',
    'hub.actionMarkReady': '标记为就绪',
    'hub.walkinClient': '临时客户',
    'hub.invoicedAs': '→ 已开票：{{ref}}',
    'hub.errorPrint': '打印时出错',
    'hub.errorPopupBlocked': '请允许弹出窗口以进行打印。',
    'hub.statusWaiting': '等待中',
    'hub.statusInProgress': '进行中',
    'hub.statusReady': '就绪',
    'hub.statusDelivered': '已交付',
    'hub.statusPaid': '已付款',
    'hub.statusInvoiced': '已开票',
    'hub.statusSent': '已发送',
    'hub.statusAccepted': '已接受',
    'hub.statusCancelled': '已取消',
    'hub.statusDone': '已完成',
    'subscription.title': '我的订阅',
    'subscription.subtitle': '管理您的套餐和账单',
    'subscription.currentPlan': '当前套餐',
    'subscription.status': '状态',
    'subscription.statusActive': '有效',
    'subscription.statusTrial': '免费试用',
    'subscription.monthlyPrice': '月费',
    'subscription.perMonth': '/月',
    'subscription.nextBilling': '下次付款',
    'subscription.changePlan': '更改套餐',
    'subscription.redirecting': '正在跳转...',
    'subscription.upgrade': '升级',
    'subscription.downgrade': '降级',
    'subscription.upgradeTitle': '套餐升级',
    'subscription.downgradeTitle': '套餐降级',
    'subscription.newPlan': '新套餐',
    'subscription.newMonthlyPrice': '新月费',
    'subscription.upgradeDiffNow': '现在需支付的差额',
    'subscription.changeFee': '变更费用',
    'subscription.downgradeFeeNotice': '任何套餐降级均收取 {{amount}} 的固定费用。',
    'subscription.cancel': '取消',
    'subscription.confirmWithAmount': '确认（{{amount}}）',
    'subscription.toastChanged': '您的套餐已成功更改！',
    'subscription.toastCancelled': '套餐更改已取消。',
    'subscription.errorPreview': '预览时出错',
    'subscription.errorChange': '更改套餐时出错',
    'subscription.featStartRepairs': '维修管理',
    'subscription.featStartClients': '客户跟踪',
    'subscription.featStartQuotesInvoices': '报价与发票',
    'subscription.featStartOnePos': '1 个销售点',
    'subscription.featProAllStart': 'Start 套餐全部功能',
    'subscription.featProMultiUsers': '多用户',
    'subscription.featProAdvancedStats': '高级统计',
    'subscription.featProThreePos': '3 个销售点',
    'subscription.featProPrioritySupport': '优先支持',
    'subscription.featSuperAllPro': 'Pro 套餐全部功能',
    'subscription.featSuperUnlimitedPos': '无限销售点',
    'subscription.featSuperCustomApi': '定制 API',
    'subscription.featSuperDedicatedSupport': '24/7 专属支持',
    'subscription.featSuperWhiteLabel': '白标',
    'terms.title': '通用使用条款',
    'terms.edition': '2026年6月',
    'terms.introBefore': '本条款适用于',
    'terms.introMiddle': ' 网站、客户专区、客服聊天，以及由',
    'terms.introAfter': '（SASU，卡宴，法属圭亚那）提供的维修服务。',
    'terms.acceptIntro': '创建账户或通过（网站、聊天、WhatsApp）与我们联系，即表示您接受本条款以及我们的',
    'terms.privacyPolicy': '隐私政策',
    'terms.servicesTitle': '服务',
    'terms.servicesBody': '手机维修与销售、售后跟进、报价、启用时的在线支付，以及通过聊天或 WhatsApp Business 提供的支持。',
    'terms.pricingTitle': '价格',
    'terms.pricingBody': '所提供的报价和价格（门店、聊天、WhatsApp）仅供参考，须在销售点确认后方为最终价格。',
    'terms.dataTitle': '个人数据',
    'terms.dataBefore': '您的数据依据《通用数据保护条例》(GDPR) 进行处理。删除请求：',
    'terms.dataAfter': '或查看隐私政策中的“你的权利”部分。',
    'terms.contactTitle': '联系方式',
    'notifSettings.title': '推送通知',
    'notifSettings.intro': '门店发生重要事件时，立即在系统层面收到原生提醒（Windows / macOS / Android）。仅限 R.E.Mobiles 员工使用。',
    'notifSettings.statusUnsupported': '不支持（需要 iOS 16.4+）',
    'notifSettings.statusBlocked': '已阻止（权限被拒绝）',
    'notifSettings.statusEnabled': '已在此浏览器启用',
    'notifSettings.statusDisabled': '未启用',
    'notifSettings.activeCount': '{{count}} 个有效订阅',
    'notifSettings.enableBtn': '启用通知',
    'notifSettings.testBtn': '发送测试通知',
    'notifSettings.disableBtn': '停用',
    'notifSettings.iosHintPre': '在 iPhone 上，网页推送通知需要',
    'notifSettings.iosHintPost': '并将应用安装到主屏幕（PWA）。请更新你的 iPhone，然后重新安装应用。',
    'notifSettings.blockedHint': '权限被拒绝。请打开浏览器的网站设置，允许该域名的通知，然后刷新页面。',
    'notifSettings.categoriesTitle': '类别',
    'notifSettings.categoriesHint': '关闭你不想接收的内容。立即生效，仅针对此账户。',
    'notifSettings.catNewTicketLabel': '新维修工单',
    'notifSettings.catNewTicketDesc': '门店创建了一笔送修登记。',
    'notifSettings.catTicketReadyLabel': '工单已转为"就绪"',
    'notifSettings.catTicketReadyDesc': '技师将维修标记为就绪。记得通知客户。',
    'notifSettings.catNewInvoiceLabel': '新 POS 发票',
    'notifSettings.catNewInvoiceDesc': '刚完成一笔销售收款。',
    'notifSettings.catNewChatLabel': '聊天收到新消息',
    'notifSettings.catNewChatDesc': '来自员工、客户或 B2B 的私信。',
    'notifSettings.catDevisLabel': '报价已创建或已接受',
    'notifSettings.catDevisDesc': '生成了新报价，或客户点击了接受。',
    'notifSettings.accountLabel': '账户',
    'notifSettings.roleLabel': '角色',
    'notifSettings.totalSubsLabel': '订阅总数',
    'notifSettings.errPermDenied': '权限被拒绝。请在浏览器设置中启用通知。',
    'notifSettings.errPermNotGranted': '未授予权限。',
    'notifSettings.errVapidUnavailable': '服务器端 VAPID 密钥不可用。',
    'notifSettings.infoEnabled': '已在此浏览器启用通知。',
    'notifSettings.errEnableFailed': '启用失败。',
    'notifSettings.infoDisabled': '已在此浏览器停用通知。',
    'notifSettings.errDisableFailed': '停用失败。',
    'notifSettings.errPrefsUpdate': '更新偏好设置失败。',
    'notifSettings.infoTestSent': '已发送测试通知（{{sent}}/{{subs}}）。请查看你操作系统的通知中心。',
    'notifSettings.errNoneSent': '未发送任何通知。请确认此浏览器已启用通知。',
    'notifSettings.errTestFailed': '测试失败。',
    'guyarepairLogin.subscriberSpace': '订户专区',
    'guyarepairLogin.businessLoginTitle': '企业登录',
    'guyarepairLogin.businessLoginSubtitle': '登录您的 GUYAREPAIR 控制台',
    'guyarepairLogin.emailLabel': '电子邮箱',
    'guyarepairLogin.emailPlaceholder': 'you@email.com',
    'guyarepairLogin.passwordLabel': '密码',
    'guyarepairLogin.passwordPlaceholder': '您的密码',
    'guyarepairLogin.loggingIn': '登录中...',
    'guyarepairLogin.loginButton': '登录',
    'guyarepairLogin.twoFATitle': '双重验证 (2FA)',
    'guyarepairLogin.twoFASubtitle': '请输入身份验证器应用中的验证码',
    'guyarepairLogin.otpLabel': '6 位验证码',
    'guyarepairLogin.verifying': '验证中...',
    'guyarepairLogin.verifyButton': '验证',
    'guyarepairLogin.backToLogin': '返回登录',
    'guyarepairLogin.notSubscribedYet': '还不是订户？',
    'guyarepairLogin.freeTrial': '免费试用',
    'guyarepairLogin.secureConnection': '安全连接',
    'guyarepairLogin.guyarepairHome': 'GUYAREPAIR 首页',
    'guyarepairLogin.errInvalidCredentials': '凭据不正确',
    'guyarepairLogin.err2FAInvalid': '2FA 验证码无效',
    'analytics.period_today': '今天',
    'analytics.period_7d': '7 天',
    'analytics.period_30d': '30 天',
    'analytics.period_90d': '90 天',
    'analytics.period_365d': '1 年',
    'analytics.alert_suspicious_found': '检测到 {{count}} 个可疑 IP！',
    'analytics.alert_no_suspicious': '未检测到可疑 IP。',
    'analytics.page_title': '分析 — 访问',
    'analytics.page_subtitle': '追踪你所有站点的访问',
    'analytics.refresh': '刷新',
    'analytics.tab_dashboard': '仪表板',
    'analytics.tab_visits': '访问',
    'analytics.tab_blocked': '已封锁 IP',
    'analytics.tab_alerts': 'IP 警报',
    'analytics.all_sites': '所有站点',
    'analytics.kpi_total_visits': '总访问量',
    'analytics.kpi_unique_visitors': '独立访客',
    'analytics.kpi_active_sites': '活跃站点',
    'analytics.kpi_countries': '国家/地区',
    'analytics.visits_per_day': '每日访问量',
    'analytics.by_site': '按站点',
    'analytics.by_country': '按国家/地区',
    'analytics.top_pages': '访问最多的页面',
    'analytics.visits_per_hour': '每小时访问量',
    'analytics.empty_no_visits': '此时间段内没有记录任何访问',
    'analytics.empty_install_script': '必须在你的站点上安装跟踪脚本',
    'analytics.search_placeholder': '按 IP、页面、国家/地区搜索...',
    'analytics.col_date': '日期',
    'analytics.col_site': '站点',
    'analytics.col_page': '页面',
    'analytics.col_country_city': '国家/地区 / 城市',
    'analytics.col_screen': '屏幕',
    'analytics.col_action': '操作',
    'analytics.no_visits': '没有访问',
    'analytics.blocked_inline': '（已封锁）',
    'analytics.unblock': '解除封锁',
    'analytics.block': '封锁',
    'analytics.visits_count': '{{count}} 次访问',
    'analytics.blocked_ips_title': '已封锁的 IP 地址',
    'analytics.active_count': '{{count}} 个生效中',
    'analytics.col_status': '状态',
    'analytics.col_reason': '原因',
    'analytics.col_blocked_by': '封锁者',
    'analytics.no_blocked_ips': '没有已封锁的 IP',
    'analytics.status_blocked': '已封锁',
    'analytics.status_inactive': '未生效',
    'analytics.reblock': '重新封锁',
    'analytics.alert_config_title': '警报配置',
    'analytics.checking': '正在检查...',
    'analytics.check_now': '立即检查',
    'analytics.saving': '正在保存...',
    'analytics.save': '保存',
    'analytics.alerts_enabled': '已启用警报',
    'analytics.alerts_enabled_desc': '每 15 分钟监控可疑 IP',
    'analytics.threshold_label': '阈值（次/小时）',
    'analytics.alert_email_label': '警报邮箱',
    'analytics.autoblock': '自动封锁',
    'analytics.autoblock_desc': '自动封锁超过阈值的 IP',
    'analytics.alert_history_title': '警报历史',
    'analytics.alerts_count': '{{count}} 条警报',
    'analytics.no_alerts': '未触发任何警报',
    'analytics.col_visits_per_hour': '访问/小时',
    'analytics.col_sites': '站点',
    'analytics.col_autoblocked': '自动封锁',
    'analytics.col_email': '邮箱',
    'analytics.yes': '是',
    'analytics.no': '否',
    'analytics.sent': '已发送',
    'analytics.confirm_block_title': '封锁此 IP？',
    'analytics.confirm_block_ip_prefix': 'IP ',
    'analytics.confirm_block_ip_suffix': ' 将在所有站点上被封锁',
    'analytics.block_reason_placeholder': '封锁原因（可选）...',
    'analytics.cancel': '取消',
    'analytics.blocking': '正在封锁...',
    'analytics.confirm_block': '确认封锁',
    'guyarepairLanding.navTarifs': '价格',
    'guyarepairLanding.navAnnuaire': '目录',
    'guyarepairLanding.navMaReparation': '我的维修',
    'guyarepairLanding.navConnexion': '登录',
    'guyarepairLanding.navEssaiGratuit': '免费试用',
    'guyarepairLanding.heroBadge': 'SaaS 维修管理平台',
    'guyarepairLanding.heroTitleLine1': '管理您的维修工坊',
    'guyarepairLanding.heroTitleLine2': '如此',
    'guyarepairLanding.heroTitleHighlight': '简单',
    'guyarepairLanding.heroSubtitle': 'GUYAREPAIR 是维修工坊的一体化解决方案。POS 收银、维修跟踪、库存管理、开票和客户忠诚度——全部集成在一个平台中。',
    'guyarepairLanding.heroCtaStart': '免费开始',
    'guyarepairLanding.heroCtaPricing': '查看价格',
    'guyarepairLanding.repairLookupTitle': '查找我的维修',
    'guyarepairLanding.repairLookupSubtitle': '输入您的维修参考号以跟踪进度',
    'guyarepairLanding.repairLookupPlaceholder': '例如：TFX0001、MBR0012……',
    'guyarepairLanding.rechercher': '搜索',
    'guyarepairLanding.repairErrorDefault': '搜索时出错',
    'guyarepairLanding.repairFoundAt': '维修记录来自',
    'guyarepairLanding.statutTermine': '已完成',
    'guyarepairLanding.statutEnCours': '进行中',
    'guyarepairLanding.statutEnAttente': '等待中',
    'guyarepairLanding.labelReference': '参考号',
    'guyarepairLanding.labelAppareil': '设备',
    'guyarepairLanding.labelProbleme': '问题',
    'guyarepairLanding.voirPageDe': '查看 {{nom}} 的页面',
    'guyarepairLanding.directoryTitle': '找到您的维修商',
    'guyarepairLanding.directorySubtitle': '搜索 GUYAREPAIR 合作维修店',
    'guyarepairLanding.searchPlaceholder': '店铺名称、城市……',
    'guyarepairLanding.resultats': '{{count}} 个结果',
    'guyarepairLanding.featuresTitle': '您需要的一切',
    'guyarepairLanding.featuresSubtitle': '为您的工坊提供完整的工具套件',
    'guyarepairLanding.feature1Title': '维修管理',
    'guyarepairLanding.feature1Desc': '全程跟踪每次维修，从诊断到交付',
    'guyarepairLanding.feature2Title': '销售点 (POS)',
    'guyarepairLanding.feature2Desc': '收款、价格计算、集成的收银管理',
    'guyarepairLanding.feature3Title': '库存与盘点',
    'guyarepairLanding.feature3Desc': '库存变动、提醒、供应商和订单',
    'guyarepairLanding.feature4Title': '客户与忠诚度',
    'guyarepairLanding.feature4Desc': '客户数据库、带奖励的忠诚度计划',
    'guyarepairLanding.feature5Title': '报价与发票',
    'guyarepairLanding.feature5Desc': '快速创建报价、转换为发票、通过电子邮件发送',
    'guyarepairLanding.feature6Title': '多店铺',
    'guyarepairLanding.feature6Desc': '通过单一仪表板管理多家店铺',
    'guyarepairLanding.pricingTitle': '简单透明的价格',
    'guyarepairLanding.pricingSubtitle': '选择适合您业务的方案',
    'guyarepairLanding.popular': '热门',
    'guyarepairLanding.perMonth': '欧元/月',
    'guyarepairLanding.commencer': '开始',
    'guyarepairLanding.copyright': '© {{year}} REMCOMPANY. 保留所有权利。',
    'guyarepairLanding.trademarkNotice': 'GUYAREPAIR 是该服务的商业品牌。',
    'guyarepairLanding.passwordTooShort': '密码至少需要 6 个字符',
    'guyarepairLanding.registerErrorDefault': '注册时出错',
    'guyarepairLanding.registerSuccessTitle': '注册成功！',
    'guyarepairLanding.successAccountCreated': '您的账户已创建，并附带',
    'guyarepairLanding.successTrial': '5 天免费试用',
    'guyarepairLanding.successLoginHint': '登录以设置您的工作空间。欢迎邮件已发送。',
    'guyarepairLanding.seConnecter': '登录',
    'guyarepairLanding.createAccountTitle': '创建您的账户',
    'guyarepairLanding.planLine': '{{nom}} 方案 — {{prix}} 欧元/月',
    'guyarepairLanding.planLabel': '方案',
    'guyarepairLanding.companyNameLabel': '公司名称',
    'guyarepairLanding.contactNameLabel': '联系人姓名',
    'guyarepairLanding.phoneLabel': '电话',
    'guyarepairLanding.emailLabel': '电子邮箱',
    'guyarepairLanding.passwordLabel': '密码',
    'guyarepairLanding.cityLabel': '城市',
    'guyarepairLanding.addressLabel': '地址',
    'guyarepairLanding.directoryToggle': '显示在 GUYAREPAIR 公共目录中',
    'guyarepairLanding.creating': '创建中……',
    'guyarepairLanding.createMyAccount': '创建我的账户',
    'guyarepairLanding.alreadyRegistered': '已经注册？',
    'alertsConfig.saved': '提醒设置已保存',
    'alertsConfig.error': '错误',
    'alertsConfig.title': '自动提醒',
    'alertsConfig.subtitle': '为您的企业设置自动提醒。满足条件时，您将每天收到一封电子邮件。',
    'alertsConfig.emailAlertsLabel': '电子邮件提醒',
    'alertsConfig.emailAlertsDesc': '启用自动电子邮件提醒（待处理维修、缺货）',
    'alertsConfig.repairAlertsTitle': '待处理维修提醒',
    'alertsConfig.repairAlertsDesc': '当某项维修待处理超过 X 天时，您将收到一封电子邮件。',
    'alertsConfig.delayLabel': '延迟（天）',
    'alertsConfig.daysShort': '{{n}}天',
    'alertsConfig.stockAlertsTitle': '库存提醒',
    'alertsConfig.stockAlertsDesc': '当商品缺货或低于阈值时，您将收到一封电子邮件。',
    'alertsConfig.lowStockThresholdLabel': '低库存阈值',
    'alertsConfig.clientNotifLabel': '客户通知',
    'alertsConfig.clientNotifDesc': '当客户的维修状态发生变化时（已完成、进行中等）向其发送电子邮件。',
    'alertsConfig.emailSenderInfo': '电子邮件将从您配置的地址发送，或默认从 GUYAREPAIR 发送。',
    'alertsConfig.saving': '正在保存...',
    'alertsConfig.save': '保存',
    'companyAnalytics.title': '数据分析',
    'companyAnalytics.subtitle': '您企业绩效的概览',
    'companyAnalytics.loadError': '加载出错',
    'companyAnalytics.kpiRepairsToday': '今日维修',
    'companyAnalytics.kpiThisWeek': '本周 {{count}}',
    'companyAnalytics.kpiRevenueToday': '今日营收',
    'companyAnalytics.kpiThisMonthAmount': '本月 {{amount}}',
    'companyAnalytics.kpiClients': '客户',
    'companyAnalytics.kpiNewThisMonth': '本月新增 {{count}}',
    'companyAnalytics.kpiAvgTime': '平均时长',
    'companyAnalytics.daysShort': '{{count}}天',
    'companyAnalytics.kpiPerRepair': '每次维修',
    'companyAnalytics.statTotalRepairs': '维修总数',
    'companyAnalytics.statActive': '进行中',
    'companyAnalytics.statCompleted': '已完成',
    'companyAnalytics.statStockItems': '库存商品',
    'companyAnalytics.statOutOfStock': '缺货',
    'companyAnalytics.repairsByStore': '各门店进行中的维修',
    'companyAnalytics.repairsM1Explicit': '{{count}} 项明确的 M1 维修',
    'companyAnalytics.repairsLegacy': '{{count}} 项旧版维修（M2 之前）',
    'companyAnalytics.totalShown': '显示总计：{{count}}',
    'companyAnalytics.repairsM2': '{{count}} 项 M2 维修',
    'companyAnalytics.repairsTrend14Days': '维修（最近 14 天）',
    'companyAnalytics.statusDistribution': '状态分布',
    'companyAnalytics.noRepairs': '暂无维修',
    'companyAnalytics.revenue': '营收',
    'companyAnalytics.revToday': '今天',
    'companyAnalytics.revThisWeek': '本周',
    'companyAnalytics.revThisMonth': '本月',
    'companyAnalytics.revTotal': '总计',
    'companyAnalytics.statusPending': '等待中',
    'companyAnalytics.statusInProgress': '进行中',
    'companyAnalytics.statusCompleted': '已完成',
    'companyAnalytics.statusDelivered': '已交付',
    'companyAnalytics.statusCancelled': '已取消',
    'staffCommissions.title': '我的佣金',
    'staffCommissions.pdfDownloadError': '下载 PDF 时出错',
    'staffCommissions.downloadMonthSheet': '下载本月结算单：',
    'staffCommissions.generating': '正在生成…',
    'staffCommissions.downloadPdf': '下载 PDF',
    'staffCommissions.toReceive': '待收',
    'staffCommissions.alreadyReceived': '已收',
    'staffCommissions.totalCumulative': '累计总额',
    'staffCommissions.detailByType': '按类型明细',
    'staffCommissions.toPay': '应付：{{amount}}',
    'staffCommissions.paidDetail': '已付：{{amount}}',
    'staffCommissions.noCommissionYet': '暂无佣金',
    'staffCommissions.filterAll': '全部',
    'staffCommissions.filterPending': '应付',
    'staffCommissions.filterPaid': '已付',
    'staffCommissions.filterCancelled': '已取消',
    'staffCommissions.colDate': '日期',
    'staffCommissions.colType': '类型',
    'staffCommissions.colTransaction': '交易',
    'staffCommissions.colAmountTtc': '含税金额',
    'staffCommissions.colCommission': '佣金',
    'staffCommissions.colStatus': '状态',
    'staffCommissions.noCommission': '无佣金',
    'staffCommissions.month1': '一月',
    'staffCommissions.month2': '二月',
    'staffCommissions.month3': '三月',
    'staffCommissions.month4': '四月',
    'staffCommissions.month5': '五月',
    'staffCommissions.month6': '六月',
    'staffCommissions.month7': '七月',
    'staffCommissions.month8': '八月',
    'staffCommissions.month9': '九月',
    'staffCommissions.month10': '十月',
    'staffCommissions.month11': '十一月',
    'staffCommissions.month12': '十二月',
    'staffCommissions.typeVentes': 'POS 销售',
    'staffCommissions.typeCommandes': '订单',
    'staffCommissions.typeAcomptes': '定金',
    'staffCommissions.typeReparations': '维修',
    'staffCommissions.typeFactures': '发票',
    'staffCommissions.typeDevis': '报价',
    'staffCommissions.typeB2b': 'B2B',
    'staffCommissions.typeDeplacement': '上门服务',
    'labelConfig.title': '标签配置',
    'labelConfig.subtitle': '根据您的打印机调整边距和尺寸',
    'labelConfig.reset': '默认值',
    'labelConfig.save': '保存',
    'labelConfig.saving': '保存中...',
    'labelConfig.saved': '已保存',
    'labelConfig.save_error': '保存错误：{{error}}',
    'labelConfig.global_dimensions': '总体尺寸',
    'labelConfig.label_width': '标签宽度',
    'labelConfig.label_height': '标签高度',
    'labelConfig.cols': '列数',
    'labelConfig.rows': '行数',
    'labelConfig.margins_spacing': '边距与间距',
    'labelConfig.left_margin': '左边距',
    'labelConfig.top_margin': '上边距',
    'labelConfig.h_spacing': '水平间距',
    'labelConfig.v_spacing': '垂直间距',
    'labelConfig.col_offset_title': '每列偏移',
    'labelConfig.cols_count': '（{{count}} 列）',
    'labelConfig.col_n': '第 {{n}} 列',
    'labelConfig.col_offset_hint': '正值 = 向右偏移。负值 = 向左偏移。',
    'labelConfig.row_offset_title': '每行偏移',
    'labelConfig.rows_count': '（{{count}} 行）',
    'labelConfig.row_n': '第 {{n}} 行',
    'labelConfig.row_offset_hint': '正值 = 向上偏移。负值 = 向下偏移。',
    'labelConfig.preview_title': 'A4 纸预览',
    'labelConfig.preview_count': '{{cols}} x {{rows}} = {{total}} 张标签/页',
    'labelConfig.preview_dims': '{{width}} x {{height}} 毫米',
    'paymentConfig.title': '支付配置',
    'paymentConfig.statusActiveTitle': '在线支付已启用',
    'paymentConfig.providerLabel': '服务商：{{name}}',
    'paymentConfig.statusInactiveTitle': '在线支付已停用',
    'paymentConfig.statusInactiveDesc': '配置服务商以接受在线支付。目前仅支持线下支付（现金、门店刷卡）。',
    'paymentConfig.chooseProvider': '选择您的支付服务商：',
    'paymentConfig.apiKeysTitle': '{{name}} API 密钥',
    'paymentConfig.savedPlaceholder': '已保存：{{value}}',
    'paymentConfig.save': '保存',
    'paymentConfig.testConnection': '测试连接',
    'paymentConfig.infoTitle': '重要信息',
    'paymentConfig.info1': '在线支付将直接存入您的商户账户。',
    'paymentConfig.info2': '您的 API 密钥经过加密并安全存储。',
    'paymentConfig.info3': '若未进行有效配置，则仅支持线下支付。',
    'paymentConfig.info4': '每家企业独立管理各自的密钥。',
    'paymentConfig.saveError': '保存出错',
    'paymentConfig.testError': '测试出错',
    'paymentConfig.disableConfirm': '停用在线支付？',
    'paymentConfig.stripeDesc': '银行卡支付、Apple Pay、Google Pay',
    'paymentConfig.sumupDesc': 'POS V2 刷卡终端 + 在线支付（merchant_code、client_id/secret）',
    'paymentConfig.fieldPublicKey': '公钥 (pk_...)',
    'paymentConfig.fieldSecretKey': '密钥 (sk_...)',
    'paymentConfig.fieldWebhookSecret': 'Webhook 密钥 (whsec_...)',
    'paymentConfig.fieldApiKey': 'API 密钥',
    'paymentConfig.fieldMerchantCode': '商户代码',
    'paymentConfig.fieldClientId': '客户端 ID (Client ID)',
    'paymentConfig.fieldClientSecret': '客户端密钥 (Client Secret)',
    'loyaltyAdmin.title': '忠诚度计划',
    'loyaltyAdmin.subtitle': '跟踪客户积分与奖励',
    'loyaltyAdmin.refresh': '刷新',
    'loyaltyAdmin.kpiMembers': '会员',
    'loyaltyAdmin.kpiPendingRewards': '待领取奖励',
    'loyaltyAdmin.kpiRedeemed': '已使用奖励',
    'loyaltyAdmin.kpiThreshold': '奖励门槛',
    'loyaltyAdmin.purchasesSuffix': '次购买',
    'loyaltyAdmin.rewardRule': '-{{pos}}% POS / -{{repair}}% 维修',
    'loyaltyAdmin.topClients': '最忠诚的客户',
    'loyaltyAdmin.clientFallback': '客户',
    'loyaltyAdmin.flashOffers': '限时优惠',
    'loyaltyAdmin.newOffer': '新建优惠',
    'loyaltyAdmin.createFlashOffer': '创建限时优惠',
    'loyaltyAdmin.offerTitlePlaceholder': '优惠标题（例如：Weekend Special）',
    'loyaltyAdmin.offerDescPlaceholder': '描述（例如：屏幕维修特价）',
    'loyaltyAdmin.discountLabel': '折扣（%）',
    'loyaltyAdmin.endDateLabel': '结束日期',
    'loyaltyAdmin.targetLevelsLabel': '目标等级',
    'loyaltyAdmin.creating': '创建中...',
    'loyaltyAdmin.createOffer': '创建优惠',
    'loyaltyAdmin.noOffers': '暂无限时优惠',
    'loyaltyAdmin.offerMeta': '目标等级：{{levels}} | 邮件：{{emails}}',
    'loyaltyAdmin.offerEnd': ' | 结束：{{date}}',
    'loyaltyAdmin.deactivate': '停用',
    'loyaltyAdmin.activate': '启用',
    'loyaltyAdmin.sendByEmail': '通过邮件发送',
    'loyaltyAdmin.delete': '删除',
    'loyaltyAdmin.allMembers': '所有会员（{{count}}）',
    'loyaltyAdmin.searchPlaceholder': '搜索...',
    'loyaltyAdmin.colClient': '客户',
    'loyaltyAdmin.colPhone': '电话',
    'loyaltyAdmin.colPurchases': '购买次数',
    'loyaltyAdmin.colPoints': '积分',
    'loyaltyAdmin.colTotalSpent': '消费总额',
    'loyaltyAdmin.colStatus': '状态',
    'loyaltyAdmin.colRewards': '奖励',
    'loyaltyAdmin.noMembers': '暂无会员',
    'loyaltyAdmin.rewardAvailable': '奖励可用',
    'loyaltyAdmin.purchasesRemaining': '还差 {{count}} 次购买',
    'loyaltyAdmin.pageOf': '第 {{page}} / {{total}} 页',
    'loyaltyAdmin.confirmDeleteOffer': '删除此优惠？',
    'loyaltyAdmin.emailsSent': '邮件已发送',
    'loyaltyAdmin.levelBronze': '青铜',
    'loyaltyAdmin.levelArgent': '白银',
    'loyaltyAdmin.levelOr': '黄金',
    'emailConfig.pageTitle': '邮件配置',
    'emailConfig.pageSubtitle': '配置 SMTP 服务器，用于通过邮件发送发票、报价单和通知。',
    'emailConfig.smtpSection': 'SMTP 服务器',
    'emailConfig.fieldHost': 'SMTP 主机',
    'emailConfig.fieldPort': '端口',
    'emailConfig.fieldUser': 'SMTP 用户（邮箱）',
    'emailConfig.fieldPassword': '邮箱密码',
    'emailConfig.passwordPlaceholderExisting': '••••••••（留空以保留原密码）',
    'emailConfig.passwordPlaceholderNew': 'Hostinger 邮箱密码',
    'emailConfig.useSsl': '使用 SSL/TLS（推荐用于 465 端口）',
    'emailConfig.enableEmails': '启用邮件发送',
    'emailConfig.tipTitle': 'Hostinger 提示：',
    'emailConfig.tipBody': '邮箱密码与 hPanel 密码不同。你可以在 hPanel → 邮箱 → 邮箱账户 → 管理 中查看或重置。',
    'emailConfig.senderSection': '发件人',
    'emailConfig.fieldSenderName': '发件人名称',
    'emailConfig.fieldSenderEmail': '发件人邮箱',
    'emailConfig.saving': '保存中…',
    'emailConfig.save': '保存',
    'emailConfig.testing': '发送中…',
    'emailConfig.testConnection': '测试连接',
    'emailConfig.disable': '停用',
    'emailConfig.loadError': '加载错误（HTTP {{status}}）',
    'emailConfig.saveSuccess': '配置已保存。现在可以点击「测试连接」。',
    'emailConfig.saveErrorFallback': '保存出错',
    'emailConfig.testSuccess': '测试邮件已发送。请查看收件箱。',
    'emailConfig.testErrorFallback': 'SMTP 测试失败。请检查 Hostinger 邮箱密码（与 hPanel 密码不同）。',
    'emailConfig.disableConfirm': '停用自定义配置吗？服务器将恢复为默认的 .env 配置。',
    'emailConfig.disableSuccess': '自定义配置已停用。',
    'emailConfig.disableErrorFallback': '停用时出错',
    'promosCalendar.title': '促销日历',
    'promosCalendar.subtitle': '按日安排的促销',
    'promosCalendar.empty': '本月没有安排促销。',
    'adminIntegrations.supplierCredentials': '供应商凭据 (Mobilax · Jens · LCD-Phone)',
    'adminIntegrations.generateStockPhotos': '生成库存照片 (AI) — M1 / M2',
    'adminIntegrations.stockCategoryAudit': '库存类别审计 — 手机 / IMEI / 配件',
    'printerTokens.title': '打印机代理令牌',
    'printerTokens.desc': '管理 Windows 代理用于向后端进行身份验证的令牌。每台设备一个令牌（推荐），或为小型安装使用共享令牌。',
    'printerTokens.newBtn': '新建令牌',
    'printerTokens.includeRevoked': '包含已吊销的令牌',
    'printerTokens.refresh': '刷新',
    'printerTokens.loading': '加载中…',
    'printerTokens.emptyPre': '暂无令牌。点击',
    'printerTokens.emptyPost': '以创建一个。',
    'printerTokens.colLabel': '标签',
    'printerTokens.colType': '类型',
    'printerTokens.colPreview': '预览',
    'printerTokens.colCreated': '创建时间',
    'printerTokens.colLastUsed': '最后使用',
    'printerTokens.colStatus': '状态',
    'printerTokens.colActions': '操作',
    'printerTokens.typeShared': '共享',
    'printerTokens.typePersonal': '个人',
    'printerTokens.createdBy': '由 {{user}}',
    'printerTokens.statusRevoked': '已吊销',
    'printerTokens.statusActive': '有效',
    'printerTokens.revoke': '吊销',
    'printerTokens.securityTitle': '安全',
    'printerTokens.securityHashPre': '令牌以哈希形式（SHA-256）存储。完整令牌在创建后',
    'printerTokens.securityHashEmph': '绝不会再次显示',
    'printerTokens.securityHashPost': '。如果忘记，请将其吊销并创建一个新令牌。',
    'printerTokens.securityAudit': '每次创建和吊销都会记录在管理员审计日志中。',
    'printerTokens.createTitle': '新建代理令牌',
    'printerTokens.createLabelField': '标签（例如：收银台电脑、Carlos 的笔记本）',
    'printerTokens.createLabelPlaceholder': '收银台电脑',
    'printerTokens.createSharedLabel': '共享令牌（可供多台设备使用）',
    'printerTokens.createSharedHint': '同一时间只能有一个共享令牌处于有效状态。为安全起见，建议每台设备使用一个令牌。',
    'printerTokens.cancel': '取消',
    'printerTokens.create': '创建',
    'printerTokens.revealTitle': '令牌已创建 — 请立即复制',
    'printerTokens.revealLabelPrefix': '标签：',
    'printerTokens.revealConfigPre': '请在请求头',
    'printerTokens.revealConfigPost': '中使用此令牌配置你的 Windows 代理。',
    'printerTokens.copied': '已复制',
    'printerTokens.copy': '复制',
    'printerTokens.revealClose': '我已保存令牌',
    'printerTokens.revokeTitle': '吊销此令牌？',
    'printerTokens.revokeMsgPre': '令牌',
    'printerTokens.revokeMsgPost': '将无法再对任何代理进行身份验证。此操作会记录在日志中，且不会删除令牌（你可以通过勾选“包含已吊销的令牌”来显示它）。',
    'printerTokens.actionError': '错误：{{detail}}',
    'servicePrices.pageTitle': '维修价格',
    'servicePrices.pageSubtitle': '管理价格和公开页面内容',
    'servicePrices.viewPublicPage': '查看公开页面',
    'servicePrices.add': '添加',
    'servicePrices.tabPrices': '价格',
    'servicePrices.tabContent': '页面内容',
    'servicePrices.editPriceTitle': '编辑价格',
    'servicePrices.newPriceTitle': '新增价格',
    'servicePrices.brand': '品牌 *',
    'servicePrices.choose': '请选择...',
    'servicePrices.model': '型号',
    'servicePrices.modelPlaceholder': '例如：iPhone 14 Pro',
    'servicePrices.repairType': '维修类型 *',
    'servicePrices.delay': '时长',
    'servicePrices.delayPlaceholder': '例如：30 分钟',
    'servicePrices.priceMin': '最低价 (EUR)',
    'servicePrices.priceMax': '最高价 (EUR)',
    'servicePrices.order': '排序',
    'servicePrices.visiblePublic': '公开可见',
    'servicePrices.btnUpdate': '修改',
    'servicePrices.btnSave': '保存',
    'servicePrices.loading': '加载中...',
    'servicePrices.noPrices': '暂无已保存的价格',
    'servicePrices.noPricesHint': '添加您的第一批价格，将其显示在公开页面上',
    'servicePrices.colRepair': '维修',
    'servicePrices.colPrice': '价格',
    'servicePrices.colVisible': '可见',
    'servicePrices.colActions': '操作',
    'servicePrices.allModels': '所有型号',
    'servicePrices.contentLoading': '正在加载内容...',
    'servicePrices.contentBannerPre': '在此修改公开页面',
    'servicePrices.contentBannerPost': '上显示的内容。保存后修改将立即生效。',
    'servicePrices.headerSection': '页面头部',
    'servicePrices.mainTitle': '主标题',
    'servicePrices.accentWord': '彩色强调词',
    'servicePrices.seoDescription': 'SEO 描述',
    'servicePrices.contactInfo': '联系信息',
    'servicePrices.phone': '电话',
    'servicePrices.phoneDisplay': '显示的电话',
    'servicePrices.whatsappLabel': 'WhatsApp（含国家代码）',
    'servicePrices.address': '地址',
    'servicePrices.hours': '营业时间',
    'servicePrices.trustBadges': '信任标识',
    'servicePrices.addShort': '+ 添加',
    'servicePrices.titleField': '标题',
    'servicePrices.description': '描述',
    'servicePrices.faqTitle': '常见问题 (FAQ)',
    'servicePrices.question': '问题',
    'servicePrices.answer': '答案',
    'servicePrices.ctaSection': '行动号召区块 (CTA)',
    'servicePrices.ctaTitle': 'CTA 标题',
    'servicePrices.ctaDescription': 'CTA 描述',
    'servicePrices.footer': '页脚',
    'servicePrices.line1': '第 1 行',
    'servicePrices.line2': '第 2 行',
    'servicePrices.hidePreview': '隐藏预览',
    'servicePrices.livePreview': '实时预览',
    'servicePrices.savedSuccess': '保存成功！',
    'servicePrices.saving': '保存中...',
    'servicePrices.saveContent': '保存内容',
    'servicePrices.previewLabel': '公开页面预览',
    'servicePrices.faqShort': '常见问题',
    'servicePrices.confirmDelete': '删除此价格？',
    'servicePrices.repairTypes.ecran': '屏幕',
    'servicePrices.repairTypes.batterie': '电池',
    'servicePrices.repairTypes.connecteurCharge': '充电接口',
    'servicePrices.repairTypes.cameraArriere': '后置摄像头',
    'servicePrices.repairTypes.cameraAvant': '前置摄像头',
    'servicePrices.repairTypes.hautParleur': '扬声器',
    'servicePrices.repairTypes.micro': '麦克风',
    'servicePrices.repairTypes.boutonPower': '电源键',
    'servicePrices.repairTypes.boutonVolume': '音量键',
    'servicePrices.repairTypes.vitreArriere': '后盖玻璃',
    'servicePrices.repairTypes.nappeFaceId': 'Face ID 排线',
    'servicePrices.repairTypes.carteMere': '主板',
    'servicePrices.repairTypes.diagnostique': '检测',
    'servicePrices.repairTypes.desoxydation': '除氧化清洁',
    'servicePrices.repairTypes.autre': '其他',
    'companySettings.toast.loadError': '加载设置时出错',
    'companySettings.toast.saveSuccess': '设置保存成功',
    'companySettings.toast.saveError': '保存时出错',
    'companySettings.toast.notImage': '文件必须是图片',
    'companySettings.toast.tooLarge': '文件不得超过 5 MB',
    'companySettings.toast.logoSuccess': '徽标更新成功',
    'companySettings.toast.logoError': '上传徽标时出错',
    'companySettings.toast.previewError': '生成预览时出错',
    'companySettings.tabs.info': '信息',
    'companySettings.tabs.documents': '文档（发票、报价单、采购订单）',
    'companySettings.tabs.payment': '支付',
    'companySettings.tabs.logo': '徽标',
    'companySettings.tabs.preview': 'PDF 预览',
    'companySettings.tabs.security': '安全',
    'companySettings.title': '公司设置',
    'companySettings.subtitle': '配置您的公司信息和文档',
    'companySettings.save': '保存',
    'companySettings.info.sectionTitle': '公司信息',
    'companySettings.info.companyNameLabel': '公司名称',
    'companySettings.info.companyNamePlaceholder': '例如：我的公司有限公司',
    'companySettings.info.legalFormLabel': '法律形式',
    'companySettings.info.legalFormPlaceholder': '例如：股份公司、有限责任公司、个体工商户……',
    'companySettings.info.capitalLabel': '注册资本',
    'companySettings.info.capitalPlaceholder': '例如：1 000 欧元',
    'companySettings.info.siretLabel': 'SIRET',
    'companySettings.info.siretPlaceholder': '例如：123 456 789 00014',
    'companySettings.info.rcsLabel': 'RCS',
    'companySettings.info.rcsPlaceholder': '例如：Paris B 123 456 789',
    'companySettings.info.phoneLabel': '电话',
    'companySettings.info.phonePlaceholder': '例如：+594 694 XX XX XX',
    'companySettings.info.emailLabel': '电子邮箱',
    'companySettings.info.emailPlaceholder': '例如：contact@mycompany.com',
    'companySettings.info.postalLabel': '邮政编码',
    'companySettings.info.postalPlaceholder': '例如：97300',
    'companySettings.info.addressLabel': '地址',
    'companySettings.info.addressPlaceholder': '例如：主街 10 号',
    'companySettings.info.cityLabel': '城市',
    'companySettings.info.cityPlaceholder': '例如：卡宴',
    'companySettings.info.tvaLabel': '增值税说明',
    'companySettings.info.tvaPlaceholder': '文档上的税务说明',
    'companySettings.documents.devisSectionTitle': '报价单设置',
    'companySettings.documents.devisValidityLabel': '报价单有效期',
    'companySettings.documents.devisValidityPlaceholder': '报价单的有效期限',
    'companySettings.documents.devisConditionsLabel': '一般条款（报价单）',
    'companySettings.documents.devisConditionsPlaceholder': '显示在报价单上的一般条款',
    'companySettings.documents.bcSectionTitle': '采购订单设置',
    'companySettings.documents.bcConditionsLabel': '采购订单条款',
    'companySettings.documents.bcConditionsPlaceholder': '服务执行条款',
    'companySettings.documents.factureSectionTitle': '发票设置',
    'companySettings.documents.facturePaymentLabel': '付款条款',
    'companySettings.documents.facturePaymentPlaceholder': '例如：收到时付款……',
    'companySettings.documents.facturePenaltiesLabel': '逾期罚金',
    'companySettings.documents.facturePenaltiesPlaceholder': '逾期罚金条款',
    'companySettings.documents.factureRecoveryLabel': '催收赔偿金',
    'companySettings.documents.factureRecoveryPlaceholder': '固定赔偿金条款',
    'companySettings.documents.factureReserveLabel': '所有权保留',
    'companySettings.documents.factureReservePlaceholder': '所有权保留条款',
    'companySettings.documents.warrantySectionTitle': '保修',
    'companySettings.documents.warrantyLabel': '保修说明',
    'companySettings.documents.warrantyPlaceholder': '例如：自维修之日起，零件和工时享受 6 个月保修。',
    'companySettings.documents.warrantyHint': '如果填写，此说明将显示在发票底部。',
    'companySettings.payment.sectionTitle': '在线支付',
    'companySettings.payment.disableTitle': '禁用在线支付',
    'companySettings.payment.disableDesc': '启用后，所有报价单上的在线支付选项（Stripe）将被隐藏。客户只能请求 SumUp 付款链接。',
    'companySettings.payment.statusDisabled': '在线支付已禁用 - 客户将只看到 SumUp 请求表单',
    'companySettings.payment.statusEnabled': '在线支付已启用 - 客户可以直接在线支付',
    'companySettings.payment.howTitle': '它是如何运作的？',
    'companySettings.payment.step1': '1. 客户通过电子邮件收到报价单并接受',
    'companySettings.payment.step2': '2. 客户不在线支付，而是填写包含其电子邮箱/电话的表单',
    'companySettings.payment.step3': '3. 您会收到包含付款请求的通知',
    'companySettings.payment.step4': '4. 您手动将 SumUp 付款链接发送给客户',
    'companySettings.logo.sectionTitle': '公司徽标',
    'companySettings.logo.description': '此徽标将显示在您的发票、报价单和采购订单上（PNG、JPG 格式，最大 5 MB）。',
    'companySettings.logo.alt': '徽标',
    'companySettings.logo.none': '无徽标',
    'companySettings.logo.uploading': '正在上传……',
    'companySettings.logo.choose': '选择徽标',
    'companySettings.logo.hint': '徽标将在 PDF 文档中自动调整大小。',
    'companySettings.preview.sectionTitle': '您的文档预览',
    'companySettings.preview.description': '使用您当前的设置（徽标、信息、法律声明）查看示例发票或报价单。',
    'companySettings.preview.saveReminder': '请记得在生成预览前保存您的更改。',
    'companySettings.preview.facture': '发票',
    'companySettings.preview.devis': '报价单',
    'companySettings.preview.generating': '正在生成……',
    'companySettings.preview.generate': '生成预览',
    'companySettings.preview.iframeTitle': 'PDF 预览',
    'companySettings.security.genericError': '错误',
    'companySettings.security.invalidCode': '验证码无效',
    'companySettings.security.enabledToast': '双重验证已成功启用！',
    'companySettings.security.disabledToast': '双重验证已禁用',
    'companySettings.security.sectionTitle': '账户安全',
    'companySettings.security.twoFaTitle': '双重验证（2FA）',
    'companySettings.security.statusActive': '已启用',
    'companySettings.security.statusInactive': '已禁用',
    'companySettings.security.intro': '使用两步验证保护您的账户。每次登录时，除密码外还需输入一个 6 位验证码。',
    'companySettings.security.configureBtn': '设置双重验证',
    'companySettings.security.step1ScanPrefix': '1. 使用',
    'companySettings.security.step1ScanSuffix': ' 扫描此二维码：',
    'companySettings.security.qrAlt': '2FA 二维码',
    'companySettings.security.manualKeyLabel': '或手动输入此密钥：',
    'companySettings.security.step2Enter': '2. 输入应用中显示的验证码：',
    'companySettings.security.activate': '启用',
    'companySettings.security.protectedMsg': '您的账户受双重验证保护',
    'companySettings.security.disablePrompt': '要禁用，请输入您当前的验证码：',
    'companySettings.security.disable': '禁用',
    'docTimezone.title': '文档时间',
    'docTimezone.intro': '配置文档（小票、发票、报价单、采购订单）上日期和时间所用的时区。',
    'docTimezone.sectionTimezone': '时区',
    'docTimezone.selectLabel': '选择您的时区',
    'docTimezone.currentLabel': '当前时区：',
    'docTimezone.selectHint': '此时区将应用于文档上显示的所有日期。小票的记录时间一经保存将永不更改。',
    'docTimezone.save': '保存',
    'docTimezone.importantTitle': '重要',
    'docTimezone.importantBody': '默认情况下，所有文档均使用法属圭亚那时区（卡宴，UTC-3）。如果您更改此设置，未来的文档将使用新时区。已创建的文档将保留其原始记录时间。',
    'docTimezone.toastUpdated': '时区已更新',
    'docTimezone.errUpdate': '更新时出错',
    'docTimezone.errNetwork': '网络错误',
    'docTimezone.tzCayenne': '法属圭亚那（卡宴）',
    'docTimezone.tzMartinique': '马提尼克 / 瓜德罗普',
    'docTimezone.tzGuadeloupe': '瓜德罗普',
    'docTimezone.tzParis': '法国本土（巴黎）',
    'docTimezone.tzReunion': '留尼汪',
    'docTimezone.tzNoumea': '新喀里多尼亚',
    'docTimezone.tzTahiti': '法属波利尼西亚（大溪地）',
    'flashOffers.confirmDelete': '删除此优惠？',
    'flashOffers.emailsSentFallback': '邮件已发送',
    'flashOffers.pageTitle': '限时优惠和促销',
    'flashOffers.pageSubtitle': '管理您的限时促销并发送给忠实客户',
    'flashOffers.newOffer': '新建优惠',
    'flashOffers.createTitle': '创建限时优惠',
    'flashOffers.labelTitle': '标题 *',
    'flashOffers.placeholderTitle': '例如：周末特惠',
    'flashOffers.labelDiscount': '折扣 (%)',
    'flashOffers.labelDescription': '描述',
    'flashOffers.placeholderDescription': '例如：屏幕维修优惠价',
    'flashOffers.labelEndDate': '结束日期',
    'flashOffers.labelTargetLevels': '目标等级',
    'flashOffers.levelBronze': '铜牌',
    'flashOffers.levelSilver': '银牌',
    'flashOffers.levelGold': '金牌',
    'flashOffers.creating': '创建中...',
    'flashOffers.createOffer': '创建优惠',
    'flashOffers.emptyTitle': '尚未创建任何限时优惠',
    'flashOffers.emptyHint': '点击“{{btn}}”开始',
    'flashOffers.badgeExpired': '已过期',
    'flashOffers.badgeDisabled': '已停用',
    'flashOffers.endLabel': '结束：{{date}}',
    'flashOffers.emailsCount': '邮件：{{count}}',
    'flashOffers.lastSent': '最后发送：{{date}}',
    'flashOffers.deactivate': '停用',
    'flashOffers.activate': '启用',
    'flashOffers.sendByEmail': '通过邮件发送',
    'flashOffers.delete': '删除',
    'mailsAi.oauthDenied': 'Google 授权被拒绝。',
    'mailsAi.sessionExpired': '会话已过期，请重试。',
    'mailsAi.tokenExchangeFailed': 'Google 连接错误，请重试。',
    'mailsAi.missingParams': '缺少参数。',
    'mailsAi.googleConnectError': 'Google 连接错误。',
    'mailsAi.errorWith': '错误：{{msg}}',
    'mailsAi.aiAnalysisError': 'AI 分析错误：{{msg}}',
    'mailsAi.confirmDeleteAccount': '删除此电子邮箱账户及其所有已存储的邮件？',
    'mailsAi.confirmRefetch': '这将删除所有缓存的邮件并以完整的 HTML 渲染重新下载。是否继续？',
    'mailsAi.confirmBulkAnalyze': '分析 {{count}} 封未分析的邮件？（将消耗 AI 额度）',
    'mailsAi.fetchAnalyzedHeader': '已获取并分析 {{count}} 封新邮件。',
    'mailsAi.alertsDetected': '检测到 {{count}} 条警报：',
    'mailsAi.fetchAnalyzedNoThreat': '已自动获取并分析 {{count}} 封新邮件。未检测到威胁。',
    'mailsAi.fetchRetrieved': '已获取 {{count}} 封新邮件。',
    'mailsAi.noNewEmail': '没有新邮件。',
    'mailsAi.refetchDone': '重新同步完成！已获取 {{count}} 封带 HTML 渲染的邮件。',
    'mailsAi.allVisibleAnalyzed': '所有可见邮件均已分析完毕！',
    'mailsAi.bulkAnalyzeDone': '分析完成！已分析 {{done}}/{{total}} 封邮件。',
    'mailsAi.emailSent': '邮件发送成功！',
    'mailsAi.subtitle': '智能管理您的商务邮件',
    'mailsAi.autoRefresh': '自动刷新',
    'mailsAi.refresh': '刷新',
    'mailsAi.analyzeAll': '全部分析',
    'mailsAi.compose': '新邮件',
    'mailsAi.addAccount': '添加账户',
    'mailsAi.loadingAccounts': '正在加载账户…',
    'mailsAi.noAccountTitle': '未连接任何电子邮箱账户',
    'mailsAi.noAccountDesc': '连接您的第一个电子邮箱账户以开始。',
    'mailsAi.fetchingAll': '正在获取所有邮件…',
    'mailsAi.fetchingAllHint': '这可能需要几分钟',
    'mailsAi.noEmail': '没有邮件。',
    'mailsAi.noSubject': '（无主题）',
    'mailsAi.prev': '上一页',
    'mailsAi.next': '下一页',
    'mailsAi.pageOf': '{{page}} / {{total}}',
    'sumupTerminal.title': 'SumUp 终端（刷卡终端）',
    'sumupTerminal.subtitle': '每家门店一台刷卡终端——M1 和 M2 相互独立。POS V2 使用所选门店的刷卡终端。',
    'sumupTerminal.hintM1': 'Resurrection Mobile 刷卡终端（SOLO）',
    'sumupTerminal.hintM2': '待第二台刷卡终端与 SumUp 配对后配置',
    'sumupTerminal.m2NotConfigured': 'M2 尚未配置——如果第二台刷卡终端还没配对，这很正常。配对后，请填写下方字段（独立的 SumUp M2 账户）。',
    'sumupTerminal.step1Lead': '在 SumUp Cloud → 终端 → 复制',
    'sumupTerminal.step1Merchant': '商户代码',
    'sumupTerminal.step1And': '和',
    'sumupTerminal.step1Reader': '读卡器 ID',
    'sumupTerminal.step2Lead': '粘贴',
    'sumupTerminal.step2Secret': '私密密钥',
    'sumupTerminal.step2Mid': '(sup_sk_…) —',
    'sumupTerminal.step2Public': '不是公开密钥 sup_pk_',
    'sumupTerminal.step3Lead': '点击',
    'sumupTerminal.step3Verify': '验证 API 密钥',
    'sumupTerminal.step3Rest': '→ 商户代码会自动填入',
    'sumupTerminal.step4Lead': '从列表中选择刷卡终端，然后',
    'sumupTerminal.step4Save': '保存',
    'sumupTerminal.labelName': '刷卡终端名称（可选）',
    'sumupTerminal.namePlaceholder': '例如：我的终端 M1',
    'sumupTerminal.labelApiKey': 'SumUp 私密 API 密钥（sup_sk_…）*',
    'sumupTerminal.savedKeyPlaceholder': '已保存：{{masked}}',
    'sumupTerminal.apiKeyHint': '仅限 sup_sk_ 私密密钥。SumUp 仅在创建时显示一次。',
    'sumupTerminal.verifyKeyBtn': '1. 验证 API 密钥',
    'sumupTerminal.keyConfirmed': '✓ 密钥已由 SumUp 确认',
    'sumupTerminal.labelMerchantCode': '商户代码 *',
    'sumupTerminal.labelReaderId': '读卡器 ID（reader）*',
    'sumupTerminal.discoverBtn': '查找我的刷卡终端',
    'sumupTerminal.readerFallback': 'SumUp 刷卡终端',
    'sumupTerminal.labelDeviceId': '设备标识符（可选）',
    'sumupTerminal.saveBtn': '保存 {{mag}}',
    'sumupTerminal.testBtn': '在刷卡终端上测试 {{amount}}',
    'sumupTerminal.checklistTitle': '刷卡终端检查清单',
    'sumupTerminal.checklistWifi': '终端已开机并连接到 Wi‑Fi',
    'sumupTerminal.checklistPaired': 'SumUp Cloud 中状态为「已配对」',
    'sumupTerminal.checklistSolo': 'Solo 软件 ≥ 3.3.24',
    'sumupTerminal.checklistBluetooth': '蓝牙和 API 不能同时工作——如果使用 POS，请关闭 SOLO 上的蓝牙',
    'sumupTerminal.checklistCancel': '如果金额显示后又自行取消：请在刷卡终端上重新连接 API（不是 POS 的故障）',
    'sumupTerminal.openCloud': '打开 SumUp Cloud',
    'sumupTerminal.errLoad': '无法加载配置',
    'sumupTerminal.msgMerchantChanged': '商户账户已更改——请验证 API 密钥，然后选择刷卡终端。',
    'sumupTerminal.errPasteSecret': '请先粘贴 SumUp 私密密钥（sup_sk_…），而不是公开密钥 sup_pk_。',
    'sumupTerminal.keyOkReaders': '密钥正常——账户 {{mc}} · 找到 {{count}} 台刷卡终端。',
    'sumupTerminal.keyOkNone': '密钥正常——账户 {{mc}} · SumUp Cloud 中没有已配对的刷卡终端。',
    'sumupTerminal.errKeyRejected': 'SumUp 拒绝了该 API 密钥',
    'sumupTerminal.msgNoReaders': '未找到刷卡终端——请确认终端已在 SumUp Cloud 中配对。',
    'sumupTerminal.errDiscover': '查找刷卡终端出错',
    'sumupTerminal.readerSelected': '已选择刷卡终端：{{name}}',
    'sumupTerminal.errMerchantChangeKey': '更换 SumUp 账户：保存前请输入新的 API 密钥（sup_sk_…）。',
    'sumupTerminal.errVerifyFirst': '请先点击「验证 API 密钥」——保存前 SumUp 必须确认该密钥。',
    'sumupTerminal.errReaderRequired': '需要读卡器 ID——请点击「查找我的刷卡终端」并选择终端。',
    'sumupTerminal.savedWithNotice': '已保存 {{mag}} 的配置。{{notice}}',
    'sumupTerminal.saved': '已保存 {{mag}} 的配置。',
    'sumupTerminal.errSave': '保存出错',
    'sumupTerminal.testOk': '测试通过——请查看刷卡终端',
    'sumupTerminal.errTest': '测试失败',
    'adminB2B.accessDenied': '访问被拒绝',
    'adminB2B.reservedAdmins': '仅限管理员。',
    'adminB2B.backToDashboard': '返回仪表板',
    'adminB2B.back': '返回',
    'adminB2B.title': 'B2B 客户',
    'adminB2B.accountsSingular': '已在 B2B 门户注册的企业 — {{count}} 个账户',
    'adminB2B.accountsPlural': '已在 B2B 门户注册的企业 — {{count}} 个账户',
    'adminB2B.colCompany': '企业',
    'adminB2B.colManager': '负责人',
    'adminB2B.colEmail': '电子邮件',
    'adminB2B.colPhone': '电话',
    'adminB2B.colStatus': '状态',
    'adminB2B.colRegistered': '注册日期',
    'adminB2B.empty': '暂无 B2B 客户',
    'adminB2B.statusValide': '已通过',
    'adminB2B.statusEnAttente': '待处理',
    'adminB2B.statusRefuse': '已拒绝',
    'adminCache.statusCompleted': '已完成',
    'adminCache.statusRunning': '进行中...',
    'adminCache.statusUpdating': '更新中',
    'adminCache.statusError': '错误',
    'adminCache.never': '从未',
    'adminCache.title': '供应商数据',
    'adminCache.refreshing': '刷新中...',
    'adminCache.refreshData': '刷新数据',
    'adminCache.step1Title': '第 1 步 — 供应商登录凭据。',
    'adminCache.step1Intro': '在以下页面输入 Mobilax、JensMobiles 和 LCD-Phone 的邮箱和密码',
    'adminCache.step1LinkText': '供应商登录凭据',
    'adminCache.step1Outro': '然后返回此处并点击“{{action}}”以为 AI 自动报价提供数据。',
    'adminCache.configurePasswords': '设置密码',
    'adminCache.totalCached': '缓存中的产品总数',
    'adminCache.spareParts': '备件',
    'adminCache.accessories': '配件',
    'adminCache.phones': '手机',
    'adminCache.syncState': '同步状态',
    'adminCache.noSync': '尚未执行同步',
    'adminCache.exploreCache': '浏览缓存',
    'adminCache.searchPlaceholder': '搜索（例如：iPhone 14 保护壳、全新 Galaxy A06）...',
    'adminCache.allTypes': '所有类型',
    'adminCache.filterParts': '零件',
    'adminCache.filterAccessories': '配件',
    'adminCache.filterPhones': '手机',
    'adminCache.colType': '类型',
    'adminCache.colSupplier': '供应商',
    'adminCache.colPart': '零件',
    'adminCache.colBrand': '品牌',
    'adminCache.colPrice': '价格',
    'adminCache.colStock': '库存',
    'adminCache.colRef': '编号',
    'adminCache.catPart': '零件',
    'adminCache.catAccessory': '配件',
    'adminCache.catPhone': '手机',
    'adminCache.inStock': '有货',
    'adminCache.outOfStock': '缺货',
    'adminCache.noResults': '没有与“{{query}}”匹配的结果',
    'adminDownloads.artifactDesktopLabel': 'Windows 员工应用',
    'adminDownloads.artifactDesktopDesc': '分发给 Windows 用户的 ZIP 压缩包。',
    'adminDownloads.artifactPackLabel': '打印机代理包',
    'adminDownloads.artifactPackDesc': '用于重新构建打印代理的源码 ZIP 压缩包。',
    'adminDownloads.artifactExeLabel': 'Windows 代理',
    'adminDownloads.artifactExeDesc': '可直接在技术员工位上运行的可执行文件。',
    'adminDownloads.available': '可用',
    'adminDownloads.missing': '缺失',
    'adminDownloads.download': '下载',
    'adminDownloads.activeFile': '当前文件',
    'adminDownloads.size': '大小',
    'adminDownloads.lastUpdate': '最近更新',
    'adminDownloads.uploadedBy': '上传者',
    'adminDownloads.replaceLiveFile': '替换线上文件',
    'adminDownloads.uploading': '上传中...',
    'adminDownloads.replace': '替换',
    'adminDownloads.replaceHint': '所选文件将直接替换 remobiles.com 上提供给用户的文件。',
    'adminDownloads.selectedFile': '已选文件：{{name}}',
    'adminDownloads.loadError': '加载文件时出错',
    'adminDownloads.downloadLinkUnavailable': '下载链接不可用',
    'adminDownloads.downloadFailed': '无法下载',
    'adminDownloads.selectFilePrompt': '请为 {{label}} 选择一个文件。',
    'adminDownloads.confirmReplace': '现在用 {{name}} 替换 {{label}} 吗？',
    'adminDownloads.replaceSuccess': '{{label}} 已成功替换。',
    'adminDownloads.uploadError': '上传过程中出错',
    'adminDownloads.title': '安装程序和下载',
    'adminDownloads.subtitle': '直接下载 Windows 安装包，并为超级管理员提供线上替换。',
    'adminDownloads.printerConfig': '打印机配置',
    'adminDownloads.refresh': '刷新',
    'adminDownloads.availableArtifacts': '可用构件',
    'adminDownloads.totalSize': '总大小',
    'adminDownloads.alert': '提醒',
    'adminDownloads.alertText': '替换会覆盖线上文件。没有单独的删除操作。',
    'adminDownloads.accessTitle': '管理员和超级管理员访问权限',
    'adminDownloads.accessText': '此页面集中管理 remobiles.com 上可见的下载内容。文件的线上替换仅对超级管理员显示。',
    'adminDownloads.signedLinksNote': '下载链接仍由后端签名，以避免在浏览器端生成 blob。',
    'adminCachePurge.accessDenied': '仅限 Carlos 访问。',
    'adminCachePurge.title': '清除商业单据',
    'adminCachePurge.descIntro': '隐藏页面 — 仅限 Carlos。删除所选日期',
    'adminCachePurge.descBefore': '之前',
    'adminCachePurge.descOutro': '的销售、登记、订单、定金和报价单/发票。维修不受影响。',
    'adminCachePurge.warnBackupBefore': '破坏性且不可逆的操作。请先从',
    'adminCachePurge.warnBackupLink': '数据库',
    'adminCachePurge.warnBackupAfter': '导出备份,再执行真正的清除。',
    'adminCachePurge.resultDryRunLine': '模拟完成 — 将删除 {{before}} 之前的 {{count}} 条单据。',
    'adminCachePurge.resultPurgeLine': '清除完成 — 已删除 {{before}} 之前的 {{count}} 条单据。',
    'adminCachePurge.sectionParams': '参数',
    'adminCachePurge.labelBeforeDate': '删除此日期之前的全部',
    'adminCachePurge.hintStrictlyBefore': '严格早于当天 00:00。',
    'adminCachePurge.labelConfirm': '确认(必填)',
    'adminCachePurge.hintTypeToken': '请输入:{{token}}',
    'adminCachePurge.dryRunLabel': '模拟模式(dry-run)— 不删除任何内容',
    'adminCachePurge.previewBtn': '预览',
    'adminCachePurge.simulateBtn': '模拟清除',
    'adminCachePurge.executeBtn': '执行清除',
    'adminCachePurge.previewHeading': '预览 — {{count}} 条单据',
    'adminCachePurge.beforeLabel': '早于 {{before}}',
    'adminCachePurge.previewEmpty': '没有可显示的数据。',
    'adminCachePurge.colCollection': '集合',
    'adminCachePurge.colCount': '数量',
    'adminCachePurge.colExamples': '示例',
    'adminCachePurge.sectionExcluded': '未删除',
    'adminCachePurge.excludedReparations': '维修(设备)',
    'adminCachePurge.excludedStock': '库存',
    'adminCachePurge.excludedClients': '客户',
    'adminCachePurge.excludedUtilisateurs': '用户',
    'adminCachePurge.confirmDryRun': '模拟清除 {{before}} 之前的内容({{count}} 条单据)?',
    'adminCachePurge.confirmDelete': '⚠️ 不可逆 — 删除 {{before}} 之前的 {{count}} 条商业单据?',
    'adminCachePurge.errorPreview': '预览出错',
    'adminCachePurge.errorLoad': '加载出错',
    'adminCachePurge.errorPurge': '清除出错',
    'adminSupplierCreds.title': '供应商凭据',
    'adminSupplierCreds.subtitle': '{{providers}} — 用于 Auto-Devis 和目录缓存',
    'adminSupplierCreds.supplierData': '供应商数据',
    'adminMagasins.statusActive': '启用',
    'adminMagasins.statusArchived': '已归档',
    'adminMagasins.newStore': '新建门店',
    'adminMagasins.fieldCode': '代码（自动生成，可编辑）',
    'adminMagasins.fieldName': '名称 *',
    'adminMagasins.namePlaceholder': '例如：卡宴中心门店',
    'adminMagasins.fieldAddress': '地址',
    'adminMagasins.fieldPhone': '电话',
    'adminMagasins.fieldPrinterIp': '打印机 (IP)',
    'adminMagasins.printerIpPlaceholder': '例如：192.168.1.50 — 若无专用打印机请留空',
    'adminMagasins.printerIpHint': '若留空 → 回退到 POS 会话打印机。',
    'adminMagasins.fieldBadgeColor': '标记颜色',
    'adminMagasins.setAsDefault': '设为默认门店',
    'adminMagasins.defaultWillBeDemoted': '门店 {{code}}（{{name}}）目前为默认门店，将被自动取消默认。',
    'adminMagasins.cancel': '取消',
    'adminMagasins.createStore': '创建门店',
    'adminMagasins.nameRequired': '名称为必填项',
    'adminMagasins.createError': '创建出错',
    'adminMagasins.confirmOverrideDefault': '门店「{{code}} — {{name}}」目前为默认门店。\n\n勾选「设为默认」后，它将被自动取消默认。\n\n确认？',
    'adminMagasins.loadError': '加载出错',
    'adminMagasins.confirmArchive': '归档门店 {{code}}？商品和销售记录不会被删除。',
    'adminMagasins.genericError': '出错',
    'adminMagasins.back': '返回',
    'adminMagasins.title': '门店',
    'adminMagasins.subtitle': '管理门店（实体店）',
    'adminMagasins.filterActive': '启用',
    'adminMagasins.filterArchived': '已归档',
    'adminMagasins.filterAll': '全部',
    'adminMagasins.colCode': '代码',
    'adminMagasins.colName': '名称',
    'adminMagasins.colAddress': '地址',
    'adminMagasins.colPhone': '电话',
    'adminMagasins.colPrinterIp': '打印机 IP',
    'adminMagasins.colColor': '颜色',
    'adminMagasins.colStatus': '状态',
    'adminMagasins.colActions': '操作',
    'adminMagasins.loading': '加载中…',
    'adminMagasins.emptyArchived': '没有已归档的门店。',
    'adminMagasins.emptyActive': '没有启用的门店。',
    'adminMagasins.defaultBadge': '默认',
    'adminMagasins.edit': '编辑',
    'adminMagasins.cannotArchiveDefault': '无法操作 — 默认门店',
    'adminMagasins.archive': '归档',
    'adminMagasins.restore': '恢复',
    'adminMagasins.footerNote': '已归档的门店仍保留其商品和销售记录（R1 — 仅软删除）。标记为「{{badge}}」的门店无法归档。',
    'adminPromos.title': '自动促销',
    'adminPromos.subtitle': '有效促销、日历和设置',
    'adminPromos.tabCurrent': '有效促销',
    'adminPromos.tabCalendar': '月度日历',
    'adminPromos.tabSettings': '设置',
    'adminPromos.forceDailyDraw': '强制进行新的每日抽取',
    'adminPromos.ref': '编号：{{ref}}',
    'adminPromos.statusActive': '🟢 已启用',
    'adminPromos.statusInactive': '⚫ 未启用',
    'adminPromos.endLabel': '结束：{{date}}',
    'adminPromos.emptyPromos': '无促销',
    'adminPromos.regenThisMonth': '重新生成本月',
    'adminPromos.productsCount': '{{count}} 件产品',
    'adminPromos.emptyCalendar': '无日历 — 重新生成？',
    'adminPromos.configDaily': '每日自动机器人',
    'adminPromos.excludedCategories': '排除的类别（用逗号分隔）',
    'adminPromos.excludedKeywords': '排除的关键词（正则 OR，可选 — 留空 = 使用默认值）',
    'adminPromos.save': '保存',
    'adminPromos.minPct': '最小 %',
    'adminPromos.maxPct': '最大 %',
    'adminPromos.confirmRegenDaily': '现在抽取新的每日促销吗？',
    'adminPromos.drawResult': '新抽取：{{name}}',
    'adminPromos.statusResult': '状态：{{status}}',
    'adminPromos.confirmRegenCalendar': '重新生成 {{month}} 的日历吗？这将覆盖现有的日历。',
    'adminPromos.calendarRegenResult': '{{status}} — 已使用 {{count}} 件产品',
    'adminPromos.settingsSaved': '设置已保存',
    'adminCadbotPrix.source.ventePos': 'POS 销售',
    'adminCadbotPrix.source.reparation': '维修',
    'adminCadbotPrix.source.devisValide': '已确认报价',
    'adminCadbotPrix.refSource.prixValide': '已确认价格',
    'adminCadbotPrix.refSource.tarifPublic': '公开价格',
    'adminCadbotPrix.refSource.calculFournisseur': '供应商计算',
    'adminCadbotPrix.refSource.aucune': '无参考',
    'adminCadbotPrix.loadError': '加载错误',
    'adminCadbotPrix.genericError': '错误',
    'adminCadbotPrix.toastCollected': '已记录 {{ventes}} 笔销售 + {{reparations}} 次维修',
    'adminCadbotPrix.toastAnalyzed': '{{creees}} 条新建议，{{maj}} 条更新',
    'adminCadbotPrix.priceInvalid': '价格无效',
    'adminCadbotPrix.toastApproved': '价格已确认：{{price}} — {{detail}}',
    'adminCadbotPrix.toastApprovedLocked': '手动价格已锁定，建议待处理',
    'adminCadbotPrix.toastApprovedPublished': '价格页面已更新',
    'adminCadbotPrix.rejectReasonPrompt': '拒绝原因（可选）：',
    'adminCadbotPrix.proposalRejected': '建议已拒绝',
    'adminCadbotPrix.settingsSaved': '设置已保存',
    'adminCadbotPrix.confirmRemoveValidated': '移除已确认价格 {{model}} · {{part}} · {{quality}}？',
    'adminCadbotPrix.validatedRemoved': '已移除确认价格',
    'adminCadbotPrix.pageTitle': 'CADBOT 价格确认',
    'adminCadbotPrix.pageSubtitle': 'CADBOT 记录实际收取的价格并提出调整建议。每个已确认的价格都会更新价格页面，并在报价时优先使用。',
    'adminCadbotPrix.rules': '规则',
    'adminCadbotPrix.collecting': '收集中…',
    'adminCadbotPrix.memorizeSales': '记录销售',
    'adminCadbotPrix.analyzing': '分析中…',
    'adminCadbotPrix.analyze': '分析',
    'adminCadbotPrix.minSales': '最少销售数',
    'adminCadbotPrix.tolerancePct': '最小差额 (%)',
    'adminCadbotPrix.toleranceEur': '最小差额 (€)',
    'adminCadbotPrix.windowDays': '时间窗口（天）',
    'adminCadbotPrix.publishOnApprove': '确认后即发布到价格页面',
    'adminCadbotPrix.countDevisValides': '同时计入已批准的 AI 报价（除已开票销售外）',
    'adminCadbotPrix.filterPending': '待确认',
    'adminCadbotPrix.filterApproved': '已确认',
    'adminCadbotPrix.filterRejected': '已拒绝',
    'adminCadbotPrix.filterAll': '全部',
    'adminCadbotPrix.refresh': '刷新',
    'adminCadbotPrix.loading': '加载中…',
    'adminCadbotPrix.emptyProposals': '没有{{scope}}建议。请点击“{{collect}}”然后点击“{{analyze}}”。',
    'adminCadbotPrix.emptyScopePending': '待确认的',
    'adminCadbotPrix.tier': '档次',
    'adminCadbotPrix.realSales': '{{count}} 笔实际销售（从 {{min}} 到 {{max}}）',
    'adminCadbotPrix.lastSaleOn': '最近一次 {{date}}',
    'adminCadbotPrix.statusBadgePending': '待确认',
    'adminCadbotPrix.statusBadgeApproved': '已确认',
    'adminCadbotPrix.statusBadgeRejected': '已拒绝',
    'adminCadbotPrix.referencePrice': '参考价格',
    'adminCadbotPrix.medianRealSales': '实际销售中位数',
    'adminCadbotPrix.priceToValidate': '待确认价格（可修改）',
    'adminCadbotPrix.priceRetained': '采用价格',
    'adminCadbotPrix.evidenceSales': '佐证销售（{{count}}）',
    'adminCadbotPrix.thDate': '日期',
    'adminCadbotPrix.thSource': '来源',
    'adminCadbotPrix.thRef': '编号',
    'adminCadbotPrix.thDesignation': '名称',
    'adminCadbotPrix.thPriceTtc': '含税价格',
    'adminCadbotPrix.validate': '确认',
    'adminCadbotPrix.validateAt': '按 {{price}} €',
    'adminCadbotPrix.reject': '拒绝',
    'adminCadbotPrix.reviewApproved': '由 {{by}} 于 {{date}} 确认',
    'adminCadbotPrix.reviewRejected': '由 {{by}} 于 {{date}} 拒绝',
    'adminCadbotPrix.lockedPendingNote': '（价格已手动编辑：已锁定，价格待处理）',
    'adminCadbotPrix.validatedPrices': '已确认价格（{{count}}）',
    'adminCadbotPrix.noValidatedPrices': '暂无已确认价格。',
    'adminCadbotPrix.thDevice': '设备',
    'adminCadbotPrix.thPart': '配件',
    'adminCadbotPrix.thTier': '档次',
    'adminCadbotPrix.thPrice': '价格',
    'adminCadbotPrix.thValidated': '确认',
    'adminCadbotPrix.salesCountShort': '{{count}} 笔销售',
    'adminCadbotPrix.remove': '移除',
    'adminCommissions.typeVentes': '销售',
    'adminCommissions.typeCommandes': '订单',
    'adminCommissions.typeAcomptes': '定金',
    'adminCommissions.typeReparations': '维修',
    'adminCommissions.typeFactures': '发票',
    'adminCommissions.typeDevis': '报价',
    'adminCommissions.typeB2b': 'B2B',
    'adminCommissions.typeDeplacement': '上门',
    'adminCommissions.tagBackfill': '回补',
    'adminCommissions.tagDoublonPotentiel': '可能重复',
    'adminCommissions.tagSuspectReparation': '可疑维修',
    'adminCommissions.tagSuspectCommande': '可疑订单',
    'adminCommissions.confirmCancel': '取消这笔佣金？',
    'adminCommissions.noSelection': '未选择任何行',
    'adminCommissions.confirmBulkMarkPaid': '将 {{count}} 笔佣金标记为已支付？',
    'adminCommissions.confirmRecompute30d': '为现有销售重新计算最近 30 天的佣金？\n幂等操作：不会创建重复项。',
    'adminCommissions.recomputeResult': '扫描：{{scanned}} 笔销售 — 已创建 {{created}} 笔佣金',
    'adminCommissions.error': '错误：{{detail}}',
    'adminCommissions.title': '佣金',
    'adminCommissions.totalToPay': '应付总额',
    'adminCommissions.alreadyPaid': '已支付',
    'adminCommissions.recompute30d': '重算最近 30 天',
    'adminCommissions.recompute30dHint': '对现有销售的追溯回补',
    'adminCommissions.configPerStaff': '按员工配置',
    'adminCommissions.configure': '配置',
    'adminCommissions.noStaffFound': '未找到员工',
    'adminCommissions.filters': '筛选',
    'adminCommissions.allStatuses': '全部状态',
    'adminCommissions.statusToPay': '待支付',
    'adminCommissions.statusPaid': '已支付',
    'adminCommissions.statusCancelled': '已取消',
    'adminCommissions.allStaff': '全部员工',
    'adminCommissions.allTypes': '全部类型',
    'adminCommissions.auditHeuristic': '启发式审计',
    'adminCommissions.auditAdvanced': '高级多信号审计',
    'adminCommissions.metierAuditReadOnly': '高级审计 — 只读 · Mongo 账本不变 · 仅多信号分析器',
    'adminCommissions.metierAuditLoading': '业务分析进行中…',
    'adminCommissions.ledgerCommissionStored': '账本佣金（已存储）',
    'adminCommissions.metierCommissionTheoretical': '理论业务佣金',
    'adminCommissions.totalGapPeriod': '期间总差额',
    'adminCommissions.rowsAnalyzed': '已分析行数',
    'adminCommissions.typeMismatchDetected': '检测到的类型不一致',
    'adminCommissions.auditHeuristicLegend': '启发式审计：按交易参考分类。不写入数据库。',
    'adminCommissions.legendRecompute30d': '30 天重算',
    'adminCommissions.combinedAuditNote': 'Ledger 列 = 存储在 Mongo 中的值（类型、费率快照、commission_amount）。Métier 列 = 多信号分析 + 所检测类型的当前员工配置。',
    'adminCommissions.bulkMarkPaid': '标记为已支付（{{count}}）',
    'adminCommissions.clearSelection': '取消选择',
    'adminCommissions.colDate': '日期',
    'adminCommissions.colStaff': '员工',
    'adminCommissions.colType': '类型',
    'adminCommissions.colTransaction': '交易',
    'adminCommissions.colAmount': '金额',
    'adminCommissions.colRateApplied': '适用费率',
    'adminCommissions.colCommission': '佣金',
    'adminCommissions.colStatus': '状态',
    'adminCommissions.colLedgerType': 'L. 类型',
    'adminCommissions.colLedgerRate': 'L. 费率',
    'adminCommissions.colLedgerCommission': 'L. 佣金',
    'adminCommissions.colMetierType': 'M. 类型',
    'adminCommissions.colMetierRate': 'M. 费率',
    'adminCommissions.colMetierCommission': 'M. 佣金',
    'adminCommissions.colGap': '差额',
    'adminCommissions.colAuditSignals': '审计信号',
    'adminCommissions.colRealType': '实际类型（审计）',
    'adminCommissions.colAppliedType': '适用类型',
    'adminCommissions.colSource': '来源',
    'adminCommissions.loading': '加载中…',
    'adminCommissions.mixed': '混合',
    'adminCommissions.pairLabel': '配对：{{id}}',
    'adminCommissions.expectedLabel': '预期：{{type}}',
    'adminCommissions.markPaidShort': '已付',
    'adminCommissions.noCommissionInFilter': '此筛选条件下无佣金',
    'adminCommissions.noCommissionHint': '如果刚刚激活了某笔佣金，请使用上方的"重算最近 30 天"按钮。',
    'adminCommissions.modalTitle': '{{name}} 的佣金',
    'adminCommissions.cancel': '取消',
    'adminCommissions.save': '保存',
    'adminCloud.status.ok': 'OK',
    'adminCloud.status.ko': '失败',
    'adminCloud.status.skipped': '已跳过',
    'adminCloud.docType.ticket': '维修单',
    'adminCloud.docType.facture': '发票',
    'adminCloud.docType.acompte': '定金',
    'adminCloud.docType.devis': '报价单',
    'adminCloud.docType.bonCommande': '采购单',
    'adminCloud.errors.load': '加载出错',
    'adminCloud.errors.save': '保存出错',
    'adminCloud.errors.test': '测试出错',
    'adminCloud.errors.rebuild': '重建出错',
    'adminCloud.errors.syncToggle': '切换同步出错。',
    'adminCloud.save.success': '设置已保存（明文密钥绝不会返回）。',
    'adminCloud.test.ok': '✓ 连接正常 — {{name}}（所有者：{{owner}}，到期：{{expires}}）',
    'adminCloud.test.ko': '连接失败：{{error}}',
    'adminCloud.test.unknownError': '未知',
    'adminCloud.hierarchy.ok': '✓ 层级结构正常 — {{path}}（folder_id：{{folderId}}...）',
    'adminCloud.hierarchy.ko': '层级结构失败 — {{message}}',
    'adminCloud.access.adminRequired': '需要管理员权限。',
    'adminCloud.sync.resumed': '云同步已恢复。',
    'adminCloud.sync.paused': '云同步已暂停。',
    'adminCloud.title': '云同步 — remobiles.fr',
    'adminCloud.subtitlePre': '您的 PDF（维修单、发票、报价单、定金）会自动归档到您的私有空间',
    'adminCloud.refresh': '刷新',
    'adminCloud.sync.active': '云同步已启用',
    'adminCloud.sync.pausedLabel': '云同步已暂停',
    'adminCloud.sync.pausedAt': '暂停于 {{date}}',
    'adminCloud.sync.pausedBy': ' 由 {{by}}',
    'adminCloud.sync.activeHint': '所有新的 PDF 文档都会自动上传到 remobiles.fr。',
    'adminCloud.sync.pauseBtn': '暂停',
    'adminCloud.sync.resumeBtn': '恢复',
    'adminCloud.confirm.resumeTitle': '要恢复同步吗？',
    'adminCloud.confirm.pauseTitle': '要暂停同步吗？',
    'adminCloud.confirm.resumeBody': '新文档将再次自动上传到 remobiles.fr。',
    'adminCloud.confirm.pauseBody': '在您恢复同步之前不会上传任何新文档。现有文档不受影响。',
    'adminCloud.cancel': '取消',
    'adminCloud.stats.globalStatus': '总体状态',
    'adminCloud.stats.enabled': '已启用',
    'adminCloud.stats.disabled': '已禁用',
    'adminCloud.stats.uploadsOk': '上传成功',
    'adminCloud.stats.uploadsKo': '上传失败',
    'adminCloud.stats.total': '总计',
    'adminCloud.structure.title': '目标云结构（真实层级）',
    'adminCloud.structure.cachedTotal': '已缓存 {{count}} 个文件夹',
    'adminCloud.structure.createdThisMonth': '本月创建了 {{count}} 个',
    'adminCloud.structure.retryHierarchy': '重试创建层级',
    'adminCloud.structure.noUploadToday': '（今天无上传）',
    'adminCloud.structure.flat': '（扁平）',
    'adminCloud.structure.recentFolders': '最近创建的文件夹',
    'adminCloud.structure.noFolderCache': '（无缓存文件夹）',
    'adminCloud.structure.policyLabel': '策略',
    'adminCloud.structure.policyBody': '：绝不会向 remobiles.fr 发送任何文件夹或文件的删除操作。测试文件在云端仍然可见。',
    'adminCloud.loading': '加载中...',
    'adminCloud.connection.title': '连接设置',
    'adminCloud.connection.uploadUrl': '上传 URL',
    'adminCloud.connection.status': '状态',
    'adminCloud.connection.enableAuto': '启用自动同步',
    'adminCloud.connection.currentKey': '当前 API 密钥：{{masked}}',
    'adminCloud.connection.noKey': '<无>',
    'adminCloud.connection.keyPlaceholder': '在此粘贴新密钥以替换 (rcsk_...)',
    'adminCloud.connection.keyHint': '密钥在数据库中以 Fernet 加密存储。留空则不修改。',
    'adminCloud.save.btn': '保存',
    'adminCloud.test.btn': '测试连接 (whoami)',
    'adminCloud.test.lastTest': '上次测试：{{mark}} {{date}}',
    'adminCloud.logs.title': '上传日志',
    'adminCloud.logs.allStatuses': '所有状态',
    'adminCloud.logs.filterOk': 'OK',
    'adminCloud.logs.filterKo': '失败',
    'adminCloud.logs.filterSkipped': '已跳过',
    'adminCloud.logs.allTypes': '所有类型',
    'adminCloud.logs.typeTickets': '维修单',
    'adminCloud.logs.typeFactures': '发票',
    'adminCloud.logs.typeAcomptes': '定金',
    'adminCloud.logs.typeDevis': '报价单',
    'adminCloud.logs.typeBonsCommande': '采购单',
    'adminCloud.logs.colDate': '日期',
    'adminCloud.logs.colType': '类型',
    'adminCloud.logs.colRef': '参考号',
    'adminCloud.logs.colStatus': '状态',
    'adminCloud.logs.colFolder': '文件夹',
    'adminCloud.logs.colError': '错误',
    'adminCloud.logs.empty': '暂无上传。',
    'size50x30': '50 x 30 毫米（Bixolon 标准）',
    'protocolZpl': 'ZPL（推荐用于较新的 Bixolon）',
    'protocolBpl': 'BPL（旧版 / SLP 系列）',
    'fieldClientName': '客户姓名',
    'fieldClientPhone': '客户电话',
    'fieldDeviceLock': '密码 / 锁屏',
    'fieldModel': '型号',
    'fieldParts': '配件 / 故障',
    'fieldDate': '日期',
    'fieldPrice': '价格',
    'fieldRef': '参考号 REM-XXX',
    'errLoad': '加载配置出错',
    'saved': '配置已保存。',
    'errSave': '保存出错',
    'previewNeedRef': '请输入 REM-XXX 参考号以生成预览。',
    'errPreview': '生成预览出错',
    'testQueued': '测试已加入队列。本地代理连接后会立即处理。',
    'errTest': '打印机测试出错',
    'confirmRotate': '重新生成令牌会使旧令牌失效。是否继续？',
    'tokenGenerated': '已生成新令牌。请复制并粘贴到本地代理配置中。',
    'errRotate': '重新生成令牌出错',
    'tokenCopied': '令牌已复制到剪贴板。',
    'copyFailed': '复制失败。',
    'errDownloadPack': '下载失败{{http}}：{{detail}}',
    'downloadLinkUnavailable': '下载链接不可用',
    'downloadStartedHint': '下载已开始。如果没有反应，请在浏览器中允许下载。',
    'errDownloadApp': '应用下载失败{{http}}：{{detail}}',
    'agentExeDownloaded': 'Windows 代理下载成功。',
    'errDownloadAgent': '代理下载失败{{http}}：{{detail}}',
    'packDownloaded': '代理安装包下载成功。',
    'securityTitle': '网络打印机安全',
    'securityBody': '请记得修改默认管理员密码（admin/admin），并通过打印机的网页界面禁用 TELNET 和 FTP',
    'securityNoInternet': '切勿将 9100 端口暴露到互联网。',
    'downloadsTitle': '下载与安装程序',
    'downloadsDesc': '直接访问 Windows ZIP 文件、打印机代理和实时替换页面。',
    'openInstallers': '打开安装程序',
    'loading': '加载中...',
    'bixolonSection': 'Bixolon - 二维码标签',
    'fieldPrinterName': '打印机名称',
    'fieldIp': 'IP 地址',
    'fieldPortRaw': '端口（RAW socket）',
    'fieldIpMethod': 'IP 方式',
    'ipMethodManual': '手动（固定 IP）',
    'ipMethodDhcp': 'DHCP',
    'fieldSubnet': '子网',
    'fieldGateway': '网关',
    'fieldDns': 'DNS',
    'fieldProtocol': '打印协议',
    'fieldDefaultLabelFormat': '默认标签格式',
    'printerActive': '打印机已启用',
    'testConnection': '测试连接',
    'lastTest': '最近测试：{{date}}',
    'epsonSection': 'Epson - 收银小票',
    'epsonDesc': '这些值用于 80 毫米小票。Windows 代理读取此配置后，将小票发送到门店的 Epson 打印机。',
    'fieldTicketIp': 'Epson IP 地址',
    'fieldTicketPort': 'Epson 端口',
    'fieldTicketProtocol': '小票协议',
    'ticketProtoEscpos': 'ESC/POS（Epson）',
    'ticketProtoZplFallback': 'ZPL（备用）',
    'agentSection': '本地代理',
    'agentDesc': '本地代理运行在局域网（LAN）的一台工作站上，通过轮询（polling）接收任务，并将 Bixolon 标签或 Epson 小票发送到已配置的打印机。API 令牌用于以代理身份进行认证。',
    'tokenCopyNow': '令牌（请立即复制 - 之后将不再显示）：',
    'agentTokenLabel': '代理令牌',
    'tokenCreated': '（已创建）',
    'tokenNotGenerated': '（未生成）',
    'noToken': '— 无令牌 —',
    'hide': '隐藏',
    'show': '显示',
    'copy': '复制',
    'regenerateToken': '重新生成令牌',
    'generateToken': '生成令牌',
    'agentWinTitle': '本地 Windows 代理',
    'agentWinDesc': '下载可直接运行的代理，如果需要在 Windows 工作站上重新构建代理，请下载 zip 安装包。',
    'directLinks': '直接链接',
    'dlDesktopApp': 'Windows 员工应用',
    'dlAgentExe': 'Windows 代理（.exe）',
    'dlAgentPack': '代理安装包（.zip）',
    'tempLinksNote': '自动签名的临时链接。它们将在几分钟后过期。',
    'downloading': '下载中...',
    'dlAgentExeBtn': '下载 Windows 代理（.exe）',
    'dlAgentPackBtn': '下载代理安装包（.zip）',
    'desktopAppDesc': '下载已编译好的 R.E.Mobiles 桌面应用。它会启动本地前端、本地后端以及内置的打印代理。',
    'dlDesktopAppBtn': '下载 Windows 应用（.zip）',
    'printedFields': '打印字段',
    'fieldFontSize': '字号（6-16）',
    'fieldMargin': '边距（0-24 pt）',
    'previewPdf': 'PDF 预览',
    'previewDesc': '为现有维修单生成一个测试 PDF 标签。',
    'previewRefPlaceholder': '参考号 REM-XXX',
    'previewBtn': '预览',
    'save': '保存',
    'reload': '重新加载',
    'errUnknown': '未知错误',
    'adminPertes.title': '损失',
    'adminPertes.subtitle': '按销售员统计：低于目录价收款的库存外销售以及超过授权上限的折扣。',
    'adminPertes.exportCsv': '导出 CSV',
    'adminPertes.recalcul': '按历史重新计算',
    'adminPertes.typeHorsStock': '库存外低于定价',
    'adminPertes.typeRemise': '折扣过高',
    'adminPertes.typeSousCatalogue': '低于目录价',
    'adminPertes.preset30j': '30 天',
    'adminPertes.preset3m': '3 个月',
    'adminPertes.preset12m': '12 个月',
    'adminPertes.presetCustom': '自定义',
    'adminPertes.payCb': '银行卡',
    'adminPertes.payCash': '现金',
    'adminPertes.payCheque': '支票',
    'adminPertes.payVirement': '转账',
    'adminPertes.payMixte': '混合',
    'adminPertes.payAvoir': '购物金',
    'adminPertes.payAcompte': '定金',
    'adminPertes.periode': '时间段：{{debut}} → {{fin}}',
    'adminPertes.du': '从',
    'adminPertes.au': '到',
    'adminPertes.vendeur': '销售员',
    'adminPertes.type': '类型',
    'adminPertes.magasin': '门店',
    'adminPertes.tous': '全部',
    'adminPertes.tileTotal': '总损失',
    'adminPertes.calculeLe': '计算于 {{date}}',
    'adminPertes.remisesExcessives': '过高折扣',
    'adminPertes.auDelaDe': '超过 {{pct}}',
    'adminPertes.tileNb': '涉及的销售',
    'adminPertes.parVendeur': '按销售员',
    'adminPertes.loading': '加载中…',
    'adminPertes.aucunePerte': '该时间段内无损失。',
    'adminPertes.colTotal': '合计',
    'adminPertes.colNbVentes': '销售数',
    'adminPertes.filtrerVendeur': '按该销售员筛选明细',
    'adminPertes.detailTitle': '销售明细',
    'adminPertes.pageRange': '{{from}}–{{to}}，共 {{total}}',
    'adminPertes.pageN': '第 {{page}} 页',
    'adminPertes.aucuneLigne': '这些筛选条件下没有记录。',
    'adminPertes.colDate': '日期',
    'adminPertes.colTicket': '小票',
    'adminPertes.colArticle': '商品',
    'adminPertes.colQte': '数量',
    'adminPertes.colPrixVendu': '售出价',
    'adminPertes.colPrixRef': '参考价',
    'adminPertes.colRemise': '折扣',
    'adminPertes.colPerte': '损失',
    'adminPertes.trierPerte': '按损失排序',
    'adminPertes.colStatut': '状态',
    'adminPertes.colActions': '操作',
    'adminPertes.ticket': '小票',
    'adminPertes.ouvrirTicket': '在新标签页打开收银小票（PDF）',
    'adminPertes.voirVente': '查看销售',
    'adminPertes.masquerVente': '隐藏销售内容',
    'adminPertes.voirVenteTitle': '查看此小票售出的商品',
    'adminPertes.venteLabel': '销售',
    'adminPertes.paiement': '支付：',
    'adminPertes.contenuIndispo': '该小票的销售内容不可用（请打开 PDF 小票）。',
    'adminPertes.ligneEnPerte': '（亏损行）',
    'adminPertes.totalVente': '销售合计：',
    'adminPertes.precedent': '上一页',
    'adminPertes.suivant': '下一页',
    'adminPertes.lignesParPage': '每页 {{count}} 行',
    'adminPertes.legendeTitle': '损失如何计算',
    'adminPertes.legendeHorsStockText': '“库存外”销售以低于目录价收款，而该商品在销售时存在于数据库中。损失 =',
    'adminPertes.legendeHorsStockFormula': '（参考价 − 售出价）× 数量',
    'adminPertes.legendeRemiseText': '销售行上折扣超过 {{seuil}}。只计入超过 {{seuil}} 的部分：',
    'adminPertes.legendeRemiseFormula': '（折扣 − {{seuil}}）× 参考价 × 数量',
    'adminPertes.legendeSousCatalogue': '有库存商品在未申报折扣的情况下低于目录价售出：与“库存外低于定价”公式相同。',
    'adminPertes.legendeFooter': '参考价是商品在销售日期的目录价。“按历史重新计算”会重新读取所有过往销售；当前视图已缓存并自动刷新。',
    'adminPertes.confirmRecalcul': '要对全部销售历史重新计算损失吗？此操作会重新读取所有过往销售，可能需要一些时间。',
    'adminPertes.recalculDone': '重新计算完成 — 已分析 {{count}} 笔销售',
    'adminPertes.recalculDoneGeneric': '已对全部历史完成重新计算',
    'adminPertes.recalculFail': '重新计算失败',
    'adminPertes.exportDone': 'CSV 导出已下载',
    'adminPertes.exportUnavailable': '导出不可用（需更新后端）',
    'adminPertes.exportFail': '导出失败',
    'adminPertes.refManquante': '缺少销售单号：找不到小票',
    'adminPertes.ticketFail': '无法打开小票',
    'adminPertes.endpointIndispo': '“损失”接口不可用（需更新后端）。',
    'adminPertes.errLoad': '加载错误',
    'adminPertes.ticketTooltipRef': '小票 {{ref}}',
    'adminPertes.lignes_one': '{{count}} 行',
    'adminPertes.lignes_other': '{{count}} 行',
    'adminPertes.articles_one': '{{count}} 件',
    'adminPertes.articles_other': '{{count}} 件',
    'adminPertes.autres_one': '（+{{count}} 个）',
    'adminPertes.autres_other': '（+{{count}} 个）',
    'adminTodo.cat.ventesHorsStock': '待确认的无库存销售',
    'adminTodo.cat.cadbotPrix': '待审核的 CADBOT 价格',
    'adminTodo.cat.devisChat': '待处理的聊天报价',
    'adminTodo.cat.acomptesACommander': '定金 → 待订购的配件',
    'adminTodo.cat.commandesSansSuivi': '无追踪单号的订单',
    'adminTodo.cat.sumupAConfirmer': '待确认的 SumUp 付款',
    'adminTodo.cat.factureRequests': '开票请求',
    'adminTodo.groupFallback': '分组',
    'adminTodo.time.now': '刚刚',
    'adminTodo.time.minutesAgo': '{{n}} 分钟前',
    'adminTodo.time.hoursAgo': '{{n}} 小时前',
    'adminTodo.error.endpointUnavailable': '“待办”接口不可用（需更新后端）。',
    'adminTodo.error.load': '加载出错',
    'adminTodo.settings.unavailable': '设置不可用（需更新后端）。',
    'adminTodo.settings.notLoaded': '设置未加载',
    'adminTodo.settings.saved': '设置已保存',
    'adminTodo.settings.saveError': '无法保存设置',
    'adminTodo.title': '待办',
    'adminTodo.subtitleUpdated': '更新于 {{time}} · 每 60 秒自动刷新',
    'adminTodo.subtitleDefault': '所有需要处理的事项，尽在一处。',
    'adminTodo.notifications': '通知',
    'adminTodo.refresh': '刷新',
    'adminTodo.settings.saving': '正在保存…',
    'adminTodo.settings.loading': '正在加载设置…',
    'adminTodo.settings.pushLabel': '手机推送通知',
    'adminTodo.settings.pushHint': '一旦有新事项就提醒。',
    'adminTodo.settings.digestLabel': '每天上午 9 点汇总',
    'adminTodo.settings.digestHint': '每天早上一条消息，汇总所有待办事项。',
    'adminTodo.settings.categoriesTracked': '关注的类别',
    'adminTodo.allClear': '没有待处理事项，一切都是最新的。',
    'adminTodo.groupNothingPending': '没有待处理事项',
    'adminTodo.open': '打开',
    'adminTodo.seeAll': '查看全部 {{count}} 项',
    'adminTodo.openPage': '打开页面',
    'adminTodo.pushOn': '推送已开启',
    'adminTodo.pushOff': '推送已关闭',
    'adminTodo.digestOn': '9 点汇总已开启',
    'adminTodo.digestOff': '9 点汇总已关闭',
    'adminUsers.role.super_admin.label': '超级管理员',
    'adminUsers.role.super_admin.desc': '完全访问整个系统（仅限 carlos）',
    'adminUsers.role.admin_magasin.label': '门店管理员',
    'adminUsers.role.admin_magasin.desc': '管理一个或多个指定门店',
    'adminUsers.role.technicien.label': '售后技术员',
    'adminUsers.role.technicien.desc': '两家门店的售后工单。无 POS，无会计。',
    'adminUsers.role.vendeur.label': '销售员',
    'adminUsers.role.vendeur.desc': '所有门店的 POS。无会计，无管理。',
    'adminUsers.roleUnknown': '未知',
    'adminUsers.modal.editTitle': '编辑 {{username}}',
    'adminUsers.createUser': '创建用户',
    'adminUsers.field.username': '用户名',
    'adminUsers.field.passwordEdit': '新密码（留空则保持不变）',
    'adminUsers.field.passwordCreate': '密码 *（至少 {{min}} 个字符）',
    'adminUsers.field.email': '电子邮箱',
    'adminUsers.field.telephone': '电话',
    'adminUsers.field.role': '门店角色',
    'adminUsers.field.assignedMagasins': '分配的门店',
    'adminUsers.modal.minOneRequired': '（至少需 1 个）',
    'adminUsers.modal.ignoredForRole': '— 已保存但对此角色忽略（范围 = 所有门店）',
    'adminUsers.modal.loadingMagasins': '正在加载门店…',
    'adminUsers.modal.posOnlyTitle': '缺勤 / 停用 — 仅 POS',
    'adminUsers.modal.posOnlyDesc': '可以登录并在 POS 收款，但无法访问其他页面（维修、库存、客户、管理…）。',
    'adminUsers.action.cancel': '取消',
    'adminUsers.action.save': '保存',
    'adminUsers.action.create': '创建',
    'adminUsers.denied.title': '访问被拒绝',
    'adminUsers.denied.desc': '此页面仅限超级管理员访问。',
    'adminUsers.denied.back': '返回仪表板',
    'adminUsers.error.load': '加载错误',
    'adminUsers.error.passwordMin': '密码必须至少包含 {{min}} 个字符。',
    'adminUsers.feedback.updated': '用户 {{username}} 已更新。',
    'adminUsers.feedback.created': '用户 {{username}} 已创建。',
    'adminUsers.error.operation': '操作过程中出错',
    'adminUsers.error.needsMagasinPick': '请先选择会话门店（屏幕中央的窗口），然后再创建用户。',
    'adminUsers.feedback.disabled': '{{username}} 已停用。',
    'adminUsers.feedback.enabled': '{{username}} 已重新启用。',
    'adminUsers.error.generic': '错误',
    'adminUsers.action.back': '返回',
    'adminUsers.title': '内部用户',
    'adminUsers.subtitle': '创建 / 编辑 / 停用（仅限超级管理员）',
    'adminUsers.limitInfo': '{{current}}/{{max}} 个用户 · {{plan}} 套餐',
    'adminUsers.limitReachedTitle': '已达上限（最多 {{max}} 个用户）',
    'adminUsers.limitReached': '已达上限（{{max}}）',
    'adminUsers.includeDisabled': '包含已停用的用户',
    'adminUsers.col.role': '角色',
    'adminUsers.col.emailTel': '邮箱 / 电话',
    'adminUsers.col.status': '状态',
    'adminUsers.col.actions': '操作',
    'adminUsers.empty': '暂无用户。',
    'adminUsers.allMagasins': '全部',
    'adminUsers.status.active': '启用',
    'adminUsers.status.disabled': '已停用',
    'adminUsers.status.posOnly': '缺勤 · 仅 POS',
    'adminUsers.action.edit': '编辑',
    'adminUsers.commissions': '佣金',
    'adminUsers.action.disable': '停用',
    'adminUsers.action.enable': '重新启用',
    'adminHorsStock.stockUnknown': '库存未知',
    'adminHorsStock.stockCount': '库存 {{count}}',
    'adminHorsStock.selected': '已选择',
    'adminHorsStock.lineDefaultDesignation': '商品',
    'adminHorsStock.loadError': '加载错误',
    'adminHorsStock.lineStillUnresolved': '仍有一行处于“待核实”状态或未关联参考编号。',
    'adminHorsStock.saleValidatedWithLoss': '销售 {{ref}} 已确认 — 历史记录中 {{total}}。已记录损失：{{loss}}。',
    'adminHorsStock.saleValidatedNoLoss': '销售 {{ref}} 已确认 — 历史记录中 {{total}}，无损失。',
    'adminHorsStock.validationFailed': '无法确认',
    'adminHorsStock.catalogBadge': '目录',
    'adminHorsStock.cashedLineInfo': '已收款 {{qty}} × {{price}}',
    'adminHorsStock.horsStockBadge': '无库存',
    'adminHorsStock.articleExistedQuestion': '该商品已存在吗？',
    'adminHorsStock.optionLoss': '损失 — 商品已存在，关联参考编号',
    'adminHorsStock.optionNonExistent': '商品不存在 — 原样接受',
    'adminHorsStock.optionToVerify': '待核实',
    'adminHorsStock.attachedArticle': '已关联商品',
    'adminHorsStock.refLabel': '编号 {{ref}}',
    'adminHorsStock.catalogPriceLabel': '目录价',
    'adminHorsStock.unknown': '未知',
    'adminHorsStock.soldLabel': '售出',
    'adminHorsStock.estimatedLoss': '预计损失',
    'adminHorsStock.selectCatalogRef': '选择与此商品对应的目录参考编号。',
    'adminHorsStock.catalogSuggestions': '目录建议',
    'adminHorsStock.noSuggestion': '此行没有建议 — 请使用下方搜索。',
    'adminHorsStock.otherCatalogArticle': '目录中的其他商品',
    'adminHorsStock.searchPlaceholder': '搜索参考编号 / 名称 / EAN…',
    'adminHorsStock.noArticleFound': '未找到商品。',
    'adminHorsStock.freeArticleInfo': '自由商品：该行保持原样，不做关联，也不产生库存变动。',
    'adminHorsStock.toVerifyInfo': '在该行确定之前（是 / 否）将阻止确认。',
    'adminHorsStock.toValidateBadge': '待确认',
    'adminHorsStock.cashedBadge': '已收款',
    'adminHorsStock.cashedAmountLabel': '已收款',
    'adminHorsStock.subtotal': '小计',
    'adminHorsStock.discountLabel': '折扣',
    'adminHorsStock.historyTotal': '历史记录总额',
    'adminHorsStock.amountLockedInfo': '实际收款金额：此处无法修改价格、数量和折扣。',
    'adminHorsStock.lossesPreview': '损失预览（仅管理层可见）',
    'adminHorsStock.remiseExcessiveLabel': '超过 {{seuil}}% 的折扣（已给予 {{pct}}）',
    'adminHorsStock.lossRecorded': '已确认损失',
    'adminHorsStock.lossSavedInfo': '确认后记录到“损失”页面。',
    'adminHorsStock.noLossYet': '当前阶段未发现损失',
    'adminHorsStock.noLossYetSuffix': ' — 关联参考编号后计算即完成。',
    'adminHorsStock.noteLabel': '备注（可选）',
    'adminHorsStock.notePlaceholder': '例如：议定价格、商品收到日期…',
    'adminHorsStock.validateButton': '确认并写入历史记录',
    'adminHorsStock.blockedTitle': '仍有一条或多条无库存行需要处理',
    'adminHorsStock.validationBlocked': '确认已阻止：',
    'adminHorsStock.blockedVerifierCount': '{{n}} 行“待核实”',
    'adminHorsStock.blockedNoRefCount': '{{n}} 行“是”但未关联参考编号',
    'adminHorsStock.legendTitle': '会发生什么',
    'adminHorsStock.legendIntro': '该销售已收款：无法取消，库存也不会变动。确认会关联正确的商品，将差价或过高折扣记入损失，然后将销售写入历史记录。',
    'adminHorsStock.legendYesWord': '是',
    'adminHorsStock.legendYesDesc': '— 商品已存在：选择目录参考编号（建议或搜索）。',
    'adminHorsStock.legendNonWord': '否',
    'adminHorsStock.legendNonDesc': '— 自由商品，保持原样。',
    'adminHorsStock.legendVerifierDesc': '— 在该行确定之前阻止确认。',
    'adminHorsStock.legendPertesWord': '损失',
    'adminHorsStock.legendPertesDesc': '— 目录价与售价之间的差额，加上超过小计 {{seuil}}% 的折扣部分；仅此处可见并记录在“损失”页面。',
    'adminHorsStock.pageTitle': '待确认的无库存销售',
    'adminHorsStock.pageSubtitle': '已收款；在管理层确认前不进入历史记录。',
    'adminHorsStock.refresh': '刷新',
    'adminHorsStock.emptyState': '没有等待确认的无库存销售。',
    'adminHorsStock.processedThisSession': '本次会话已处理',
    'adminHorsStock.lossShortLabel': '损失',
    'adminHorsStock.validatedBadge': '已确认',
    'stockPhotoAi.title': '库存照片 · AI',
    'stockPhotoAi.subtitle': '超级管理员 Carlos · OpenAI 生成 · 独立门店 M1/M2',
    'stockPhotoAi.apiKeysLink': 'OpenAI API 密钥',
    'stockPhotoAi.statsTotal': '商品 {{mag}}',
    'stockPhotoAi.statsWithPhoto': '有照片',
    'stockPhotoAi.statsMissing': '无照片',
    'stockPhotoAi.searchPlaceholder': '搜索参考号或名称…',
    'stockPhotoAi.filter': '筛选',
    'stockPhotoAi.generateBatch': '批量生成（最多 10）',
    'stockPhotoAi.batchResult': '批量 {{mag}}：{{ok}} 成功 · {{skipped}} 已跳过 · {{errors}} 错误',
    'stockPhotoAi.loading': '加载中…',
    'stockPhotoAi.stockLabel': '库存 {{qty}}',
    'stockPhotoAi.generateOne': 'AI 生成',
    'stockPhotoAi.empty': '{{mag}} 没有缺少照片的商品',
    'stockPhotoAi.errorLoad': '无法加载',
    'stockPhotoAi.errorGenerate': '生成失败',
    'stockPhotoAi.errorBatch': '批量失败',
    'stockPhotoAi.confirmBatch': '为 {{mag}} 生成最多 {{max}} 张 AI 图像？（OpenAI · API 费用）',
    'stockCatAudit.title': '库存类别审核',
    'stockCatAudit.subtitle': '手机与零件/配件完整分析 · 仅限 Carlos',
    'stockCatAudit.backToIntegrations': '管理集成',
    'stockCatAudit.magasin': '门店',
    'stockCatAudit.allStores': '全部',
    'stockCatAudit.issuesOnly': '仅显示有问题的行',
    'stockCatAudit.runAnalysis': '开始分析',
    'stockCatAudit.statTotal': '总计',
    'stockCatAudit.statWithIssues': '有问题',
    'stockCatAudit.statFalseImei': '错误 IMEI',
    'stockCatAudit.statNeedsImei': '需要 IMEI',
    'stockCatAudit.statCategorieMismatch': '类别不同',
    'stockCatAudit.statCategorieMissing': '类别为空',
    'stockCatAudit.statAmbiguous': '不明确',
    'stockCatAudit.currentCategories': '当前类别',
    'stockCatAudit.suggestedCategories': '建议类别',
    'stockCatAudit.searchPlaceholder': '参考号、名称、类别…',
    'stockCatAudit.allFilters': '所有筛选',
    'stockCatAudit.applySuggested': '应用建议类别 ({{count}})',
    'stockCatAudit.colRef': '参考号',
    'stockCatAudit.colDesignation': '名称',
    'stockCatAudit.colMag': '门店',
    'stockCatAudit.colCurrentCat': '当前类别',
    'stockCatAudit.colSuggestedCat': '建议类别',
    'stockCatAudit.colType': '类型',
    'stockCatAudit.colIssues': '问题',
    'stockCatAudit.typePhone': '手机',
    'stockCatAudit.typePiece': '零件',
    'stockCatAudit.analyzing': '正在分析…',
    'stockCatAudit.emptyRows': '没有行 — 请运行分析或放宽筛选条件。',
    'stockCatAudit.hint': '例如"手机支架"现在归类为配件（无需 IMEI）。真正的整机手机在盘点时仍需 IMEI。',
    'stockCatAudit.errorAnalyze': '无法分析',
    'stockCatAudit.errorApply': '应用失败',
    'stockCatAudit.confirmApply': '将建议类别应用到 {{count}} 个商品？',
    'stockCatAudit.issueFalsePhoneImei': '误判手机（错误带 IMEI）',
    'stockCatAudit.issueNeedsImei': '手机 — 需要 IMEI',
    'stockCatAudit.issueCategorieMismatch': '类别不同',
    'stockCatAudit.issueCategorieMissing': '缺少类别',
    'stockCatAudit.issueAmbiguous': '不明确',
    'stockHist.periodToday': '今天',
    'stockHist.periodYesterday': '昨天',
    'stockHist.periodWeek': '本周',
    'stockHist.periodMonth': '本月',
    'stockHist.title': '库存历史',
    'stockHist.subtitle': '门店与仓库出入库',
    'stockHist.statMovements': '出入库',
    'stockHist.statPieces': '件数',
    'stockHist.locationShop': '门店',
    'stockHist.locationWarehouse': '仓库',
    'stockHist.empty': '此期间无入库记录',
    'stockHist.colDateTime': '日期 / 时间',
    'stockHist.colDesignation': '品名',
    'stockHist.colStore': '店号',
    'stockHist.colLocation': '位置',
    'stockHist.colQty': '数量',
    'stockHist.colSalePrice': '售价',
    'stockHist.colBy': '操作人',
    'stockHist.statusNew': '新建',
    'stockHist.statusRestock': '补货',
    'stockHist.selectedOne': '已选',
    'stockHist.selectedMany': '已选',
    'stockHist.labelOne': '标签',
    'stockHist.labelMany': '标签',
    'stockHist.printCount': '打印 ({{count}})',
    'partsOrders.statusPending': '待处理',
    'partsOrders.statusPartial': '部分',
    'partsOrders.statusReceived': '已接收',
    'partsOrders.statusCancelled': '已取消',
    'partsOrders.filterAll': '全部',
    'partsOrders.filterReceived': '已接收',
    'partsOrders.filterCancelled': '已取消',
    'partsOrders.partTypeStandard': '标准',
    'partsOrders.partTypeSpare': '配件',
    'partsOrders.partTypeSerialized': '序列化（序列号/IMEI）',
    'partsOrders.createTitle': '新建供应商订单',
    'partsOrders.supplier': '供应商',
    'partsOrders.supplierPlaceholder': '供应商名称',
    'partsOrders.line': '第 {{num}} 行',
    'partsOrders.designationPlaceholder': '名称 *',
    'partsOrders.referencePlaceholder': '参考编号（可选）',
    'partsOrders.type': '类型',
    'partsOrders.qty': '数量',
    'partsOrders.purchasePriceUnit': '单位进价',
    'partsOrders.expectedSalePrice': '预计售价',
    'partsOrders.category': '类别',
    'partsOrders.categoryPlaceholder': '例如：屏幕、电池',
    'partsOrders.location': '存放位置',
    'partsOrders.locationShop': '店面',
    'partsOrders.locationWarehouse': '仓库',
    'partsOrders.addLine': '添加一行',
    'partsOrders.notes': '备注',
    'partsOrders.errorNeedLine': '请至少添加一行并填写名称。',
    'partsOrders.errorCreate': '创建时出错。',
    'partsOrders.cancel': '取消',
    'partsOrders.creating': '创建中…',
    'partsOrders.create': '创建订单',
    'partsOrders.receiveTitle': '收货 — {{ref}}',
    'partsOrders.allReceived': '所有行均已接收。',
    'partsOrders.remaining': '剩余 {{count}}',
    'partsOrders.receivedQty': '接收数量',
    'partsOrders.serialsLabel': '序列号 / IMEI（每行一个或用逗号分隔）',
    'partsOrders.errorNeedQty': '请至少填写一个接收数量。',
    'partsOrders.errorReceive': '收货时出错。',
    'partsOrders.close': '关闭',
    'partsOrders.validating': '确认中…',
    'partsOrders.validateReceive': '确认收货',
    'partsOrders.linkTitle': '分配给维修单',
    'partsOrders.linkDescription': '配件“{{designation}}”将计入维修价格，但不会从库存中扣除（尚未收货）。',
    'partsOrders.linkRefPlaceholder': '维修参考号（例如 REP-000123）',
    'partsOrders.errorNeedRef': '请输入维修参考号。',
    'partsOrders.errorRepairNotFound': '错误：未找到维修单？',
    'partsOrders.assign': '分配',
    'partsOrders.confirmCancel': '取消此订单？关联到维修单的配件将被解除关联。',
    'partsOrders.errorCancel': '取消时出错。',
    'partsOrders.errorGeneric': '出错。',
    'partsOrders.supplierUnknown': '供应商？',
    'partsOrders.linesCount': '{{count}} 行',
    'partsOrders.receivedCount': '已收 {{received}}/{{total}}',
    'partsOrders.purchaseCost': '采购成本',
    'partsOrders.colDesignation': '名称',
    'partsOrders.colReceivedQty': '已收/数量',
    'partsOrders.colPurchaseUnit': '单位进价',
    'partsOrders.colSalePlanned': '预计售价',
    'partsOrders.colRepair': '维修单',
    'partsOrders.colAction': '操作',
    'partsOrders.typeSerialized': '序列化',
    'partsOrders.typeSpareShort': '配件',
    'partsOrders.typeStandardShort': '标准',
    'partsOrders.detach': '解除关联',
    'partsOrders.receive': '收货',
    'partsOrders.pageTitle': '配件订单',
    'partsOrders.pageSubtitle': '供应商采购 — 维修预分配与收货',
    'partsOrders.filterAllStores': '全部',
    'partsOrders.refresh': '刷新',
    'partsOrders.newOrder': '新建订单',
    'partsOrders.kpiOpenOrders': '未完成订单',
    'partsOrders.kpiAssignedParts': '已分配维修的配件',
    'partsOrders.kpiCostToReceive': '待收货成本',
    'partsOrders.loading': '加载中…',
    'partsOrders.empty': '暂无配件订单。',
    'stockForm.editTitle': '编辑商品',
    'stockForm.addTitle': '添加商品',
    'stockForm.productSheet': '产品信息',
    'stockForm.newStockProduct': '新库存产品',
    'stockForm.analyzePhoto': '分析照片',
    'stockForm.scan': '扫描',
    'stockForm.supplierSearch': '供应商搜索',
    'stockForm.supplierSearchPlaceholder': '参考号、EAN 或配件名称…',
    'stockForm.refShort': '编号：',
    'stockForm.priceLabel': '价格：',
    'stockForm.sectionArticle': '商品信息',
    'stockForm.reference': '参考号',
    'stockForm.ean': 'EAN',
    'stockForm.eanPlaceholder': '条形码',
    'stockForm.category': '类别',
    'stockForm.categoryPlaceholder': '屏幕、电池…',
    'stockForm.designation': '名称',
    'stockForm.supplier': '供应商',
    'stockForm.sectionStock': '库存信息',
    'stockForm.location': '位置',
    'stockForm.shop': '门店',
    'stockForm.depot': '仓库',
    'stockForm.both': '两者',
    'stockForm.qtyShop': '门店数量',
    'stockForm.qtyDepot': '仓库数量',
    'stockForm.alertThreshold': '预警阈值',
    'stockForm.sectionPricing': '价格信息',
    'stockForm.purchasePrice': '采购价（不含税）',
    'stockForm.salePrice': '销售价（€）',
    'stockForm.margin': '利润率',
    'stockForm.sectionShop': '网店信息',
    'stockForm.visibleOnline': '在线商店中可见',
    'stockForm.visibleOnlineHint': '顾客将可以购买此商品',
    'stockForm.cancel': '取消',
    'stockForm.saving': '保存中…',
    'stockForm.edit': '修改',
    'stockForm.addToStock': '添加到库存',
    'stockForm.save': '保存',
    'stockForm.reviewTitle': '商品核对',
    'stockForm.newArticle': '新商品',
    'stockForm.existingBanner': '已存在 — {{designation}}（门店:{{qb}} 仓库:{{qd}}）。数量已添加到库存。',
    'stockForm.imeiRequired': '将手机登记入库需要 IMEI。',
    'stockForm.imeiInvalid': 'IMEI 无效（14 至 20 位数字）。',
    'stockForm.articleNotFound': '未找到商品',
    'stockForm.imeiNotRegistered': 'IMEI 未登记 — 请检查号码或进入 高级库存 > IMEI。',
    'stockForm.imeiFirstRegistered': '已登记第一个 IMEI。还剩 {{count}} 台设备 — 请在 高级库存 > IMEI 标签页中补全 IMEI（参考号 {{ref}}）。',
    'stockForm.saveError': '保存时出错',
    'clientChat.typeBoutiqueOrder': '商店订单',
    'clientChat.typeRepair': '维修',
    'clientChat.typeClient': '客户对话',
    'clientChat.title': '客户聊天',
    'clientChat.convCount': '{{count}} 个对话',
    'clientChat.convCountPlural': '{{count}} 个对话',
    'clientChat.searchPlaceholder': '搜索客户...',
    'clientChat.noConversations': '暂无客户对话',
    'clientChat.clientFallback': '客户',
    'clientChat.startConversation': '开始对话',
    'clientChat.writePlaceholder': '给客户写消息...',
    'clientChat.selectConversation': '选择一个对话',
    'stockInvImport.errorAiAnalysis': 'AI 分析错误 — 请检查 Admin > API 集成 (OpenAI)',
    'stockInvImport.confirmMissingImei': '{{count}} 行手机缺少完整的 IMEI。\n\n是否继续导入？您可以在高级库存 > IMEI 中补全。',
    'stockInvImport.errorImport': '导入错误',
    'stockInvImport.locationDepot': '仓库',
    'stockInvImport.locationBoutique': '门店',
    'stockInvImport.pageTitle': 'AI 发票导入',
    'stockInvImport.pageSubtitle': 'PDF 分析 · 计算与 /calcul 一致',
    'stockInvImport.visionHint': 'OpenAI Vision · 价格取整与毛利计算模块一致',
    'stockInvImport.invoiceLabel': '发票（PDF 或图片）',
    'stockInvImport.fileSize': '{{size}} KB',
    'stockInvImport.clickToChoose': '点击选择文件',
    'stockInvImport.shippingTotalLabel': '运费总额 (EUR)',
    'stockInvImport.autoIfEmpty': '— 留空则自动',
    'stockInvImport.shippingPlaceholder': '例如：29.90',
    'stockInvImport.customsPct': '关税 %',
    'stockInvImport.marginPct': '毛利 %',
    'stockInvImport.analyzing': '正在分析…（15–30 秒）',
    'stockInvImport.analyzeInvoice': '分析发票',
    'stockInvImport.kpiProducts': '产品',
    'stockInvImport.kpiSupplier': '供应商',
    'stockInvImport.kpiShippingTotal': '运费总额',
    'stockInvImport.kpiShippingPerUnit': '运费 / 单位',
    'stockInvImport.recalc': '重新计算…',
    'stockInvImport.phonesCompleteImei': '{{count}} 部手机 — 请在下方补全 IMEI（如发票中存在则自动提取）。',
    'stockInvImport.colRef': '参考号',
    'stockInvImport.colDesignation': '名称',
    'stockInvImport.colQty': '数量',
    'stockInvImport.colPurchase': '进价',
    'stockInvImport.colPlusShipping': '+运费',
    'stockInvImport.colPlusCustoms': '+{{pct}}% 关税',
    'stockInvImport.colPlusMargin': '+{{pct}}% 毛利',
    'stockInvImport.colLabor': '工时费',
    'stockInvImport.colFinalPrice': '最终价格',
    'stockInvImport.remove': '移除',
    'stockInvImport.generateEan': '生成 EAN',
    'stockInvImport.imeiDevicePlaceholder': '设备 IMEI {{n}}',
    'stockInvImport.back': '返回',
    'stockInvImport.importing': '正在导入…',
    'stockInvImport.confirm': '确认',
    'stockInvImport.importDone': '导入完成',
    'stockInvImport.created': '已创建',
    'stockInvImport.updated': '已更新',
    'stockInvImport.imeiRegistered': '已登记的 IMEI',
    'stockInvImport.errors': '错误',
    'stockInvImport.imeiMissingTitle': '缺少 IMEI — 请在高级库存中补全',
    'stockInvImport.missingOfTotal': '缺少 {{missing}} / 共 {{total}}',
    'stockInvImport.newImport': '新建导入',
    'stockInvImport.backToStock': '返回库存',
    'clientPwd.pinGenerated': '已为 {{nom}} 生成 PIN：{{pin}}',
    'clientPwd.error': '错误',
    'clientPwd.errorSendEmail': '发送邮件出错',
    'clientPwd.errorSendBulk': '批量发送出错',
    'clientPwd.bulkResult': '已发送 {{sent}} 封邮件，{{errors}} 个错误',
    'clientPwd.totalClients': '共 {{total}} 位客户',
    'clientPwd.sending': '发送中...',
    'clientPwd.sendToClients': '发送给 {{count}} 位客户',
    'clientPwd.searchPlaceholder': '按姓名、电话、邮箱搜索...',
    'clientPwd.filterAll': '全部',
    'clientPwd.filterSent': '密码已发送',
    'clientPwd.filterNotSent': '密码未发送',
    'clientPwd.colName': '姓名',
    'clientPwd.colPhone': '电话',
    'clientPwd.colEmail': '邮箱',
    'clientPwd.colPin': 'PIN 码',
    'clientPwd.colStatus': '状态',
    'clientPwd.colActions': '操作',
    'clientPwd.loading': '加载中...',
    'clientPwd.noEmail': '无邮箱',
    'clientPwd.statusSent': '已发送',
    'clientPwd.statusPending': '待发送',
    'clientPwd.statusNotGenerated': '未生成',
    'clientPwd.genPinTitle': '生成 PIN 码',
    'clientPwd.resend': '重新发送',
    'clientPwd.pageOf': '第 {{page}} / {{total}} 页',
    'stockInv.error.pickMagasin': '请先为本次盘点选择门店。',
    'stockInv.error.analyzeFailed': '分析失败——请检查 OpenAI 密钥或重试。',
    'stockInv.error.server': '服务器错误',
    'stockInv.dropdown.refLabel': '货号：',
    'stockInv.short.boutique': '店',
    'stockInv.short.depot': '仓',
    'stockInv.summary.title': '盘点汇总',
    'stockInv.summary.subtitle': '已保存 {{count}} 件商品',
    'stockInv.summary.statusNew': '新建',
    'stockInv.summary.statusUpdated': '已更新',
    'stockInv.summary.errorsTitle': '错误',
    'stockInv.summary.created': '已创建 {{count}}',
    'stockInv.summary.updated': '已更新 {{count}}',
    'stockInv.summary.pieces': '{{count}} 件',
    'stockInv.btn.printLabels': '打印标签',
    'stockInv.btn.newInventory': '新建盘点',
    'stockInv.btn.printCount': '打印 ({{count}})',
    'stockInv.btn.addRow': '添加行',
    'stockInv.btn.scan': '扫描',
    'stockInv.btn.csvImport': '导入 CSV',
    'stockInv.btn.csvExport': '导出',
    'stockInv.btn.saving': '保存中…',
    'stockInv.btn.saveAll': '全部保存 ({{count}})',
    'stockInv.col.status': '状态',
    'stockInv.col.reference': '货号',
    'stockInv.col.designation': '品名',
    'stockInv.col.pAchat': '进价',
    'stockInv.col.pVente': '售价',
    'stockInv.col.lieu': '位置',
    'stockInv.col.qteAjoutee': '新增数量',
    'stockInv.col.stockTotal': '总库存',
    'stockInv.col.magasin': '门店',
    'stockInv.col.prixAchat': '进价 (€)',
    'stockInv.col.prixVente': '售价 (€)',
    'stockInv.col.emplacement': '位置',
    'stockInv.col.qte': '数量',
    'stockInv.col.fournisseur': '供应商',
    'stockInv.location.boutique': '门店',
    'stockInv.location.depot': '仓库',
    'stockInv.header.title': '库存盘点',
    'stockInv.header.subtitleMagasin': '快速录入 · {{magasin}}',
    'stockInv.header.subtitleNoMagasin': '快速录入 · 请选择门店',
    'stockInv.warn.pickMagasin': '保存盘点前请先选择门店。',
    'stockInv.cross.title': '{{count}} 个货号已存在于其他门店',
    'stockInv.cross.explain': '你在目标门店创建了一条新行。如果这是有意为之（各门店独立库存），请忽略此消息。如果你想转移，请前往',
    'stockInv.cross.explainTransfer': '→ 转移。',
    'stockInv.cross.createdIn': '在 {{magasin}} 创建',
    'stockInv.cross.existedIn': '原存在于',
    'stockInv.cross.noMagasin': '— 无门店 —',
    'stockInv.cross.qty': '数量',
    'stockInv.badge.existing': '已有',
    'stockInv.badge.new': '新',
    'stockInv.placeholder.refEan': '货号 / EAN',
    'stockInv.placeholder.ean13': 'EAN13 条码',
    'stockInv.placeholder.productName': '产品名称',
    'stockInv.placeholder.fournisseur': '供应商',
    'stockInv.footer.rows': '行',
    'stockInv.footer.toSave': '待保存',
    'stockInv.footer.existingCount': '({{count}} 个已有)',
    'stockInv.footer.newCount': '({{count}} 个新)',
    'stockInv.footer.piecesAndValue': '{{count}} 件 · 进货 {{value}}',
    'stockInv.hint.enterBefore': '按',
    'stockInv.hint.enterKey': '回车',
    'stockInv.hint.enterAfter': '跳到下一行',
    'stockInv.review.title': '盘点预分析',
    'stockInv.review.subtitle': '{{count}} 行 · 门店 {{magasin}}',
    'staffChat.statusOnline': '在线',
    'staffChat.statusBusy': '忙碌',
    'staffChat.statusAway': '离开',
    'staffChat.statusOffline': '离线',
    'staffChat.colorYellow': '黄色',
    'staffChat.colorBlue': '蓝色',
    'staffChat.colorGreen': '绿色',
    'staffChat.colorOrange': '橙色',
    'staffChat.colorPurple': '紫色',
    'staffChat.colorCyan': '青色',
    'staffChat.colorRed': '红色',
    'staffChat.quickRepliesTitle': '快捷回复',
    'staffChat.quickRepliesSubtitle': '自定义聊天回复',
    'staffChat.qrLabelPlaceholder': '标签（例如：已就绪！）',
    'staffChat.qrTextPlaceholder': '消息内容...',
    'staffChat.qrSaveEdit': '保存',
    'staffChat.cancel': '取消',
    'staffChat.add': '添加',
    'staffChat.filterAll': '全部',
    'staffChat.filterTeam': '团队',
    'staffChat.filterClients': '客户',
    'staffChat.filterTickets': '工单',
    'staffChat.filterQuick': '快捷',
    'staffChat.messaging': '消息',
    'staffChat.newConversation': '新会话',
    'staffChat.searchPlaceholder': '搜索会话...',
    'staffChat.noStaffAvailable': '没有可用成员',
    'staffChat.labelTeam': '团队',
    'staffChat.labelOrder': '订单',
    'staffChat.labelRepair': '维修',
    'staffChat.labelClient': '客户',
    'staffChat.priorityUrgent': '紧急',
    'staffChat.priorityMedium': '中等',
    'staffChat.priorityNormal': '普通',
    'staffChat.ticketsNone': '没有待处理工单',
    'staffChat.ticketsAllHandled': '所有消息都已处理',
    'staffChat.timeAgoLessThanHour': '不到 1 小时前',
    'staffChat.timeAgoHours': '{{h}} 小时前',
    'staffChat.viewConversation': '查看会话',
    'staffChat.close': '关闭',
    'staffChat.recentlyClosed': '最近关闭',
    'staffChat.closedBy': '由 {{name}}',
    'staffChat.noConversations': '没有会话',
    'staffChat.conversation': '会话',
    'staffChat.startConversation': '开始会话',
    'staffChat.endToEndEncrypted': '消息采用端到端加密',
    'staffChat.aiAssistant': 'AI 助手',
    'staffChat.autoBadge': '自动',
    'staffChat.nudgeTitle': '发送抖动提醒！',
    'staffChat.sending': '发送中...',
    'staffChat.messagePlaceholder': '写一条消息...',
    'staffChat.selectConversation': '选择一个会话',
    'staffChat.chooseFromList': '从左侧列表中选择',
    'warnDuplicateReference': '已在库存 — 保存时 +1',
    'warnDuplicateEan': 'EAN 已在库存 — 保存时 +1',
    'warnCrossMagasin': '该参考号在另一家门店',
    'warnLowVision': '照片识别不确定',
    'warnPrixAchatManual': '需手动输入进货价',
    'warnLlmUnavailable': 'AI 视觉不可用（API 密钥）',
    'alertAddPhotoOrText': '请添加照片或粘贴标签文本。',
    'errAnalyzePhoto': '照片分析出错',
    'alertEnterPrixAchat': '请输入进货价以重新计算售价。',
    'errCalcPrice': '价格计算出错',
    'alertRefDesignationRequired': '需要参考号和品名。',
    'alertPrixVenteRequired': '需要售价。',
    'noticeAddedToList': '+{{qty}} 加入列表：{{designation}}（共 +{{total}}）',
    'noticeStockUpdate': '库存更新：{{designation}}（+{{qty}}）',
    'noticeAdded': '已添加：{{designation}}（×{{qty}}）',
    'errServer': '服务器错误',
    'alertChooseMagasin': '请选择门店。',
    'errAnalyzeImpossible': '无法分析',
    'summaryTitle': '已保存的商品',
    'summarySubtitle': '新建 {{created}} · 更新 {{updated}} · 待打印 {{labels}} 个标签',
    'printLabels': '打印标签（{{count}}）',
    'newSession': '新会话',
    'colStatut': '状态',
    'colReference': '参考号',
    'colDesignation': '品名',
    'colPrixAchat': '进货价',
    'colPrixVente': '售价',
    'colQtyAdded': '新增数量',
    'badgeNew': '新增',
    'badgeAddStock': '+库存',
    'pageTitle': '分析商品',
    'pageSubtitle': '扫描多个商品 · 逐行确认 · 一次性全部保存',
    'pendingList': '待处理列表 — {{count}} 项 · {{pieces}} 件',
    'saveAll': '全部保存（{{count}}）',
    'badgeUpdate': '更新',
    'depot': '仓库',
    'boutique': '门店',
    'stockAbbrev': '库存 店:{{boutique}} 仓:{{depot}}',
    'remove': '移除',
    'photoSectionTitle': '商品照片',
    'productAlt': '商品',
    'photoHint': '相册或相机 — 包装或标签（EAN 可见）',
    'gallery': '相册',
    'camera': '相机',
    'analyzing': '分析中…',
    'analyze': '分析',
    'aiVisionOption': '标签无法识别时使用 AI 视觉（OpenAI / Gemini）',
    'labelTextLabel': '标签文本（可选 — 如果条形码无法识别）',
    'labelTextPlaceholder': 'iPhone 8 OLED 屏幕\nEAN 3701234567890\nRef IP8-LCD-001',
    'emptyHint': '运行分析以预填库存表单。',
    'analyzingHint': '正在识别标签并查找供应商…',
    'alreadyInStockPrefix': '已在库存（{{magasin}}）— 保存 =',
    'alreadyInStockSuffix': '（门店 {{boutique}} · 仓库 {{depot}}）',
    'alreadyInListPrefix': '已在列表中（×{{qty}}）— 接受 =',
    'alreadyInListSuffix': '加入列表',
    'currentStockBoutique': '（当前门店库存：{{qty}}）',
    'resultTitle': '分析结果',
    'readConfidence': '识别置信度：{{pct}}%',
    'aiVision': 'AI 视觉',
    'matchLabel': '匹配',
    'fieldDesignation': '品名 *',
    'fieldReference': '参考号 *',
    'fieldCategorie': '类别',
    'fieldFournisseur': '供应商',
    'otherSupplierParts': '其他供应商配件',
    'tarifsTitle': '价格',
    'fieldPrixAchat': '进货价 (€)',
    'autoSupplierCache': '供应商自动缓存',
    'fieldPrixVente': '售价 (€)',
    'recalcVente': '重新计算售价',
    'laborLabel': '工时费：{{amount}}',
    'detailTitle': '自动报价计算明细',
    'detailAchat': '进货：',
    'detailPort': '运费：',
    'detailDouane': '关税：',
    'detailCoutPiece': '单件成本：',
    'detailFinal': '最终：',
    'qtyLocationTitle': '数量与位置',
    'quantite': '数量',
    'quit': '退出',
    'acceptPlusOne': '接受（+1）',
    'acceptLine': '接受该行',
    'acceptHelp': '列表或库存重复 = 自动 +1 · 然后「全部保存」· 最后打印标签。',
    'reviewTitleAccept': '这一行正确吗？',
    'reviewTitleBulk': '保存前检查',
    'reviewSubtitleAccept': '确认后加入列表，然后扫描下一个商品',
    'reviewBulkSubtitle': '{{count}} 项待保存到库存',
    'avoirs.title': '贷记单',
    'avoirs.subtitle': '由小票或发票生成的顾客贷记 — 可在收银台使用',
    'avoirs.refresh': '刷新',
    'avoirs.errorLoad': '加载贷记单出错',
    'avoirs.searchPlaceholder': '贷记单号、客户、原始小票…',
    'avoirs.allStatuses': '全部状态',
    'avoirs.empty': '暂无贷记单',
    'avoirs.colRef': '单号',
    'avoirs.colClient': '客户',
    'avoirs.colOrigin': '来源',
    'avoirs.colInitial': '初始金额',
    'avoirs.colSolde': '余额',
    'avoirs.colStatut': '状态',
    'avoirs.colDate': '日期',
    'avoirs.createdBy': '创建人',
    'avoirs.originLabel': '来源：',
    'avoirs.motifLabel': '原因：',
    'avoirs.clientLabel': '客户：',
    'avoirs.printTicket': '打印贷记小票',
    'avoirs.downloadPdf': '下载 PDF',
    'avoirs.historyTitle': '变动记录',
    'avoirs.cancelRemaining': '取消剩余余额',
    'avoirs.confirmCancel': '取消 {{ref}} 的剩余余额？',
    'avoirs.close': '关闭',
    'avoirs.statutDisponible': '可用',
    'avoirs.statutPartiel': '部分已使用',
    'avoirs.statutUtilise': '已使用',
    'avoirs.statutAnnule': '已取消',
    'stockMov.tab.dashboard': '仪表板',
    'stockMov.tab.movements': '库存变动',
    'stockMov.tab.imei': 'IMEI / 序列号',
    'stockMov.tab.inventory': '盘点',
    'stockMov.header.title': '高级库存',
    'stockMov.header.subtitle': '库存变动 · IMEI · 盘点会话 · 仪表板',
    'stockMov.cancel': '取消',
    'stockMov.save': '保存',
    'stockMov.saving': '保存中...',
    'stockMov.loadError': '加载错误',
    'stockMov.error': '错误：{{detail}}',
    'stockMov.loading': '加载中…',
    'stockMov.pageOf': '第 {{page}} / {{total}} 页',
    'stockMov.kpi.totalArticles': '商品总数',
    'stockMov.kpi.qteBoutique': '门店数量',
    'stockMov.kpi.qteDepot': '仓库数量',
    'stockMov.kpi.ruptures': '缺货',
    'stockMov.kpi.imeiEnStock': '在库 IMEI',
    'stockMov.boutique': '门店',
    'stockMov.depot': '仓库',
    'stockMov.total': '合计',
    'stockMov.valeurAchat': '采购价值',
    'stockMov.valeurVente': '销售价值',
    'stockMov.marge': '毛利',
    'stockMov.margeTotale': '总毛利',
    'stockMov.stocksNegatifs': '负库存（{{count}}）',
    'stockMov.aucunStockNegatif': '无负库存',
    'stockMov.articlesSousSeuil': '低于阈值的商品（{{count}}）',
    'stockMov.tousAuDessusSeuil': '所有商品均高于其预警阈值',
    'stockMov.filter.all': '全部',
    'stockMov.filter.entrees': '入库',
    'stockMov.filter.sorties': '出库',
    'stockMov.magasinLabel': '门店：',
    'stockMov.nouveauMouvement': '新建变动',
    'stockMov.col.date': '日期',
    'stockMov.col.type': '类型',
    'stockMov.col.motif': '原因',
    'stockMov.col.article': '商品',
    'stockMov.col.magasin': '门店',
    'stockMov.col.qte': '数量',
    'stockMov.col.stockAvant': '变动前库存',
    'stockMov.col.stockApres': '变动后库存',
    'stockMov.col.imei': 'IMEI',
    'stockMov.col.par': '操作人',
    'stockMov.aucunMouvement': '暂无记录的变动',
    'stockMov.type.transfert': '调拨',
    'stockMov.type.entree': '入库',
    'stockMov.type.sortie': '出库',
    'stockMov.modalNewMovement': '新建库存变动',
    'stockMov.field.motif': '原因',
    'stockMov.field.article': '商品',
    'stockMov.searchArticlePlaceholder': '搜索商品...',
    'stockMov.refStock': '（{{ref}}）库存：{{qty}}',
    'stockMov.refShort': '编号：{{ref}}',
    'stockMov.field.quantite': '数量',
    'stockMov.field.prixUnitaire': '单价',
    'stockMov.field.imeiOptional': 'IMEI / 序列号（可选）',
    'stockMov.imeiPlaceholder': '例如：353012345678901',
    'stockMov.field.noteOptional': '备注（可选）',
    'stockMov.commentPlaceholder': '备注...',
    'stockMov.imeiRefRequired': '需填写 IMEI 和编号',
    'stockMov.refQtyRequired': '需填写编号和数量',
    'stockMov.registreTitle': 'IMEI 登记簿 — 手机溯源',
    'stockMov.registreDesc': '每台在库设备都必须有唯一的 IMEI。可用于追溯其历史记录（采购、POS 销售、维修）。',
    'stockMov.nouveauTelephone': '新建手机',
    'stockMov.searchImeiPlaceholder': '搜索 IMEI、商品...',
    'stockMov.tousLesStatuts': '全部状态',
    'stockMov.enregistrerImei': '登记 IMEI',
    'stockMov.col.imeiSerie': 'IMEI / 序列号',
    'stockMov.col.refDot': '编号',
    'stockMov.col.magShort': '门店',
    'stockMov.col.etat': '成色',
    'stockMov.col.statut': '状态',
    'stockMov.col.origine': '来源',
    'stockMov.aucunImei': '暂无 IMEI — 请先将手机加入库存，然后在此登记其号码。',
    'stockMov.historique': '历史记录',
    'stockMov.historiqueImei': '历史记录 · {{imei}}',
    'stockMov.byUser': '操作人：{{user}}',
    'stockMov.aucunMouvementImei': '没有与该 IMEI 关联的变动。',
    'stockMov.modalRegisterImei': '登记 IMEI / 序列号',
    'stockMov.field.articleStockRef': '库存商品（编号）',
    'stockMov.searchPlaceholder': '搜索...',
    'stockMov.field.etat': '成色',
    'stockMov.field.origine': '来源',
    'stockMov.origine.achat': '采购',
    'stockMov.origine.reprise_client': '客户以旧换新',
    'stockMov.origine.transfert': '调拨',
    'stockMov.etat.neuf': '全新',
    'stockMov.etat.occasion': '二手',
    'stockMov.etat.reconditionne': '翻新',
    'stockMov.etat.hs': '故障',
    'stockMov.statut.en_stock': '在库',
    'stockMov.statut.vendu': '已售',
    'stockMov.statut.reserve': '已预留',
    'stockMov.statut.en_reparation': '维修中',
    'stockMov.motif.achat_fournisseur': '供应商采购',
    'stockMov.motif.retour_client': '客户退货',
    'stockMov.motif.correction_inventaire': '盘点更正',
    'stockMov.motif.transfert_entrant': '调入',
    'stockMov.motif.reception_commande': '订单收货',
    'stockMov.motif.reintegration_reparation': '维修回库',
    'stockMov.motif.vente_pos': 'POS 销售',
    'stockMov.motif.consommation_reparation': '维修耗用',
    'stockMov.motif.perte_casse': '损耗 / 破损',
    'stockMov.motif.retour_fournisseur': '退回供应商',
    'stockMov.motif.transfert_sortant': '调出',
    'stockMov.motif.ajustement_inventaire': '盘点调整',
    'stockMov.sessionsInventaire': '盘点会话',
    'stockMov.nouvelInventaire': '新建盘点',
    'stockMov.aucuneSession': '暂无盘点会话',
    'stockMov.parUser': '操作人：{{user}}',
    'stockMov.articlesEcarts': '{{articles}} 件商品，{{ecarts}} 处差异',
    'stockMov.status.enCours': '进行中',
    'stockMov.status.valide': '已确认',
    'stockMov.retourSessions': '返回会话列表',
    'stockMov.statutColon': '状态：',
    'stockMov.validePar': '由 {{user}} 确认',
    'stockMov.validerSansCorrection': '确认但不更正',
    'stockMov.validerCorriger': '确认并更正库存',
    'stockMov.comptagePhysique': '实物盘点',
    'stockMov.searchArticleShort': '搜索商品...',
    'stockMov.inv.bdShort': '店:{{b}} 仓:{{d}}',
    'stockMov.stockSelectionne': '已选库存：',
    'stockMov.dotBoutique': '· 门店 {{q}}',
    'stockMov.dotDepot': '· 仓库 {{q}}',
    'stockMov.qteComptee': '已盘数量',
    'stockMov.col.stockTheorique': '理论库存',
    'stockMov.col.comptagePhysique': '实物盘点',
    'stockMov.col.ecart': '差异',
    'stockMov.col.comptePar': '盘点人',
    'stockMov.aucunArticleCompte': '尚未盘点任何商品。请在上方开始盘点。',
    'stockMov.modalNewSession': '新建盘点会话',
    'stockMov.field.titreOptional': '标题（可选）',
    'stockMov.titrePlaceholder': '例如：2026 年 3 月月度盘点',
    'stockMov.creating': '创建中...',
    'stockMov.creer': '创建',
    'stockMov.confirmValidateApply': '确认并应用库存更正？',
    'stockMov.confirmValidateNoApply': '确认但不应用更正？',
    'stockMov.sessionValidee': '会话已确认！',
    'stockMov.countSaved': '盘点已保存：理论库存 {{theorique}}，实物 {{physique}}，差异 {{ecart}}',
    'stock.err.templateDownload': '下载模板时出错',
    'stock.err.missingId': '错误：缺少商品 ID',
    'stock.deleteSuccess': '商品已成功删除',
    'stock.err.delete': '删除时出错',
    'stock.confirmDeleteMany': '删除 {{count}} 件商品？',
    'stock.err.update': '更新时出错',
    'stock.err.transfer': '转移时出错',
    'stock.err.bulkTransfer': '批量转移时出错',
    'stock.depotOnlyM1': '目前仓库仅在 M1 可用。',
    'stock.sameSourceDest': '来源和目标相同。',
    'stock.noLineToTransfer': '没有可转移的行（数量为零或来源门店 = 目标门店）。',
    'stock.confirmBulkPublish': '将 {{count}} 件商品上线销售？',
    'stock.confirmBulkUnpublish': '将 {{count}} 件商品从线上销售中下架？',
    'stock.confirmPublishOne': '将“{{name}}”上线销售？',
    'stock.confirmUnpublishOne': '将“{{name}}”从线上销售中下架？',
    'stock.importDone': '导入完成',
    'stock.importCreated': '已创建',
    'stock.importUpdated': '已更新',
    'stock.importSkipped': '已跳过',
    'stock.importErrors': '错误',
    'stock.importRetryHint': '已有 {{count}} 件商品存在——请以“更新”模式重新运行。',
    'stock.importRetryBtn': '以更新模式重试',
    'stock.importViewErrors': '查看 {{count}} 个错误',
    'stock.transferTitle': '库存转移',
    'stock.boutique': '门店',
    'stock.depot': '仓库',
    'stock.sourceStore': '来源门店',
    'stock.sourceLocation': '来源位置',
    'stock.destStore': '目标门店',
    'stock.destLocation': '目标位置',
    'stock.quantity': '数量',
    'stock.availableAtSource': '来源可用：{{count}}',
    'stock.cancel': '取消',
    'stock.transferring': '转移中…',
    'stock.transfer': '转移',
    'stock.bulkTransferTitle': '更改 {{count}} 件商品的门店',
    'stock.location': '位置',
    'stock.bulkTransferR1Note': '转移遵循 R1 规则：来源单据清空后数量保持为 0，并在目标门店创建新单据。',
    'stock.colArticle': '商品',
    'stock.colCurrentStore': '当前门店',
    'stock.colStock': '库存',
    'stock.colQtyToTransfer': '要转移的数量',
    'stock.runTransfer': '开始转移',
    'stock.resultSucceeded': '成功',
    'stock.resultFailed': '失败',
    'stock.resultUnitsTransferred': '已转移单位',
    'stock.failuresLabel': '失败项：',
    'stock.done': '完成',
    'stock.storeN': '门店 {{n}}',
    'stock.tab.view': '概览',
    'stock.tab.inventory': '盘点',
    'stock.tab.analyze': '分析产品',
    'stock.tab.history': '历史',
    'stock.tab.supplierOrders': '供应商补货',
    'stock.tab.invoiceImport': 'AI 发票导入',
    'stock.tab.labels': '标签',
    'stock.tab.advanced': '高级库存',
    'stock.tab.reconciliation': '对账',
    'stock.tab.config': '配置',
    'posV2.remisePlafonneeMsg': '折扣上限为 {{pct}}%。超过此限额需经管理层批准。',
    'posV2.venteNonEnregRemiseRamenee': '销售未记录——折扣已降回上限；请核对总额后重新收款。',
    'posV2.remiseRameneeVerif': '折扣已降回上限——请核对总额后收款。',
    'posV2.catalogUnavailable': '目录不可用',
    'posV2.paymentRefusedTpe': '刷卡终端上的付款被拒绝或取消——请重试。',
    'posV2.caisseClosedOpenFirst': '收银机 {{mag}} 已关闭——请先打开再收款',
    'posV2.sumupCheckoutDesc': 'POS V2 · {{count}} 行',
    'posV2.sumupTerminalNotConnected': 'SumUp 终端未连接',
    'posV2.sumupSaleNotSaved': '{{msg}}。销售未记录（库存不变）。请确认刷卡终端已开机并已连接。',
    'posV2.cartEmpty': '购物车空',
    'posV2.lookupValidAvoir': '收款前请先查找有效的贷记单',
    'posV2.printError': '打印错误',
    'posV2.caisseClosedBanner': '收银机 {{mag}} 已关闭。',
    'posV2.open': '打开',
    'posV2.oneEncaissementMultiStock': '1 笔收款 {{mag}} · 多门店库存',
    'posV2.catalog': '目录',
    'posV2.ficheButtonHint': '“详情”按钮 → 照片库',
    'posV2.all': '全部',
    'posV2.stockMag': '库存 {{mag}}',
    'posV2.catalogPlaceholder': '目录…',
    'posV2.go': '搜索',
    'posV2.catalogMeta': '{{total}} 个参考 · {{scope}} · 第{{page}}/{{pages}}页',
    'posV2.enterAvoirRefOrClient': '请输入贷记单参考号或客户姓名',
    'posV2.avoirNotFound': '未找到贷记单',
    'posV2.productSheet': '产品详情',
    'posV2.productSheetSub': '图库 · 库存 · 加入购物车',
    'posV2.ticketCenter': '小票中心',
    'posV2.ticketCenterSub': '最近小票 · 重新打印',
    'posV2.savStation': '售后维修台',
    'posV2.savStationSub': '查找工单 · 收取余款 · 定金 · 购物车',
    'posV2.horsStock': '无库存',
    'posV2.horsStockSub': '临时商品销售 · 无库存标记 · 直接收款',
    'posV2.clientCenter': '客户中心',
    'posV2.clientCenterSub': '历史 · 会员积分 · 关联到本次收款',
    'posV2.orders': '订单',
    'posV2.ordersSub': '客户需求 · 订单 · 定金 · 购物车',
    'openCaisse.denomBill': '纸币',
    'openCaisse.denomCoin': '硬币',
    'openCaisse.cardTotal': '合计',
    'openCaisse.successOpen': '收银台 {{magasin}} 已成功开启。',
    'openCaisse.errorOpen': '打开收银台时出错',
    'openCaisse.backToDashboard': '返回仪表板',
    'openCaisse.title': '开启收银台 {{magasin}}',
    'openCaisse.titleForce': '强制开启收银台 {{magasin}}',
    'openCaisse.openingFund': '开账备用金',
    'openCaisse.openingFundHint': '请输入收银台 {{magasin}} 的纸币和硬币。',
    'openCaisse.totalOpening': '开账合计',
    'openCaisse.forceWarning': '此操作将关闭目标门店已开启的收银台，然后以此金额新建一个收银台。',
    'openCaisse.cancel': '取消',
    'openCaisse.opening': '正在开启...',
    'openCaisse.validateOpening': '确认开启',
    'calcul.title': '价格 / 报价计算工具',
    'calcul.subtitle': '与 PHP 计算器相同的界面 + 生成 80mm 和 A4 PDF。',
    'calcul.clientSection': '客户信息',
    'calcul.clientName': '客户姓名',
    'calcul.phone': '电话',
    'calcul.email': '电子邮箱',
    'calcul.saveClient': '保存客户',
    'calcul.deviceSection': '选择设备',
    'calcul.brand': '品牌',
    'calcul.model': '型号',
    'calcul.itemsSection': '项目',
    'calcul.itemDescription': '配件 / 名称',
    'calcul.itemReference': '配件编号',
    'calcul.itemPurchasePrice': '进货价',
    'calcul.addLine': '添加一行',
    'calcul.paramsSection': '参数',
    'calcul.quantity': '数量',
    'calcul.labor': '工时费 (€)',
    'calcul.partReference': '配件编号',
    'calcul.supplier': '供应商',
    'calcul.docType': '文档类型',
    'calcul.docTypeDevis': '报价单',
    'calcul.docTypeFacture': '发票',
    'calcul.docTypeProforma': '形式发票',
    'calcul.acceptOnlinePayment': '接受在线支付 (SumUp)',
    'calcul.acceptOnlinePaymentHint': '客户可以申请 SumUp 付款链接',
    'calcul.saveTicket': '✅ 保存小票',
    'calcul.saving': '正在保存...',
    'calcul.preview': '👁️ 预览',
    'calcul.previewSection': '预览',
    'calcul.previewIframeTitle': '小票预览',
    'calcul.previewEmpty': '运行计算以显示小票。',
    'calcul.printTicket': '打印小票',
    'calcul.transformA4': '转换为 A4 报价单',
    'calcul.totalArticles': '项目总额',
    'calcul.totalPurchase': '进货总额',
    'calcul.shippingFees': '运费',
    'calcul.customsFees': '关税费用',
    'calcul.costPerPiece': '每件成本',
    'calcul.finalPrice': '最终价格',
    'calcul.alertAllowPopups': '请允许弹出窗口以进行打印。',
    'calcul.alertAddItem': '请至少添加一个带进货价的项目。',
    'calcul.ticketSaved': '✅ 小票已保存。',
    'calcul.errorGenerateTicket': '生成小票时出错',
    'calcul.errorPrintTicket': '打印小票出错',
    'calcul.errorGenerateA4': '生成 A4 报价单时出错',
    'caisseHist.errPrint': '收银打印出错',
    'caisseHist.errPrintGeneric': '打印出错',
    'caisseHist.errLoadMonthly': '加载月度记录出错',
    'caisseHist.errExport': '导出会计数据出错',
    'caisseHist.confirmForceClose': '强制关闭 {{date}} 的收银？此操作不可撤销。',
    'caisseHist.errForceClose': '强制关闭时出错',
    'caisseHist.title': '收银开台 / 关台记录',
    'caisseHist.month': '月份',
    'caisseHist.store': '门店',
    'caisseHist.allStores': '所有门店',
    'caisseHist.exportAccounting': '会计导出',
    'caisseHist.totalSales': '销售合计',
    'caisseHist.totalCash': '现金合计',
    'caisseHist.totalCard': '刷卡合计',
    'caisseHist.withdrawals': '取款',
    'caisseHist.totalTheoretical': '理论合计',
    'caisseHist.totalAccounting': '记账合计',
    'caisseHist.discrepancy': '差额',
    'caisseHist.validatedBy': '验证人',
    'caisseHist.validationDate': '验证日期',
    'caisseHist.noValidatedCaisse': '没有已验证的收银。',
    'caisseHist.opening': '开台',
    'caisseHist.closing': '关台',
    'caisseHist.caisse': '收银',
    'caisseHist.daySales': '当日销售',
    'caisseHist.dateStart': '开始日期',
    'caisseHist.dateEnd': '结束日期',
    'caisseHist.reset': '重置',
    'caisseHist.cashFloat': '备用金',
    'caisseHist.openedBy': '开台人',
    'caisseHist.closedBy': '关台人',
    'caisseHist.noHistory': '暂无可用记录',
    'caisseHist.closingProgress': '关闭中...',
    'caisseHist.forceClose': '强制关闭',
    'caisseHist.forced': '强制',
    'caisseHist.showMore': '查看更多（{{count}} 条此前的开台）',
    'caisseHist.showLess': '收起',
    'repairDetail.popupBlocked': '请允许弹出窗口以进行打印。',
    'repairDetail.downloadError': '下载出错',
    'repairDetail.statusUpdateError': '更新出错',
    'repairDetail.invalidAmount': '金额无效',
    'repairDetail.genericError': '出错',
    'repairDetail.filesAttached': '已附加 {{count}} 个文件',
    'repairDetail.uploadProgress': '上传中 {{current}}/{{total}}…',
    'repairDetail.addNoteError': '添加备注时出错',
    'repairDetail.confirmDeleteNote': '删除此备注？',
    'repairDetail.notFound': '未找到该维修',
    'repairDetail.backToRepairs': '返回维修列表',
    'repairDetail.photosTitle': '照片 ({{count}})',
    'repairDetail.photoAlt': '照片 {{index}}',
    'repairDetail.notesTitle': '备注 ({{count}})',
    'repairDetail.notePlaceholder': '添加备注…',
    'repairDetail.visibilityPublic': '公开',
    'repairDetail.visibilityInternal': '内部',
    'repairDetail.filesBtn': '文件',
    'repairDetail.sending': '发送中…',
    'repairDetail.add': '添加',
    'repairDetail.noNotes': '暂无备注',
    'repairDetail.staffDefault': '员工',
    'repairDetail.printAcompteError': '打印定金凭条出错',
    'repairDetail.printAvoirError': '打印贷记单凭条出错',
    'repairDetail.downloadPdfError': 'PDF 下载出错',
    'repairDetail.changeStatus': '更改状态',
    'repairDetail.noStatusChange': '无可用的状态更改',
    'repairDetail.addDeposit': '添加定金',
    'repairDetail.amountLabel': '金额 (€)',
    'repairDetail.paymentMode': '支付方式',
    'repairDetail.paymentCash': '现金',
    'repairDetail.paymentCard': '银行卡',
    'repairDetail.paymentTransfer': '转账',
    'repairDetail.paymentCheck': '支票',
    'repairDetail.cancel': '取消',
    'repairDetail.statusRecu': '已接收',
    'repairDetail.statusEnCours': '处理中',
    'repairDetail.statusAttentePieces': '等待配件',
    'repairDetail.statusPieceArrivee': '配件已到',
    'repairDetail.statusNonReparable': '无法维修',
    'repairDetail.statusTermine': '已完成',
    'repairDetail.statusLivre': '已交付',
    'repairDetail.statusAttenteDepot': '等待送修',
    'closeCaisse.denomBillet': '纸币',
    'closeCaisse.denomPiece': '硬币',
    'closeCaisse.countBadge': '× {{count}}',
    'closeCaisse.total': '合计',
    'closeCaisse.errLoad': '加载收银台时出错',
    'closeCaisse.errPdf': '生成 PDF 时出错',
    'closeCaisse.errConfirmCb': '请在关闭收银台前确认刷卡支付',
    'closeCaisse.confirmEcart': '注意：检测到 {{ecart}} 的差额。\n\n理论总额：{{theorique}}\n清点总额：{{compte}}\n\n是否继续？',
    'closeCaisse.closeSuccess': '收银台 {{magasin}} 已成功关闭。',
    'closeCaisse.errClose': '关闭收银台时出错',
    'closeCaisse.backToDashboard': '返回仪表板',
    'closeCaisse.journee': '营业日 {{date}}',
    'closeCaisse.openedBy': '由 {{name}} 开启',
    'closeCaisse.refresh': '刷新',
    'closeCaisse.summaryTitle': '收银台汇总',
    'closeCaisse.activitySummary': '门店 {{magasin}} 活动 — {{ops}} 笔操作（{{pos}} 笔 POS 销售，{{acomptes}} 笔预付款）。',
    'closeCaisse.fondOuverture': '开账备用金',
    'closeCaisse.ventesEspeces': '现金销售',
    'closeCaisse.ventesCb': '刷卡销售',
    'closeCaisse.paiementsStripe': 'Stripe 支付',
    'closeCaisse.acomptes': '预付款',
    'closeCaisse.retraits': '取出',
    'closeCaisse.totalTheorique': '理论总额',
    'closeCaisse.totalVentes': '销售总额：{{montant}}',
    'closeCaisse.activiteVendeur': '按销售员统计',
    'closeCaisse.colVendeur': '销售员',
    'closeCaisse.colOps': '笔数',
    'closeCaisse.colEspeces': '现金',
    'closeCaisse.colCb': '刷卡',
    'closeCaisse.comptageEspeces': '现金清点',
    'closeCaisse.comptageSubtitle': '纸币与硬币的可视化明细，用于关账。',
    'closeCaisse.totalCompte': '清点总额',
    'closeCaisse.ecart': '差额',
    'closeCaisse.ecartImportant': '检测到较大差额',
    'closeCaisse.infosComplementaires': '补充信息',
    'closeCaisse.montantCoffreLabel': '存入保险柜的金额（EUR）',
    'closeCaisse.montantCoffreHint': '存入保险柜的现金金额。',
    'closeCaisse.cbConfirmLabel': '我已确认刷卡支付',
    'closeCaisse.cbConfirmHint': '确认所有刷卡支付已在终端机上收款。',
    'closeCaisse.imprimerRapport': '打印报表',
    'closeCaisse.validerCaisse': '确认关账',
    'closeCaisse.onlyAdmin': '只有管理员才能确认关账',
    'paiements.title': '在线支付',
    'paiements.proofsToValidate': '{{count}} 个待审核凭证',
    'paiements.pendingCount': '{{count}} 个待处理',
    'paiements.tabSumup': 'SumUp 支付 ({{count}})',
    'paiements.tabProofs': '支付凭证 ({{count}})',
    'paiements.noProof': '暂无支付凭证',
    'paiements.orderDefault': '订单',
    'paiements.proofValidated': '已审核',
    'paiements.proofPendingValidation': '等待审核',
    'paiements.totalLabel': '总计：',
    'paiements.sentLabel': '发送时间：',
    'paiements.byLabel': '操作人：',
    'paiements.validatedByLabel': '审核人：',
    'paiements.viewCapture': '查看截图',
    'paiements.validatePayment': '确认付款',
    'paiements.reject': '拒绝',
    'paiements.confirmOrder': '确认订单',
    'paiements.filterAll': '全部',
    'paiements.filterPending': '待处理',
    'paiements.filterConfirmed': '已确认',
    'paiements.filterCancelled': '已取消',
    'paiements.noPayment': '暂无支付',
    'paiements.amountLabel': '金额：',
    'paiements.refLabel': '编号：',
    'paiements.dateLabel': '日期：',
    'paiements.ticketPdf': 'PDF 小票',
    'paiements.validate': '确认',
    'paiements.cancel': '取消',
    'paiements.statusPaidApplied': '已确认',
    'paiements.statusPaidPending': '待处理',
    'paiements.statusPending': '处理中',
    'paiements.statusCancelled': '已取消',
    'paiements.orderRepair': '维修 {{ref}}',
    'paiements.orderBoutique': '商店订单',
    'paiements.alertConfirmed': '付款已确认并应用！',
    'paiements.errorConfirm': '确认时出错',
    'paiements.confirmCancel': '取消此付款？',
    'paiements.error': '出错了',
    'paiements.errorTicket': '下载小票时出错',
    'paiements.confirmValidateProof': '审核此支付凭证？',
    'paiements.alertProofValidated': '付款已审核！',
    'paiements.confirmRejectProof': '拒绝此支付凭证？',
    'paiements.confirmConfirmOrder': '确认此订单？',
    'paiements.alertOrderConfirmed': '订单已确认！',
    'repairForm.deviceNotFound': '未找到设备',
    'repairForm.selectMagasinFirst': '请先选择承接此次维修的门店。',
    'repairForm.saveError': '保存时出错',
    'repairForm.conversionFromCommande': '从订单转换',
    'repairForm.prefillNotice': '信息已预填 · 定金（{{amount}}）将在完成时转入。',
    'repairForm.sectionMagasin': '门店',
    'repairForm.magasinLabel': '承接门店 *',
    'repairForm.selectMagasinOption': '— 选择门店 —',
    'repairForm.sectionForcedEntry': '强制录入',
    'repairForm.forcedEntryHint': '针对遗漏登记的送修：用实际送修日期录入维修（而非今天的日期）。',
    'repairForm.useBackdateLabel': '使用更早的送修日期',
    'repairForm.realDepotDateTime': '实际送修日期和时间',
    'repairForm.sectionClient': '客户',
    'repairForm.clientName': '客户姓名 *',
    'repairForm.phone': '电话 *',
    'repairForm.email': '电子邮箱',
    'repairForm.address': '地址',
    'repairForm.sectionDevice': '设备',
    'repairForm.brand': '品牌 *',
    'repairForm.model': '型号 *',
    'repairForm.problem': '故障',
    'repairForm.technician': '维修技师',
    'repairForm.selectOption': '— 选择 —',
    'repairForm.imeiSerial': 'IMEI / 序列号',
    'repairForm.deviceLock': '锁屏密码',
    'repairForm.sectionParts': '配件',
    'repairForm.defectivePartsHint': '接收时无法正常工作的部件',
    'repairForm.phoneDoesntTurnOn': '手机无法开机',
    'repairForm.sectionStockParts': '库存配件（可选）',
    'repairForm.stockPartsHint': '如果该配件在门店库存中，创建时将自动扣减，并按目录价重新计算维修价格。否则请在下方手动填写价格（理论报价）。',
    'repairForm.stockPartsTotal': '库存配件合计：{{amount}} — 如有库存则在创建时应用。',
    'repairForm.sectionPricing': '价格',
    'repairForm.priceRepair': '维修价格（€）',
    'repairForm.theoreticalQuote': '— 理论报价',
    'repairForm.priceDiagnostic': '检测价格（€）',
    'repairForm.receptionNotes': '接收备注',
    'repairForm.sectionPhotos': '照片',
    'repairForm.addPhoto': '添加',
    'repairForm.cancel': '取消',
    'repairForm.save': '保存',
    'repairForm.createRepair': '创建维修单',
    'repairForm.parts.speaker': '扬声器',
    'repairForm.parts.lcd': '屏幕',
    'repairForm.parts.front_cam': '前置摄像头',
    'repairForm.parts.back_cam': '后置摄像头',
    'repairForm.parts.microphone': '麦克风',
    'repairForm.parts.fingerprint': '指纹',
    'repairForm.parts.home_button': '主屏键',
    'repairForm.parts.volume_button': '音量键',
    'repairForm.parts.power_button': '电源键',
    'repairForm.parts.signal_carrier': '信号',
    'repairForm.parts.battery': '电池',
    'repairForm.parts.wifi_bt': 'Wi-Fi/蓝牙',
    'repairForm.parts.ear_speaker': '听筒',
    'repairForm.parts.charging_port': '充电口',
    'labels.barcodeAuto': 'EAN13 将自动生成',
    'labels.allowPopups': '请允许弹出窗口以进行打印。',
    'labels.selectAtLeastOne': '请至少选择一个产品',
    'labels.errorGenerate': '生成标签出错',
    'labels.infoNoEan': '提示：{{count}} 个产品没有 EAN — 已自动生成内部 EAN13。共计：{{total}} 个标签。',
    'labels.jobCreated': '已创建打印任务（{{count}} 个标签）。\nID：{{id}}...\nBixolon 代理将提取此批次。',
    'labels.jobNoEan': '\n注意：{{count}} 个没有 EAN（自动生成）。',
    'labels.errorBatch': '批量打印出错',
    'labels.generating': '正在生成...',
    'labels.generatePdf': '生成 PDF ({{count}})',
    'labels.previewPdf': 'PDF 预览 ({{count}})',
    'labels.printBixolon': '打印 Bixolon ({{count}})',
    'labels.clear': '清空',
    'labels.format': '格式',
    'labels.formatBixolon': 'Bixolon 50 × 30 毫米（热敏）',
    'labels.formatA4': 'A4 标签纸（旧版）',
    'labels.pageTitle': '产品标签',
    'labels.pageSubtitle': '可配置的产品标签',
    'labels.config': '配置',
    'labels.searchPlaceholder': '搜索产品...',
    'labels.boutique': '门店',
    'labels.depot': '仓库',
    'labels.deselectAll': '取消全选',
    'labels.colProduct': '产品',
    'labels.colPrice': '价格',
    'labels.colBoutiqueShort': '门店',
    'labels.colQtyToPrint': '打印数量',
    'labels.noProduct': '暂无产品',
    'labels.autoShort': '自动',
    'labels.previewTitle': '标签预览',
    'labels.refLabel': '编号：',
    'labels.selectedProducts': '已选产品',
    'labels.totalLabels': '标签总数',
    'labels.autoGenAtPdf': '在 PDF 中自动生成',
    'labels.selectToPreview': '选择一个产品以预览',
    'labels.batchVeryLarge': '批次非常大',
    'labels.batchConfirmTitle': '确认大批次',
    'labels.confirmBodyPrefix': '您将生成',
    'labels.confirmBodySuffix': '个标签。',
    'labels.estRoll': '≈ {{meters}} 米标签卷（50×30毫米）',
    'labels.estTime': '≈ {{minutes}} 分钟打印时间（约 1.5 秒/标签）',
    'labels.cancel': '取消',
    'labels.confirmAnyway': '仍然确认',
    'labels.continue': '继续',
    'rep.status.awaitingDeposit': '等待送修',
    'rep.status.received': '已接收',
    'rep.status.inProgress': '维修中',
    'rep.status.awaitingParts': '等待配件',
    'rep.status.completed': '已完成',
    'rep.status.notRepairable': '无法维修',
    'rep.status.delivered': '已交付',
    'rep.status.refused': '已拒绝',
    'rep.payCash': '现金',
    'rep.payCard': '银行卡',
    'rep.payTransfer': '转账',
    'rep.payCheck': '支票',
    'rep.accept': '接受',
    'rep.addError': '添加时出错',
    'rep.adminOnlyStatus': '只有管理员可以修改此状态。',
    'rep.allowPopups': '请允许弹出窗口以进行打印。',
    'rep.chatTitle': '维修聊天 {{ref}}',
    'rep.confirmArrivalAsk': '确认在店内收到设备 {{ref}}？',
    'rep.confirmArrivalDone': '设备已确认！维修现已启动。',
    'rep.confirmArrivalError': '确认时出错',
    'rep.created': '已创建',
    'rep.currentStatus': '当前状态：',
    'rep.deleteError': '删除时出错',
    'rep.deleteRecordAsk': '删除此记录？',
    'rep.deleteStatusAsk': '删除状态“{{name}}”？',
    'rep.depositAmountEuro': '定金金额 (€)',
    'rep.diagnosticPaid': '诊断费已付',
    'rep.diagnosticRemaining': '诊断费：剩余 {{amount}}',
    'rep.downloadError': '下载时出错',
    'rep.error': '错误',
    'rep.invalidAmount': '金额无效',
    'rep.newStatus': '新状态',
    'rep.noDeposits': '暂无已付定金',
    'rep.noOnlineRequests': '暂无待处理的在线请求',
    'rep.onlineRequests': '在线请求（{{count}}）',
    'rep.or': '或',
    'rep.pointAtTicketQr': '对准票据上的二维码',
    'rep.printAcompteError': '打印定金票据出错',
    'rep.qrPrintHint': '扫码跟踪您的维修进度',
    'rep.qrSearchPlaceholder': '例如 REM0094',
    'rep.qrTrackingHint': '客户扫描此二维码即可实时跟踪维修进度',
    'rep.qrTrackingTitle': '追踪二维码',
    'rep.reference': '参考编号：',
    'rep.repair': '维修',
    'rep.scanOrEnterRef': '扫描二维码或输入参考编号',
    'rep.scanWithCamera': '用相机扫描',
    'rep.searchRepair': '搜索维修单',
    'rep.statusManagement': '状态管理',
    'rep.ticket': '票据',
    'rep.updateError': '更新时出错',
    'rep.bulkNoteSentSingular': '备注已发送至 {{count}} 个工单{{skip}}。',
    'rep.bulkNoteSentPlural': '备注已发送至 {{count}} 个工单{{skip}}。',
    'rep.bulkNoteSkippedSingular': '（已跳过 {{count}} 个）',
    'rep.bulkNoteSkippedPlural': '（已跳过 {{count}} 个）',
    'devisDepl.title': '上门报价',
    'devisDepl.subtitle': '管理上门维修报价',
    'devisDepl.newDevis': '新建报价',
    'devisDepl.exportCsv': '导出 CSV',
    'devisDepl.remindBtn': '催办 ({{count}})',
    'devisDepl.sending': '发送中...',
    'devisDepl.send': '发送',
    'devisDepl.cancel': '取消',
    'devisDepl.errGeneric': '错误',
    'devisDepl.confirmSendReminders': '向 {{count}} 位报价待处理超过 3 天的客户发送提醒吗？',
    'devisDepl.remindersSent': '已发送 {{count}} 条提醒！',
    'devisDepl.sentByEmail': '报价已通过邮件发送！',
    'devisDepl.errSend': '发送出错',
    'devisDepl.confirmDelete': '删除此报价？',
    'devisDepl.searchPlaceholder': '按编号、姓名、邮箱搜索...',
    'devisDepl.noResults': '无结果',
    'devisDepl.empty': '尚未创建报价',
    'devisDepl.travelFeeLabel': '上门费',
    'devisDepl.invalidAmount': '金额无效',
    'devisDepl.errPayment': '支付出错',
    'devisDepl.confirmStaffAccept': '确认此报价？将创建一张采购单和一张发票。',
    'devisDepl.errValidation': '确认出错',
    'devisDepl.reminderSent': '提醒已发送',
    'devisDepl.errSendReminder': '发送提醒出错',
    'devisDepl.confirmValidateBon': '确认采购单？',
    'devisDepl.errSendFacture': '发送发票出错',
    'devisDepl.confirmDetach': '将此报价与维修 {{ref}} 解除关联？',
    'devisDepl.status.pending': '待处理',
    'devisDepl.status.accepted': '已接受',
    'devisDepl.status.refused': '已拒绝',
    'devisDepl.status.depositPaid': '已付定金',
    'devisDepl.status.paid': '已付款',
    'devisDepl.stats.total': '总计',
    'devisDepl.stats.pending': '待处理',
    'devisDepl.stats.accepted': '已接受',
    'devisDepl.stats.refused': '已拒绝',
    'devisDepl.stats.revenue': '收入',
    'devisDepl.filter.all': '全部状态',
    'devisDepl.requests.title': '收到的报价请求',
    'devisDepl.requests.newCountSingular': '{{count}} 条新',
    'devisDepl.requests.newCountPlural': '{{count}} 条新',
    'devisDepl.requests.defaultTitle': '报价请求',
    'devisDepl.requests.statusNew': '新',
    'devisDepl.requests.statusInProgress': '处理中',
    'devisDepl.requests.statusRefused': '已拒绝',
    'devisDepl.requests.statusTreated': '已处理',
    'devisDepl.requests.client': '客户',
    'devisDepl.requests.addressLabel': '地址',
    'devisDepl.requests.createDevis': '创建报价',
    'devisDepl.requests.markTreated': '已处理',
    'devisDepl.requests.refuse': '拒绝',
    'devisDepl.requests.refuseMotifLabel': '拒绝原因',
    'devisDepl.requests.refuseMotifPlaceholder': '拒绝原因（可选）...',
    'devisDepl.requests.confirmRefuse': '确认拒绝',
    'devisDepl.requests.refuseMotifShownLabel': '拒绝原因：',
    'devisDepl.sumup.title': 'SumUp 链接请求',
    'devisDepl.sumup.pendingCount': '{{count}} 项待处理',
    'devisDepl.sumup.enterLinkAlert': '请输入 SumUp 链接',
    'devisDepl.sumup.linkSentAlert': 'SumUp 链接已通过邮件发送给客户！',
    'devisDepl.sumup.linkPlaceholder': '在此粘贴 SumUp 链接...',
    'devisDepl.chart.title': '最近 30 天的活动',
    'devisDepl.chart.accepted': '已接受',
    'devisDepl.chart.pending': '待处理',
    'devisDepl.chart.refused': '已拒绝',
    'devisDepl.chart.noData': '此期间无数据',
    'devisDepl.form.editTitle': '编辑报价',
    'devisDepl.form.newTitle': '新建报价',
    'devisDepl.form.clientName': '客户姓名 *',
    'devisDepl.form.searchPlaceholder': '输入以搜索...',
    'devisDepl.form.phone': '电话',
    'devisDepl.form.email': '邮箱 *',
    'devisDepl.form.emailPlaceholder': 'email@example.com',
    'devisDepl.form.address': '地址',
    'devisDepl.form.addressPlaceholder': '客户地址',
    'devisDepl.form.descriptionLabel': '维修描述',
    'devisDepl.form.descriptionPlaceholder': '需完成工作的描述...',
    'devisDepl.form.lines': '报价明细',
    'devisDepl.form.addLine': '添加',
    'devisDepl.form.designation': '项目',
    'devisDepl.form.price': '价格',
    'devisDepl.form.travelFee': '上门费 ({{amount}})',
    'devisDepl.form.acceptOnline': '接受在线支付（SumUp）',
    'devisDepl.form.acceptOnlineHint': '客户可以申请 SumUp 支付链接',
    'devisDepl.form.total': '总计',
    'devisDepl.form.submitEdit': '更新',
    'devisDepl.form.submitCreate': '创建报价',
    'devisDepl.form.nameEmailRequired': '客户姓名和邮箱为必填项',
    'devisDepl.form.atLeastOneLine': '请至少添加一行含项目和价格的明细',
    'devisDepl.detail.phone': '电话：',
    'devisDepl.detail.address': '地址：',
    'devisDepl.detail.purchaseOrder': '采购单：',
    'devisDepl.detail.invoice': '发票：',
    'devisDepl.detail.emailSentOn': '邮件发送于 {{date}}',
    'devisDepl.detail.reminderSentOn': '提醒发送于 {{date}}',
    'devisDepl.table.designation': '项目',
    'devisDepl.table.qty': '数量',
    'devisDepl.table.price': '价格',
    'devisDepl.table.total': '合计',
    'devisDepl.actions.validateDevis': '确认报价',
    'devisDepl.actions.sendByEmail': '通过邮件发送报价',
    'devisDepl.actions.remindAcceptance': '催促接受',
    'devisDepl.actions.edit': '编辑',
    'devisDepl.actions.validateBon': '确认采购单',
    'devisDepl.actions.bonValidated': '采购单已确认',
    'devisDepl.actions.remindPayment': '催促付款',
    'devisDepl.actions.pdfDevis': '报价 PDF',
    'devisDepl.actions.pdfBon': '采购单 PDF',
    'devisDepl.actions.pdfFacture': '发票 PDF',
    'devisDepl.actions.sendFactureEmail': '通过邮件发送发票',
    'devisDepl.actions.registerPayment': '登记付款',
    'devisDepl.actions.delete': '删除',
    'devisDepl.actions.linkedTo': '已关联 {{ref}}',
    'devisDepl.actions.attachToRepair': '关联到维修',
    'devisDepl.payment.title': '登记付款',
    'devisDepl.payment.devisLabel': '报价：',
    'devisDepl.payment.totalLabel': '合计：',
    'devisDepl.payment.methodLabel': '支付方式',
    'devisDepl.payment.cash': '现金',
    'devisDepl.payment.card': '刷卡',
    'devisDepl.payment.transfer': '转账',
    'devisDepl.payment.mixed': '混合',
    'devisDepl.payment.amount': '金额',
    'devisDepl.payment.noteLabel': '备注（可选）',
    'devisDepl.payment.notePlaceholder': '例如：定金、尾款...',
    'devisDepl.payment.submit': '确认付款',
    'reviews.ratingFallback': '我们的顾客在 Google 上评价我们',
    'reviews.subtitle': '看看我们的顾客在 Google 上的评价，并分享您的体验。',
    'reviews.readCta': '查看我们的 Google 评价',
    'reviews.writeCta': '写评价',
    'acompteStart.title': '您报价的订金',
    'acompteStart.subtitle': 'Resurrection Mobile · SumUp 安全支付',
    'acompteStart.loading': '正在准备付款…',
    'acompteStart.redirecting': '正在跳转到付款页面',
    'acompteStart.clickHere': '如果没有反应，请点击这里。',
    'acompteStart.paid': '此订金已支付。谢谢！您的订单正在准备中。',
    'acompteStart.orderRef': '订单 {{ref}}',
    'acompteStart.errTitle': '在线支付暂时不可用',
    'acompteStart.retry': '重试',
    'acompteStart.whatsappPay': '通过 WhatsApp 付款 / 联系我们',
    'acompteStart.inStore': '订金也可以直接在门店支付。',
    'acompteStart.footer': '付款后，您的配件订单将自动记录，并通过电子邮件向您发送收据。',
    'acompteStart.backToSite': '返回网站',
    'acompteStart.errLinkUnavailable': '付款链接不可用。',
    'acompteStart.errOnlineUnavailable': '在线支付暂时不可用。',
    'acompteStart.waMessage': '您好，我想支付我报价（{{id}}）的订金。',
    'emailVerif.loadingTitle': '正在验证……',
    'emailVerif.loadingSub': '请稍候',
    'emailVerif.successTitle': '账户已激活！',
    'emailVerif.successDefault': '电子邮箱验证成功！',
    'emailVerif.login': '登录',
    'emailVerif.errorTitle': '验证出错',
    'emailVerif.errorDefault': '验证出错',
    'emailVerif.invalidLink': '验证链接无效。',
    'emailVerif.backLogin': '返回登录',
    'emailVerif.expiredTitle': '链接已过期',
    'emailVerif.expiredDefault': '此链接已过期。',
    'emailVerif.backLoginResend': '返回登录（重新发送邮件）',
    'paySuccess.noPaymentToVerify': '没有需要验证的付款',
    'paySuccess.statusCheckFailed': '无法验证状态。付款将自动处理。',
    'paySuccess.verificationError': '验证付款时出错',
    'paySuccess.completedTitle': '付款成功！',
    'paySuccess.completedDesc': '您的付款已确认并已记入您的档案。',
    'paySuccess.failedTitle': '付款失败',
    'paySuccess.failedDesc': '付款无法处理。请重试。',
    'paySuccess.pendingTitle': '付款处理中',
    'paySuccess.pendingDesc': '正在验证您的付款。将自动记入。',
    'paySuccess.verifying': '正在验证付款……',
    'paySuccess.errorTitle': '错误',
    'paySuccess.amountLabel': '金额：',
    'paySuccess.repairLabel': '维修：',
    'paySuccess.orderLabel': '订单：',
    'paySuccess.referenceLabel': '参考号：',
    'paySuccess.noInfo': '没有可用的付款信息。',
    'paySuccess.backToSpace': '返回我的空间',
    'devisChat.errStart': '无法启动聊天，请重试。',
    'devisChat.errSend': '发送失败',
    'devisChat.errNetwork': '网络错误',
    'devisChat.hint': '通过邮件索取报价',
    'devisChat.fabAria': '索取报价',
    'devisChat.fabLabel': '免费报价',
    'devisChat.panelTitle': 'R.E.Mobiles 报价',
    'devisChat.panelSubtitle': '审核后通过邮件发送',
    'devisChat.close': '关闭',
    'devisChat.connecting': '连接中…',
    'devisChat.inputPlaceholder': '例如：iPhone 13 屏幕…',
    'register.emailRequired': '创建账户需要填写电子邮箱。',
    'register.passwordMinLength': '密码至少需要包含 4 个字符。',
    'register.passwordMismatch': '两次输入的密码不一致。',
    'register.registerError': '注册时出错',
    'register.verifyEmailTitle': '请查看您的邮箱！',
    'register.confirmationSentTo': '一封确认邮件已发送至：',
    'register.activateHint': '点击邮件中的链接以激活您的账户。如果没看到，请同时检查垃圾邮件。',
    'register.goToLogin': '前往登录',
    'register.clientSubtitle': '查看您的维修进度',
    'register.namePlaceholder': '张伟',
    'register.emailPlaceholder': 'email@example.com',
    'register.emailHint': '将发送一封确认邮件以激活您的账户',
    'register.addressPlaceholder': '示例街 123 号',
    'register.password': '密码',
    'register.confirmPassword': '确认密码',
    'register.referralCode': '推荐码（可选）',
    'register.referredBy': '由 {{nom}} 推荐',
    'register.invalidReferral': '推荐码无效',
    'register.termsNotice': '创建账户即表示您接受我们的使用条款',
    'login.googleDisabled': 'Google 登录已停用。请使用您的用户名和密码。',
    'login.invalid2FA': '双重验证码无效',
    'login.tabStaff': '员工',
    'login.tabClient': '客户',
    'login.tabBusiness': '企业',
    'login.frenchGuiana': '法属圭亚那',
    'login.emailNotVerifiedTitle': '邮箱未验证',
    'login.emailNotVerifiedDesc': '登录前您必须确认您的邮箱。',
    'login.emailResent': '邮件已重新发送！请查看您的收件箱。',
    'login.sending': '正在发送……',
    'login.resendVerification': '重新发送确认邮件',
    'login.back': '返回',
    'login.twoFATitle': '双重验证',
    'login.twoFASubtitle': '请输入应用中的验证码',
    'login.verifying': '正在验证……',
    'login.verify': '验证',
    'login.passwordPlaceholder': '您的密码',
    'login.allRightsReserved': '版权所有。',
    'acompteSuccess.errorIncompleteLink': '支付链接不完整。',
    'acompteSuccess.errorCannotConfirm': '暂时无法确认付款。',
    'acompteSuccess.whatsappMessage': '您好，我已支付报价单的定金（编号 {{ref}}）。可以确认我的订单吗？',
    'acompteSuccess.whatsappDefault': '通过 WhatsApp 联系我们',
    'acompteSuccess.errorHint': '如果您的款项确实已扣除，您的订单将在接下来几分钟内自动登记，并且您会收到一封确认邮件。',
    'acompteSuccess.appliedTitle': '已收到定金',
    'acompteSuccess.orderRegisteredLead': '谢谢。您的配件订单',
    'acompteSuccess.orderRegisteredTail': '已登记。收据已通过电子邮件发送给您；发货后您将收到物流追踪号。',
    'acompteSuccess.staffPendingTitle': '已收到付款',
    'acompteSuccess.staffPendingBody': '您的定金已在 SumUp 成功登记。我们的团队正在手动完成您的订单，并会很快通过电子邮件向您确认。',
    'acompteSuccess.whatsappQuestion': '有疑问？WhatsApp',
    'acompteSuccess.sumupFailedTitle': '付款未完成',
    'acompteSuccess.sumupFailedBody': 'SumUp 未确认此付款（{{status}}）。您可以从报价邮件中的链接重新尝试，或与我们联系。',
    'acompteSuccess.timedOutTitle': '正在确认中',
    'acompteSuccess.timedOutBody': 'SumUp 尚未确认您的付款。请放心：如果已扣款，您的订单将在接下来几分钟内自动创建，并且您会收到一封确认邮件。您可以关闭此页面。',
    'acompteSuccess.recheckNow': '立即重新检查',
    'acompteSuccess.whatsappProof': '通过 WhatsApp 发送付款凭证',
    'acompteSuccess.verifyingTitle': '正在验证付款…',
    'acompteSuccess.verifyingBody': '请稍候几秒钟。',
    'acompteSuccess.backHome': '返回首页',
    'b2bDashboard.acceptRefuse': '接受 / 拒绝',
    'b2bDashboard.actions': '操作',
    'b2bDashboard.addNotePlaceholder': '为此次维修添加备注...',
    'b2bDashboard.addPhoto': '+ 添加',
    'b2bDashboard.additionalInfoPlaceholder': '补充信息...',
    'b2bDashboard.additionalNotes': '补充备注',
    'b2bDashboard.addressOptional': '地址（可选）',
    'b2bDashboard.addressPlaceholder': '如需上门服务的地址',
    'b2bDashboard.alertDescribeRequest': '请描述您的需求',
    'b2bDashboard.amount': '金额',
    'b2bDashboard.awaitingReceptionStore': '等待在门店接收',
    'b2bDashboard.back': '返回',
    'b2bDashboard.backGlass': '后盖玻璃',
    'b2bDashboard.backGlassBroken': '后盖玻璃破损',
    'b2bDashboard.backGlassIntact': '后盖玻璃完好',
    'b2bDashboard.brandModelRequired': '品牌和型号为必填项',
    'b2bDashboard.broken': '已破损',
    'b2bDashboard.changePassword': '修改密码',
    'b2bDashboard.chat': '聊天',
    'b2bDashboard.clear': '清除',
    'b2bDashboard.clickNewRequestHint': '点击“新建需求”以创建一个',
    'b2bDashboard.clickToAddPhotos': '点击添加照片',
    'b2bDashboard.code': '密码',
    'b2bDashboard.code6Digits': '6位数字验证码',
    'b2bDashboard.codeDigitsLetters': '密码（数字/字母）',
    'b2bDashboard.codeValidatedSuccess': '验证码验证成功！',
    'b2bDashboard.confirmOrderEmailPre': '一份带确认码的订单已发送到您的邮箱。请在',
    'b2bDashboard.confirmOrderEmailPost': '一栏输入此验证码以确认您的订单。',
    'b2bDashboard.createdOn': '创建于',
    'b2bDashboard.customerProvidesPart': '我自备配件',
    'b2bDashboard.date': '日期',
    'b2bDashboard.delivery': '配送',
    'b2bDashboard.delivery.pickup': '上门取件',
    'b2bDashboard.delivery.postal': '邮寄',
    'b2bDashboard.delivery.store': '到店',
    'b2bDashboard.describeProblemPlaceholder': '描述问题...',
    'b2bDashboard.designation': '项目',
    'b2bDashboard.device': '设备',
    'b2bDashboard.devisStatus.accepted': '已接受',
    'b2bDashboard.devisStatus.depositPaid': '已付定金',
    'b2bDashboard.devisStatus.paid': '已付款',
    'b2bDashboard.devisStatus.pending': '待处理',
    'b2bDashboard.devisStatus.refused': '已拒绝',
    'b2bDashboard.diagRef': '诊断参考：',
    'b2bDashboard.documentsWord': '文档',
    'b2bDashboard.downloadError': '下载出错',
    'b2bDashboard.downloadPdf': '下载 PDF',
    'b2bDashboard.enter6DigitCode': '请输入6位数字验证码',
    'b2bDashboard.enterCodePerOrder': '请输入邮件中收到的验证码以确认每份订单。',
    'b2bDashboard.enterCodeToValidate': '请输入邮件中收到的验证码以确认您的订单。',
    'b2bDashboard.enterPinPlaceholder': '输入 PIN 码、密码...',
    'b2bDashboard.enterValidationCode': '请输入验证码',
    'b2bDashboard.error': '出错',
    'b2bDashboard.filter.all': '全部',
    'b2bDashboard.history': '历史记录',
    'b2bDashboard.imeiSerial': 'IMEI / 序列号',
    'b2bDashboard.imeiSerialShort': 'IMEI / 序列号',
    'b2bDashboard.incorrectCode': '验证码错误',
    'b2bDashboard.invoiceLabel': '发票：',
    'b2bDashboard.invoiceType.combined': '合并',
    'b2bDashboard.invoiceType.diag': '诊断',
    'b2bDashboard.invoiceType.repair': '维修',
    'b2bDashboard.invoices': '发票',
    'b2bDashboard.invoicesAppearWhenPriced': '一旦 R.E.Mobiles 确定价格，发票即会显示',
    'b2bDashboard.latePayment': '付款逾期 - {{days}} 天',
    'b2bDashboard.lock': '锁',
    'b2bDashboard.lockCode': '锁屏密码',
    'b2bDashboard.mostRecent': '最新优先',
    'b2bDashboard.nav.documents': '报价 / 发票',
    'b2bDashboard.nav.quoteRequest': '申请报价',
    'b2bDashboard.newQuoteRequest': '新建报价申请',
    'b2bDashboard.newRequest': '新建需求',
    'b2bDashboard.noInvoiceAvailable': '暂无可用发票',
    'b2bDashboard.noPhoto': '暂无照片',
    'b2bDashboard.noPosInvoice': '暂无采购发票',
    'b2bDashboard.noQuoteRequest': '暂无报价申请',
    'b2bDashboard.noTravelQuote': '暂无上门报价',
    'b2bDashboard.nonFunctionalParts': '无法正常工作的部件',
    'b2bDashboard.noteSaveError': '保存备注时出错',
    'b2bDashboard.notes': '备注',
    'b2bDashboard.oldest': '最早优先',
    'b2bDashboard.optional': '可选',
    'b2bDashboard.orderValidated': '订单已确认',
    'b2bDashboard.orderValidatedSuccess': '订单已确认！',
    'b2bDashboard.orderValidationCode': '订单确认验证码',
    'b2bDashboard.paid': '已付款',
    'b2bDashboard.paidLabel': '已付',
    'b2bDashboard.partProvidedByStore': '配件将由 R.E.Mobiles 提供',
    'b2bDashboard.parts.backCam': '后置摄像头',
    'b2bDashboard.parts.backGlass': '后盖玻璃',
    'b2bDashboard.parts.battery': '电池',
    'b2bDashboard.parts.chargingPort': '充电口',
    'b2bDashboard.parts.earSpeaker': '听筒',
    'b2bDashboard.parts.fingerprint': '指纹',
    'b2bDashboard.parts.frontCam': '前置摄像头',
    'b2bDashboard.parts.homeButton': '主屏键',
    'b2bDashboard.parts.lcd': '屏幕',
    'b2bDashboard.parts.microphone': '麦克风',
    'b2bDashboard.parts.powerButton': '电源键',
    'b2bDashboard.parts.signal': '信号',
    'b2bDashboard.parts.speaker': '扬声器',
    'b2bDashboard.parts.volumeButton': '音量键',
    'b2bDashboard.parts.wifiBt': 'Wi-Fi/蓝牙',
    'b2bDashboard.pattern': '图案',
    'b2bDashboard.pay': '支付',
    'b2bDashboard.payRemaining': '支付余款（{{amount}}）',
    'b2bDashboard.paymentCreateError': '创建支付时出错',
    'b2bDashboard.paymentLinkUnavailable': '支付链接不可用。请联系 R.E.Mobiles。',
    'b2bDashboard.pdfDownloadError': '下载 PDF 时出错',
    'b2bDashboard.pdfInvoice': '发票 PDF',
    'b2bDashboard.pdfPurchaseOrder': '订单 PDF',
    'b2bDashboard.pdfQuote': '报价 PDF',
    'b2bDashboard.penaltiesLine': '滞纳金：{{penalty}} + 补偿金：{{indemnity}}',
    'b2bDashboard.photos': '照片',
    'b2bDashboard.pickupAddress': '取件地址',
    'b2bDashboard.pickupAddressPlaceholder': '取手机的完整地址...',
    'b2bDashboard.pickupAddressRequired': '请输入取件地址',
    'b2bDashboard.pickupRequested': '已申请上门取件 - 我们将前往取走设备',
    'b2bDashboard.posInvoices': '采购发票（POS）',
    'b2bDashboard.price': '价格',
    'b2bDashboard.priceCol': '价格',
    'b2bDashboard.priceDiagnostic': '诊断费用',
    'b2bDashboard.pricePending': '待定 - 将由 R.E.Mobiles 确定',
    'b2bDashboard.priceRepair': '维修费用',
    'b2bDashboard.problem': '问题',
    'b2bDashboard.problemDescription': '问题 / 描述',
    'b2bDashboard.purchaseOrderLabel': '订单：',
    'b2bDashboard.quoteRequestTitle': '报价申请',
    'b2bDashboard.refusalReason': '拒绝原因：',
    'b2bDashboard.remaining': '剩余',
    'b2bDashboard.repairAcceptedByStaff': '维修已被工作人员接受',
    'b2bDashboard.repairRefusedByStaff': '维修已被工作人员拒绝',
    'b2bDashboard.repairTitle': '维修 {{ref}}',
    'b2bDashboard.requestDescription': '您的需求描述',
    'b2bDashboard.requestDescriptionPlaceholder': '描述您的需求：维修类型、数量、问题等。',
    'b2bDashboard.requestStatus.inProgress': '处理中',
    'b2bDashboard.requestStatus.new': '新建',
    'b2bDashboard.requestStatus.processed': '已处理',
    'b2bDashboard.requestStatus.refused': '已拒绝',
    'b2bDashboard.retentionInvoices': '发票将在我们的服务器上保存 18 个月。',
    'b2bDashboard.retentionQuotes': '报价将在我们的服务器上保存 1 个月。',
    'b2bDashboard.saveNote': '保存备注',
    'b2bDashboard.saving': '保存中...',
    'b2bDashboard.searchPlaceholder': '搜索...',
    'b2bDashboard.sendRequest': '提交我的需求',
    'b2bDashboard.sending': '发送中...',
    'b2bDashboard.status.awaitingParts': '等待配件',
    'b2bDashboard.status.awaitingPickup': '等待上门取件',
    'b2bDashboard.status.awaitingReception': '等待接收',
    'b2bDashboard.status.completed': '已完成',
    'b2bDashboard.status.delivered': '已交付',
    'b2bDashboard.status.inProgress': '进行中',
    'b2bDashboard.status.received': '已收到',
    'b2bDashboard.status.refused': '已拒绝',
    'b2bDashboard.statusCol': '状态',
    'b2bDashboard.submitError': '提交时出错',
    'b2bDashboard.teamResponse': '团队回复：',
    'b2bDashboard.titleOptional': '标题（可选）',
    'b2bDashboard.titlePlaceholder': '例如：三星屏幕批量维修',
    'b2bDashboard.total': '合计',
    'b2bDashboard.totalDue': '应付总额：{{amount}}',
    'b2bDashboard.trackingBadge': '物流：',
    'b2bDashboard.trackingNumber': '物流单号',
    'b2bDashboard.trackingPlaceholder': '例如：1Z999AA10123456784',
    'b2bDashboard.trackingRequired': '请输入邮寄的物流单号',
    'b2bDashboard.trackingShort': '物流单号',
    'b2bDashboard.travelFee': '上门费',
    'b2bDashboard.travelQuotes': '上门报价',
    'b2bDashboard.uploadError': '上传出错',
    'b2bDashboard.uploading': '上传中...',
    'b2bDashboard.validate': '确认',
    'b2bDashboard.validationCodeConfirmed': '验证码已确认',
    'client.mySpace': '我的空间',
    'client.invoiceDownloadError': '下载发票时出错',
    'client.invoiceViewError': '显示发票时出错',
    'client.invoicePrintError': '打印发票时出错',
    'client.pinMustBe4': 'PIN 码必须为 4 位数字',
    'client.pinMismatch': '两次输入的 PIN 码不一致',
    'client.pinChanged': 'PIN 码修改成功！',
    'client.pinChangeError': '修改 PIN 码时出错',
    'client.describeRequest': '请描述您的需求',
    'client.error': '错误',
    'client.enterValidationCode': '请输入验证码',
    'client.codeValidated': '验证码验证成功！',
    'client.codeIncorrect': '验证码不正确',
    'client.sumupUrlUnavailable': '错误：SumUp 支付链接不可用',
    'client.sumupCreateError': '创建 SumUp 支付时出错',
    'client.fillRequired': '请填写所有必填字段',
    'client.invalidEmail': '电子邮件地址无效',
    'client.requestError': '请求时出错',
    'client.trackingSaved': '追踪号已保存！',
    'client.statusText.recu': '设备已在工作室收到',
    'client.statusText.enCours': '维修进行中',
    'client.statusText.attentePieces': '等待配件中',
    'client.statusText.termine': '维修完成 - 待取件',
    'client.statusText.livre': '设备已取回',
    'client.statusText.demandeEnLigne': '等待接收设备',
    'client.statusText.nonReparable': '设备无法维修',
    'client.statusLabel.recu': '已接收',
    'client.statusLabel.enCours': '进行中',
    'client.statusLabel.attentePieces': '等待配件',
    'client.statusLabel.termine': '已完成',
    'client.statusLabel.livre': '已交付',
    'client.statusLabel.recupere': '已取回',
    'client.statusLabel.demandeEnLigne': '在线申请',
    'client.statusLabel.nonReparable': '无法维修',
    'client.created': '已创建',
    'client.technicianNotes': '技师备注',
    'client.noNotes': '暂无备注',
    'client.file': '个文件',
    'client.files': '个文件',
    'client.navigation': '导航',
    'client.devisFactures': '报价单 / 发票',
    'client.myAddresses': '我的地址',
    'client.myAccount': '我的账户',
    'client.needHelp': '需要帮助吗？',
    'client.helpHours': '我们的团队周一至周六 9:00 至 19:00 为您服务。',
    'client.contactUs': '联系我们',
    'client.contactSupport': '联系客服',
    'client.guideMe': '引导我',
    'client.logout': '退出登录',
    'client.changePassword': '修改密码',
    'client.addresses': '地址',
    'client.requestRepair': '申请维修',
    'client.showDelivered': '查看已交付',
    'client.hideDelivered': '隐藏已交付',
    'client.noRepairsInProgress': '没有进行中的维修',
    'client.onlineRepairRequest': '在线维修申请',
    'client.diagFeeFormPre': '请填写下方表单。',
    'client.diagFeeFormPost': '的诊断费需在线支付。',
    'client.repairReason': '维修原因',
    'client.repairReasonPlaceholder': '例如：屏幕碎裂、电池……',
    'client.fullName': '姓名',
    'client.fullNamePlaceholder': '您的姓名',
    'client.postalAddress': '邮寄地址',
    'client.addressPlaceholder': '您的地址',
    'client.emailAddress': '电子邮件地址',
    'client.emailPlaceholder': 'email@example.com',
    'client.describeIssue': '详细描述故障',
    'client.describeIssuePlaceholder': '请告诉我们手机/平板是如何发生故障的，以及您观察到的症状……',
    'client.devicePhotos': '设备照片',
    'client.addPhotos': '添加照片',
    'client.cancel': '取消',
    'client.sending': '发送中……',
    'client.sendRequest': '发送申请',
    'client.requestSaved': '申请已登记：{{ref}}',
    'client.redirecting': '正在跳转……',
    'client.payDiagnosticSumup': '使用 SumUp 支付 {{amount}}（诊断费）',
    'client.diagFeePending': '您的申请正在等待处理。如需开始诊断，请支付费用',
    'client.depositOrSend': '请将您的设备送到门店，或通过邮政寄送并附回执：',
    'client.trackingPlaceholder': '邮政追踪号',
    'client.save': '保存',
    'client.postalDelayNotice': '如通过邮政寄送：申请失效期限延长至 20 天（删除期限为 40 天）',
    'client.close': '关闭',
    'client.progress': '进度',
    'client.deposits': '已付定金',
    'client.rest': '剩余',
    'client.payWithSumup': '使用 SumUp 支付 {{amount}}',
    'client.detailedTracking': '详细跟踪',
    'client.chatRepair': '维修对话 {{ref}}',
    'client.contact': '联系',
    'client.photosCount': '照片（{{count}}）',
    'client.level': '{{name}}等级',
    'client.tierOr': '金',
    'client.tierArgent': '银',
    'client.tierBronze': '铜',
    'client.totalPurchases': '共 {{count}} 次购买',
    'client.nextLevel': '下一等级：',
    'client.purchasesToNext': '还差 {{count}} 次购买',
    'client.rewardAvailable': '奖励可用！',
    'client.reward10Reached': '恭喜，您已达到 {{count}} 次购买',
    'client.rewardPosDesc': '用于您下次门店购物',
    'client.rewardRepairDesc': '用于您下次维修',
    'client.loyaltyPoints': '会员积分',
    'client.purchasesUntilReward': '再购买 {{count}} 次即可获得奖励',
    'client.rewardReached': '已达成奖励！',
    'client.rewardsHistory': '奖励记录',
    'client.reward15Pos': '门店 -15%',
    'client.reward10Repair': '维修 -10%',
    'client.referralProgram': '推荐计划',
    'client.referralSubtitle': '分享您的代码，赢取奖励积分',
    'client.yourReferralCode': '您的推荐码',
    'client.copied': '已复制！',
    'client.copy': '复制',
    'client.referralShare1': '将此代码分享给亲友。当他们使用该代码注册时，您将获得',
    'client.referralBonusPoints': '+2 积分',
    'client.referralShare2': '会员奖励！',
    'client.copyReferralLink': '复制注册链接',
    'client.referrals': '受邀人',
    'client.bonusPoints': '奖励积分',
    'client.yourReferrals': '您的受邀人',
    'client.referralFallback': '受邀人',
    'client.myDevis': '我的报价单',
    'client.newRequest': '新申请',
    'client.newDevisRequest': '新建报价申请',
    'client.titleOptional': '标题（可选）',
    'client.devisTitlePlaceholder': '例如：iPhone 15 屏幕维修',
    'client.requestDescription': '您的需求描述',
    'client.devisDescPlaceholder': '描述您的需求：维修类型、问题等。',
    'client.addressOptional': '地址（可选，用于上门服务）',
    'client.devisAddressPlaceholder': '如需上门服务，请填写您的地址',
    'client.sendMyRequest': '发送我的申请',
    'client.myDevisRequests': '我的报价申请',
    'client.devisRequestTitle': '报价申请',
    'client.devisReqNouveau': '新建',
    'client.devisReqEnCours': '处理中',
    'client.devisReqRefuse': '已拒绝',
    'client.devisReqTraite': '已处理',
    'client.teamResponse': '团队回复：',
    'client.refusalReason': '拒绝原因：',
    'client.clickNewRequest': '点击「新申请」以创建',
    'client.designation': '项目',
    'client.price': '价格',
    'client.travelFees': '出行费',
    'client.totalUpper': '合计',
    'client.paid': '已付',
    'client.purchaseOrder': '采购单',
    'client.invoice': '发票',
    'client.latePayment': '逾期付款 - {{days}} 天',
    'client.latePenaltyLabel': '逾期罚金（年利率 {{rate}}%）',
    'client.recoveryIndemnity': '固定催收赔偿金',
    'client.totalWithPenalties': '含罚金应付总额',
    'client.validationCodeTitle': '采购单验证码',
    'client.validationCodeDesc': '请输入通过电子邮件收到的验证码以确认您的订单。',
    'client.code6digits': '6 位验证码',
    'client.validate': '确认',
    'client.codeConfirmed': '验证码已确认',
    'client.pdfDevis': '报价单 PDF',
    'client.pdfPurchaseOrder': '采购单 PDF',
    'client.pdfInvoice': '发票 PDF',
    'client.payRest': '支付余款（{{amount}}）',
    'client.deposit50': '50% 定金',
    'client.fullPayment': '全额支付',
    'client.myInvoices': '我的发票',
    'client.mostRecent': '最新',
    'client.oldest': '最早',
    'client.noInvoices': '暂无可用发票',
    'client.view': '查看',
    'client.print': '打印',
    'client.seeLess': '收起',
    'client.seeMoreInvoices': '查看更多（{{count}} 张发票）',
    'client.invoiceRetention': '发票在我们的服务器上保存 18 个月。',
    'client.devisRetention': '报价单在我们的服务器上保存 1 个月。',
    'client.createCaricature': '制作我的漫画像',
    'client.copyrightBy': '版权所有',
    'client.notifications': '通知',
    'client.markAllRead': '全部标为已读',
    'client.noNotifications': '暂无通知',
    'client.pinChangeTitle': '修改 PIN 码',
    'client.pinChangeDesc': '为了您的安全，请设置新的 4 位 PIN 码。',
    'client.newPin': '新 PIN 码',
    'client.confirmPin': '确认 PIN 码',
    'client.modifying': '修改中……',
    'client.changePin': '修改我的 PIN 码',
    'client.proofSent': '付款凭证已发送！工作人员将进行核实。',
    'client.sendError': '发送时出错',
    'client.orderStatusEnAttente': '待处理',
    'client.orderStatusPayee': '已付款',
    'client.orderStatusProofUploaded': '凭证已发送',
    'client.orderStatusConfirmee': '已确认',
    'client.orderStatusPreparee': '已备货',
    'client.orderStatusExpediee': '已发货',
    'client.orderStatusLivree': '已送达',
    'client.orderStatusAnnulee': '已取消',
    'client.trackingNumber': '追踪号：',
    'client.trackingHint': '使用此号码追踪您的包裹',
    'client.stepCommande': '下单',
    'client.proofSentLabel': '付款凭证已发送',
    'client.sentOn': '发送于',
    'client.validatedByStaff': '已由工作人员核实',
    'client.payWithSumupPlain': '使用 SumUp 支付',
    'client.sendProof': '发送付款凭证（截图）',
    'client.history': '历史记录',
    'client.chatOrder': '订单对话 {{ref}}',
    'client.homeLabel': '住宅',
    'client.enterFullAddress': '请输入您的完整地址。',
    'client.saveError': '保存时出错',
    'client.addressLabelField': '标签',
    'client.labelPlaceholder': '住宅、办公室……',
    'client.phone': '电话',
    'client.phonePlaceholder': '06 94 ...',
    'client.recipient': '收件人',
    'client.recipientPlaceholder': '收件人姓名',
    'client.deliveryAddress': '收货地址',
    'client.addressInputPlaceholder': '请输入您的完整地址',
    'client.freeAddressHint': '自由输入：如出现建议请选择，否则直接输入您的地址。',
    'client.searching': '搜索中……',
    'client.addressValidated': '地址已确认',
    'client.saving': '保存中……',
    'client.confirmDeleteAddress': '删除此地址？',
    'client.manageAddressesSubtitle': '管理您的收货地址',
    'client.addAddress': '添加地址',
    'client.newAddress': '新地址',
    'client.editAddress': '编辑地址',
    'client.default': '默认',
    'client.edit': '编辑',
    'client.delete': '删除',
    'client.setDefault': '设为默认',
    'client.selectAddress': '请选择或添加收货地址。',
    'client.orderSuccess': '下单成功！',
    'client.orderError': '下单时出错',
    'client.ourAccessories': '我们的配件',
    'client.expertSelection': '经我们专家测试的精选',
    'client.allCategories': '全部类别',
    'client.cart': '购物车',
    'client.noArticles': '暂无可用商品',
    'client.inStock': '有货',
    'client.unavailable': '缺货',
    'client.add': '添加',
    'client.myCart': '我的购物车',
    'client.articleSingular': '件商品',
    'client.articlesPlural': '件商品',
    'client.cartEmpty': '您的购物车为空',
    'client.manage': '管理',
    'client.processing': '处理中……',
    'client.payOnDelivery': '货到付款',
    'publicShop.status.en_attente': '等待中',
    'publicShop.status.en_cours': '处理中',
    'publicShop.status.termine': '已完成',
    'publicShop.status.pret': '已就绪',
    'publicShop.status.livre': '已交付',
    'publicShop.status.annule': '已取消',
    'publicShop.repairNotFound': '未找到维修记录',
    'publicShop.shopNotFound': '未找到店铺',
    'publicShop.trackTitle': '跟踪我的维修',
    'publicShop.trackSubtitle': '输入您的序列号或跟踪码',
    'publicShop.trackPlaceholder': '序列号或跟踪码……',
    'publicShop.trackButton': '跟踪',
    'publicShop.labelDateEntree': '送修日期：',
    'publicShop.labelSortiePrevue': '预计取件日期：',
    'publicShop.labelProbleme': '问题：',
    'publicShop.labelRemarques': '备注：',
    'publicShop.poweredBy': '由 {{brand}} 提供技术支持',
    'invoiceRequest.subtitle': '发票申请',
    'invoiceRequest.search.title': '查找您的购买记录',
    'invoiceRequest.search.hint': '请输入准确金额和大致时间。',
    'invoiceRequest.search.amountLabel': '已付金额（EUR）',
    'invoiceRequest.search.amountPlaceholder': '例如：25.00',
    'invoiceRequest.search.timeLabel': '时间',
    'invoiceRequest.search.dateLabel': '日期',
    'invoiceRequest.search.loading': '搜索中…',
    'invoiceRequest.search.submit': '搜索',
    'invoiceRequest.results.title': '选择您的购买记录',
    'invoiceRequest.results.paidLabel': '已付：',
    'invoiceRequest.itemsCount': '{{count}} 件商品',
    'invoiceRequest.back': '返回',
    'invoiceRequest.form.title': '您的信息',
    'invoiceRequest.form.purchase': '购买',
    'invoiceRequest.form.alreadyPaid': '已支付',
    'invoiceRequest.form.payment': '支付方式',
    'invoiceRequest.form.remaining': '剩余',
    'invoiceRequest.form.nameLabel': '全名',
    'invoiceRequest.form.namePlaceholder': '张伟',
    'invoiceRequest.form.emailLabel': '电子邮箱',
    'invoiceRequest.form.emailPlaceholder': 'zhangwei@example.com',
    'invoiceRequest.form.phoneLabel': '电话',
    'invoiceRequest.form.phonePlaceholder': '0694XXXXXX',
    'invoiceRequest.form.sending': '发送中…',
    'invoiceRequest.form.submit': '发送发票',
    'invoiceRequest.pending.title': '申请待处理',
    'invoiceRequest.pending.desc': '此发票已发送至其他邮箱地址。',
    'invoiceRequest.pending.validationRequired': '需要验证',
    'invoiceRequest.pending.info': '您的申请已转交我们的团队。审核通过后，发票将发送至 {{email}}。',
    'invoiceRequest.newRequest': '新申请',
    'invoiceRequest.success.title': '发票已发送！',
    'invoiceRequest.success.desc': '您的发票已发送至 {{email}}。',
    'invoiceRequest.success.accountCreated': '客户账户已创建！',
    'invoiceRequest.success.newAccountDesc': '您的登录凭证已发送至 {{email}}。',
    'invoiceRequest.success.sendingCredentials': '发送中…',
    'invoiceRequest.success.resendCredentials': '通过邮件接收我的登录凭证',
    'invoiceRequest.success.credentialsSent': '登录凭证已发送至 {{email}}',
    'invoiceRequest.success.trackRepairs': '跟踪我的维修',
    'invoiceRequest.footer': 'R.E.Mobiles — 102 Avenue Général de Gaulle, Porte 2, 97300 Cayenne',
    'invoiceRequest.errors.search': '搜索出错',
    'invoiceRequest.errors.notFound': '未找到与此金额和时间对应的销售记录。请核对信息。',
    'invoiceRequest.errors.send': '发送时出错',
    'invoiceRequest.errors.generic': '出错',
    'storefront.notfound.title': '未找到该企业',
    'storefront.notfound.desc': '该企业不存在或已停用。',
    'storefront.notfound.back': '返回首页',
    'storefront.tab.track': '跟踪我的维修',
    'storefront.tab.login': '客户专区',
    'storefront.track.title': '维修进度查询',
    'storefront.track.subtitle': '输入您的参考编号以跟踪维修进度',
    'storefront.track.format': '参考编号格式：',
    'storefront.track.submit': '查询',
    'storefront.track.not_found': '未找到该维修单',
    'storefront.track.ref': '参考编号',
    'storefront.track.device': '设备',
    'storefront.track.problem': '问题',
    'storefront.track.date_in': '送修日期',
    'storefront.track.date_out': '预计完成日期',
    'storefront.status.waiting': '等待中',
    'storefront.status.in_progress': '处理中',
    'storefront.status.done': '已完成',
    'storefront.status.delivered': '已交付',
    'storefront.status.cancelled': '已取消',
    'storefront.status.unknown': '未知',
    'storefront.login.title': '客户登录',
    'storefront.login.subtitle': '登录您在 {{name}} 的客户专区',
    'storefront.login.phone': '电话',
    'storefront.login.pin': 'PIN 码',
    'storefront.login.error_fields': '请输入您的电话和 PIN 码（4 位或 6 位数字）',
    'storefront.login.error_invalid': '凭证不正确',
    'storefront.login.loading': '正在登录...',
    'storefront.login.submit': '登录',
    'storefront.login.create_account': '还没有账户？创建账户',
    'storefront.register.title': '创建账户',
    'storefront.register.subtitle': '在 {{name}} 注册',
    'storefront.register.name': '全名',
    'storefront.register.name_ph': '张伟',
    'storefront.register.phone': '电话',
    'storefront.register.email': '电子邮箱（可选）',
    'storefront.register.email_ph': 'email@example.com',
    'storefront.register.pin': 'PIN 码',
    'storefront.register.pin_confirm': '确认 PIN 码',
    'storefront.register.error_required': '姓名和电话为必填项',
    'storefront.register.error_pin_short': 'PIN 码至少需要 4 位数字',
    'storefront.register.error_pin_mismatch': '两次输入的 PIN 码不一致',
    'storefront.register.error_generic': '创建账户时出错',
    'storefront.register.loading': '正在创建...',
    'storefront.register.submit': '创建我的账户',
    'storefront.register.back_to_login': '已有账户？登录',
    'landing.svcScreenTitle': '屏幕破裂',
    'landing.svcScreenDesc': '更换 iPhone、三星、华为屏幕',
    'landing.svcBatteryTitle': '电池',
    'landing.svcBatteryDesc': '更换各品牌电池',
    'landing.svcConnectorTitle': '接口',
    'landing.svcConnectorDesc': '充电接口、音频插孔',
    'landing.svcCameraTitle': '摄像头',
    'landing.svcCameraDesc': '前置和后置摄像头',
    'landing.svcOxidationTitle': '进水维修',
    'landing.svcOxidationDesc': '手机掉进水里',
    'landing.svcDiagTitle': '检测',
    'landing.svcDiagDesc': '视机型 35 至 80 €，免费报价',
    'landing.tip1': '**您好！**我可以跟踪您的维修进度或为您估价。',
    'landing.tip2': '所有维修、配件和工时均享**6 个月保修**。',
    'landing.tip3': '**检测**费用视机型 35 至 80 €，开始前先告知。',
    'landing.tip4': '手机进水了？请**关机**并尽快送来：店内除氧化处理。',
    'landing.tip5': '凭参考编号 **REM0001** 实时跟踪您的维修进度。',
    'landing.tip6': '**微焊接**与数据恢复，即使设备已无法开机。',
    'landing.tip7': '营业时间**周一至周五 9:00–19:00**、**周六 9:00–14:00**，无需预约即可送修。',
    'landing.tip8': '在线**免费报价**，确认后通过电子邮件发送。',
    'landing.tip9': '企业用户：专属**企业空间**（B2B 门户）。',
    'landing.tip10': 'iPhone、三星、华为、小米、平板和**游戏机**：我们全都能修。',
    'landing.tipFromPrice': '起价 {{price}} — 价格以门店确认为准。',
    'landing.guideMe': '引导我',
    'landing.flashUntil': '截至 {{date}}',
    'landing.cadbotTitle': 'CADBOT，您的助手',
    'landing.cadbotDesc': '维修跟踪、报价估算、营业时间——它直接在网站上为您解答。最终价格始终以门店确认为准。',
    'landing.servicesTitle': '我们的维修服务',
    'landing.servicesDesc': '在法属圭亚那卡宴提供智能手机和平板电脑快修服务',
    'landing.seeAllPrices': '查看全部价格',
    'landing.readBlog': '阅读我们的博客',
    'landing.diagTitle': '门店检测',
    'landing.diagDesc': '视机型 35 至 80 €。开始前会先告知价格。在线报价始终免费。',
    'landing.tierFrom': '最低',
    'landing.tierUpTo': '最高',
    'landing.tierEntryTitle': '入门及中端机型',
    'landing.tierEntryDesc': '简单且已确定的故障',
    'landing.tierRecentTitle': '较新的智能手机',
    'landing.tierRecentDesc': '需要检查多项症状',
    'landing.tierComplexTitle': '复杂情况',
    'landing.tierComplexDesc': '进水损坏、微焊接、游戏机、平板电脑',
    'landing.enlarge': '放大',
    'landing.storePhotoAlt': '我们位于卡宴的 Resurrection Mobile 门店',
    'landing.storeTag': '我们的门店 · 卡宴',
    'landing.enlargedPhoto': '放大的照片',
    'landing.close': '关闭',
    'landing.storePhotoAltSimple': 'Resurrection Mobile 门店',
    'landing.freeQuote': '免费报价',
    'privacy.title': '隐私政策',
    'privacy.last_updated': '最后更新：2026年3月19日',
    'privacy.intro.part1': '本隐私政策说明 ',
    'privacy.intro.part2': '（“我们”“我们的”）如何收集、使用、保存和保护用户（“您”“您的”）的个人数据，其依据为 ',
    'privacy.intro.rgpd': '《通用数据保护条例》（GDPR — 欧盟 2016/679）',
    'privacy.intro.part3': ' ，该法规适用于法国及法属圭亚那。',
    'privacy.s1.title': '数据处理负责人',
    'privacy.s1.company_label': '公司',
    'privacy.s1.status_label': '法律形式',
    'privacy.s1.controller_note': '数据处理负责人是指确定处理您个人数据的目的和方式的个人或实体。',
    'privacy.s2.title': '收集的个人数据',
    'privacy.s2.sub1_title': '2.1 身份识别数据',
    'privacy.s2.sub1_b1': '姓名',
    'privacy.s2.sub1_b2': '邮寄地址',
    'privacy.s2.sub1_b3': '电话号码',
    'privacy.s2.sub1_b4': '电子邮箱地址',
    'privacy.s2.sub1_b5': '公司名称（如为企业客户）',
    'privacy.s2.sub2_title': '2.2 与服务相关的数据',
    'privacy.s2.sub2_b1': '所托修设备的信息（品牌、型号、IMEI、序列号）',
    'privacy.s2.sub2_b2': '维修记录',
    'privacy.s2.sub2_b3': '订单、报价和发票',
    'privacy.s2.sub2_b4': '电子签名',
    'privacy.s2.sub3_title': '2.3 支付数据',
    'privacy.s2.sub3_b1': '交易信息',
    'privacy.s2.sub3_b2': '所使用的支付方式',
    'privacy.s2.payment_important_label': '重要：',
    'privacy.s2.payment_important_text': '我们绝不存储您完整的银行信息。支付由安全的服务商（Stripe）处理。',
    'privacy.s2.sub4_title': '2.4 技术数据',
    'privacy.s2.sub4_b1': 'IP 地址',
    'privacy.s2.sub4_b2': '连接数据',
    'privacy.s2.sub4_b3': 'Cookie 和跟踪器',
    'privacy.s2.sub4_b4': '浏览数据',
    'privacy.s3.title': '数据处理的目的',
    'privacy.s3.b1': '提供我们的维修和销售服务',
    'privacy.s3.b2': '管理订单、报价和开票',
    'privacy.s3.b3': '提供客户跟进和售后服务',
    'privacy.s3.b4': '与您联系（短信、电子邮件、电话）',
    'privacy.s3.b5': '遵守我们的法律和会计义务',
    'privacy.s3.b6': '改进我们的服务和安全性',
    'privacy.s3.b7': '防止欺诈',
    'privacy.s4.title': '数据处理的法律依据',
    'privacy.s4.intro': '根据 GDPR，数据处理基于：',
    'privacy.s4.i1': '合同的履行',
    'privacy.s4.i2': '法律义务的遵守',
    'privacy.s4.i3': '您的同意（例如：营销）',
    'privacy.s4.i4': '我们的合法利益（安全、改进）',
    'privacy.s5.title': '数据接收方',
    'privacy.s5.b1': '我们获授权的员工',
    'privacy.s5.b2': '我们的技术服务商（托管、支付、短信、电子邮件）',
    'privacy.s5.b3': '法律要求时的行政或司法机关',
    'privacy.s5.no_sale': '我们不会将任何个人数据出售给第三方。',
    'privacy.s6.title': '向欧盟以外地区的传输',
    'privacy.s6.text': '如果某些服务商位于欧盟以外，我们将确保其提供符合 GDPR 的充分保护水平（标准合同条款、充分性决定等）。',
    'privacy.s7.title': '数据保存期限',
    'privacy.s7.r1_label': '客户数据',
    'privacy.s7.r1_value': '最后一次商业往来后 5 年',
    'privacy.s7.r2_label': '开票数据',
    'privacy.s7.r2_value': '10 年（法律义务）',
    'privacy.s7.r3_label': '营销数据',
    'privacy.s7.r3_value': '直至撤回同意为止',
    'privacy.s7.r4_label': 'Cookie',
    'privacy.s7.r4_value': '最长 13 个月',
    'privacy.s8.title': '数据安全',
    'privacy.s8.intro': '我们采取适当的技术和组织措施：',
    'privacy.s8.b1': '对数据的受限访问',
    'privacy.s8.b2': '安全托管',
    'privacy.s8.b3': '必要时进行加密',
    'privacy.s8.b4': '定期备份',
    'privacy.s8.b5': '防止未经授权的访问',
    'privacy.s9.title': '您的权利',
    'privacy.s9.intro': '根据 GDPR，您享有以下权利：',
    'privacy.s9.r1': '访问权',
    'privacy.s9.r2': '更正权',
    'privacy.s9.r3': '删除权（“被遗忘权”）',
    'privacy.s9.r4': '限制处理权',
    'privacy.s9.r5': '反对权',
    'privacy.s9.r6': '数据可携权',
    'privacy.s9.r7': '撤回同意权',
    'privacy.s9.exercise': '如需行使您的权利，请通过以下方式联系我们：',
    'privacy.s9.complaint_before': '您也可以向 ',
    'privacy.s9.complaint_after': ' 提出投诉。',
    'privacy.s10.title': 'Cookie',
    'privacy.s10.intro': '我们的网站可能使用 Cookie 以：',
    'privacy.s10.b1': '确保网站正常运行',
    'privacy.s10.b2': '统计访问量',
    'privacy.s10.b3': '改善用户体验',
    'privacy.s10.manage': '您可以通过您的浏览器或我们的 Cookie 横幅管理您的偏好设置。',
    'privacy.s11.title': '未成年人数据',
    'privacy.s11.text': '我们的服务不面向未经父母授权的未成年人。若误收集了未成年人的数据，请联系我们予以删除。',
    'privacy.s12.title': '政策的变更',
    'privacy.s12.text': '我们可能随时修改本政策，以反映法律或技术的变化。现行有效版本为发布在我们网站上的版本。',
    'privacy.s13.title': '联系方式',
    'privacy.s13.intro': '如对本政策或您的个人数据有任何疑问：',
    'privacy.footer': '使用我们的服务即表示您确认已阅读本隐私政策。',
    'track.title': '跟踪我的维修',
    'track.label_ref': '参考号',
    'track.label_device': '设备',
    'track.label_received': '收件日期',
    'track.label_expected': '预计完成',
    'track.label_completed': '完成日期',
    'track.label_amount': '金额',
    'track.status_pending': '等待中',
    'track.see_full': '查看完整详情',
    'track.input_placeholder': '请输入您的参考号（例如：REM0001）',
    'track.btn_track': '跟踪',
    'track.scan_qr': '扫描我小票上的二维码',
    'track.err_invalid_ref': '参考号无效。期望格式：REM0001',
    'track.err_not_found': '未找到维修记录',
    'chatWidget.statusStaffOnline': '团队在线',
    'chatWidget.statusAiActive': 'AI 已启用 — 自动回复',
    'chatWidget.statusOffline': '离线 — 请留言',
    'chatWidget.launcherLabel': '聊天与帮助',
    'chatWidget.tabStaff': '客服聊天',
    'chatWidget.tabAi': 'AI 帮助',
    'chatWidget.newMessage': '新消息',
    'chatWidget.loading': '加载中...',
    'chatWidget.noConversations': '暂无会话',
    'chatWidget.emptyConvoHint': '点击「{{action}}」联系我们',
    'chatWidget.conversationFallback': '会话',
    'chatWidget.autoReplyTitle': 'AI 自动回复模式已启用',
    'chatWidget.autoReplyDesc': '团队当前离线，AI 会先行回复。',
    'chatWidget.staffEmptyTitle': '给团队发条消息',
    'chatWidget.staffEmptyDesc': '我们会尽快回复您',
    'chatWidget.aiAssistant': 'AI 助手',
    'chatWidget.badgeAuto': '自动',
    'chatWidget.badgeQuoteIndicative': '参考报价',
    'chatWidget.badgeQuotePending': '报价准备中',
    'chatWidget.supportFallback': '客服',
    'chatWidget.sending': '发送中...',
    'chatWidget.staffInputPlaceholder': '您的消息...',
    'chatWidget.interactiveGuides': '互动指南',
    'chatWidget.stepsCount': '{{count}} 个步骤',
    'chatWidget.faqTitle': '常见问题',
    'chatWidget.back': '返回',
    'chatWidget.stepProgress': '第 {{current}} / {{total}} 步',
    'chatWidget.previous': '上一步',
    'chatWidget.next': '下一步',
    'chatWidget.finish': '完成',
    'chatWidget.aiInputPlaceholder': '输入您的问题...',
    'chatWidget.aiError': '抱歉，发生了错误。',
    'chatWidget.me': '我',
    'chatWidget.newConversationSubject': '新会话',
    'hours.title': '营业时间',
    'hours.rows.weekdays.label': '周一至周五',
    'hours.rows.weekdays.hours': '9:00 - 19:00',
    'hours.rows.saturday.label': '周六',
    'hours.rows.saturday.hours': '9:00 - 14:00',
    'hours.rows.sunday.label': '周日',
    'hours.closed': '休息',
    'hours.unit.hour': '小时',
    'hours.unit.minute': '分',
    'hours.unit.second': '秒',
    'hours.clock': '卡宴时间 {{time}}',
    'hours.ring.dayProgress': '当天进度',
    'hours.ring.untilReopen': '距离重新开门',
    'hours.state.openNow': '现在营业',
    'hours.state.closingSoon': '即将关门',
    'hours.state.closed': '已关门',
    'hours.count.untilClose': '距离关门（{{hour}}:00）',
    'hours.count.untilOpen': '距离开门',
    'hours.sub.openSince': '已营业 {{duration}}',
    'hours.sub.nextOpen': '下次营业：{{when}} {{hour}}:00',
    'hours.when.today': '今天',
    'hours.when.tomorrow': '明天',
    'hours.mood.closingSoon': '⏳ 最后时段——我们还在等你来！',
    'hours.mood.justOpened': '☕ 我们刚开门——欢迎过来看看！',
    'hours.mood.open': '🟢 正在营业，随时欢迎光临！',
    'hours.mood.opensSoon': '🚪 不到一小时就开门——马上就拉起卷帘！',
    'hours.mood.sundayRest': '🌴 周日休息——周一9点见！',
    'hours.mood.morning': '🌅 早上好！我们{{hour}}点开门，准备好您的设备吧。',
    'hours.mood.evening': '🌙 今晚已打烊——很快再见！',
    'hours.dayName.0': '周日',
    'hours.dayName.1': '周一',
    'hours.dayName.2': '周二',
    'hours.dayName.3': '周三',
    'hours.dayName.4': '周四',
    'hours.dayName.5': '周五',
    'hours.dayName.6': '周六',
    'cadbot.welcome': '您好，我是 **CADBOT**，Resurrection Mobile 的助手。输入您的参考号 **REM0001** 查询维修进度，或描述您的故障以获取估价。',
    'cadbot.chip.status': '我的维修进展如何？',
    'cadbot.chip.screen': 'iPhone 11 屏幕碎了，多少钱？',
    'cadbot.chip.battery': 'Galaxy S21 电池，价格？',
    'cadbot.chip.diagnostic': '检测要多少钱？',
    'cadbot.chip.hours': '营业时间和地址？',
    'cadbot.note': '估价仅供参考，最终均以店内确认为准。详细报价将在我们团队核实后通过电子邮件发送。',
    'cadbot.status.online': '在线',
    'cadbot.resume.label': '继续我的对话',
    'cadbot.resume.title': '显示在此标签页中开始的对话',
    'cadbot.reset.label': '新对话',
    'cadbot.reset.title': '清除此对话并重新开始',
    'cadbot.input.label': '您的消息',
    'cadbot.input.placeholderIdentity': '您的姓名、电话或邮箱…',
    'cadbot.input.placeholderDefault': 'REM0001、iPhone 13 屏幕、电池…',
    'cadbot.send.aria': '发送',
    'cadbot.local.greeting': '您好！我是 **CADBOT**。我可以查询您的维修进度（参考号 REM0001）、估算报价，或告诉您我们的营业时间。',
    'cadbot.local.diagnostic': '店内检测费用根据设备和复杂程度从 {{min}} 到 {{max}} 不等。开始前会先告知您价格。而在线报价是免费的。',
    'cadbot.local.water': '请关机且不要充电，然后尽快拿到店里。除氧化处理将在检测后报价。',
    'cadbot.local.hoursLine': '我们位于 **{{address}}**。营业时间：{{hours}}。{{state}}',
    'cadbot.local.hoursOpen': '**{{state}}** — {{time}} {{countLabel}}。',
    'cadbot.local.hoursClosed': '**已关闭** — {{sub}}。',
    'cadbot.local.closedLower': '休息',
    'cadbot.local.warranty': '我们所有的维修均保修 **6 个月**，含配件和工时。',
    'cadbot.local.accounts': '入口就在上方：**客户专区**（查询您的维修）、**企业专区**（B2B 门户）和**员工专区**。',
    'cadbot.local.trackAsk': '请按 **REM0001** 的格式输入您的参考号（在您的收件单上），我会告诉您进度。',
    'cadbot.local.quoteFollowup': '我们团队核实后会立即通过电子邮件发送您的报价（请留意垃圾邮件）。如果 24 小时内没有收到，请通过 WhatsApp 联系我们：**{{phone}}**。',
    'cadbot.local.contact': '您可以通过 **{{phone}}** 联系我们（电话和 WhatsApp）。',
    'cadbot.track.here': '以下是 **{{ref}}** 的进度：',
    'cadbot.track.notFound': '我找不到维修单 **{{ref}}**。请核对您收件单上的参考号。',
    'cadbot.track.unavailable': '进度查询暂时不可用，请稍后再试。',
    'cadbot.server.ackDefault': '谢谢，技术人员会很快回复您。',
    'cadbot.error.rateLimit': '一次请求过多——请等待 {{wait}} 后重试。',
    'cadbot.error.waitMinutes': '{{n}} 分钟',
    'cadbot.error.waitFallback': '一分钟',
    'cadbot.error.server': '我无法连接到服务器。请通过 WhatsApp 联系我们：**{{phone}}**。',
    // ── tarifs.* (pilote i18n 2026-09-12 — à relire) ──
    'tarifs.back': '首页',
    'tarifs.searchPlaceholder': '搜索型号或维修类型…',
    'tarifs.loading': '正在加载价格…',
    'tarifs.updateTitle': '价格更新中',
    'tarifs.updateDesc': '我们的价格正在更新。请联系我们获取免费的个性化报价。',
    'tarifs.call': '拨打电话',
    'tarifs.callPrefix': '拨打：',
    'tarifs.callNow': '立即拨打',
    'tarifs.noResult': '无结果',
    'tarifs.soon': '价格即将公布',
    'tarifs.tryOther': '请尝试其他关键词',
    'tarifs.contactFree': '联系我们获取免费报价',
    'tarifs.repairBrand': '{{brand}} 维修',
    'tarifs.tariffsCount': '{{count}} 个价格可用',
    'tarifs.colModel': '型号',
    'tarifs.colRepair': '维修',
    'tarifs.colPrice': '价格',
    'tarifs.colDelay': '时长',
    'tarifs.allModels': '所有型号',
    'tarifs.whatsapp': 'WhatsApp',
    'tarifs.portal': '客户门户',
    'tarifs.faqTitle': '常见问题',
    'tarifs.titleFallback': '手机维修价格',
    'tarifs.subtitleFallback': '查看我们为 iPhone、三星、华为等提供的维修价格。法属圭亚那卡宴，快速且有保障的维修。',
    'tarifs.ctaTitleFallback': '需要个性化报价吗？',
    'tarifs.ctaDescFallback': '每一次维修都是独一无二的。请联系我们获取免费诊断和适合您情况的准确报价。',
    'nav.activityHub': '活动中心', 'nav.salesHistory': '销售历史', 'nav.equipeMagasins': '团队和门店', 'nav.usersLegacy': '用户（旧版）', // [i18n-P0 2026-09-12: a relire]
    _name: '中文',
    _flag: '🇨🇳',
    'nav.dashboard': '仪表盘', 'nav.pos': '销售点', 'nav.calcul': '价格计算', 'nav.devis': '报价 / 发票', 'nav.devisDeplacement': '上门报价', 'nav.commandes': '订单', 'nav.addDevice': '添加设备', 'nav.reparations': '维修', 'nav.clients': '客户', 'nav.stock': '库存', 'nav.addStock': '添加库存', 'nav.etiquettes': '标签', 'nav.users': '用户', 'nav.clientPwd': '客户密码', 'nav.boutiqueOrders': '店铺订单', 'nav.caisseHistory': '收银历史', 'nav.database': '数据库', 'nav.historique': '历史', 'nav.paiements': '在线支付', 'nav.chatClients': '客户聊天', 'nav.chat': '消息', 'nav.notes': '笔记', 'nav.logout': '退出', 'nav.quit': '退出', 'nav.admin': '管理', 'nav.navigation': '导航', 'nav.b2b': 'B2B管理', 'nav.b2bPayments': 'B2B支付', 'nav.brandsModels': '品牌与型号',
    'common.save': '保存', 'common.cancel': '取消', 'common.delete': '删除', 'common.edit': '编辑', 'common.search': '搜索', 'common.add': '添加', 'common.close': '关闭', 'common.confirm': '确认', 'common.loading': '加载中...', 'common.noData': '无数据', 'common.actions': '操作', 'common.status': '状态', 'common.date': '日期', 'common.total': '合计', 'common.print': '打印', 'common.yes': '是', 'common.no': '否', 'common.back': '返回', 'common.next': '下一步', 'common.validate': '验证', 'common.ref': '参考号', 'common.client': '客户', 'common.phone': '电话', 'common.email': '邮箱', 'common.price': '价格', 'common.quantity': '数量', 'common.amount': '金额', 'common.send': '发送', 'common.download': '下载', 'common.export': '导出', 'common.refresh': '刷新', 'common.filter': '筛选', 'common.all': '全部', 'common.name': '姓名', 'common.address': '地址', 'common.description': '描述', 'common.payment': '付款', 'common.paid': '已付', 'common.pending': '待处理', 'common.accepted': '已接受', 'common.refused': '已拒绝',
    'layout.panel': '管理面板',
    'pos.title': '销售点', 'pos.scanner': '扫描', 'pos.searchProduct': '搜索商品...', 'pos.outOfStock': '缺货', 'pos.article': '商品', 'pos.unitPrice': '单价', 'pos.qty': '数量', 'pos.emptyCart': '购物车空', 'pos.checkout': '结账', 'pos.discount': '折扣', 'pos.subtotal': '小计', 'pos.validateSale': '确认销售', 'pos.paymentMode': '支付方式', 'pos.choosePayment': '选择支付方式：', 'pos.cash': '现金', 'pos.card': '银行卡', 'pos.mixed': '混合', 'pos.totalToCollect': '应收', 'pos.change': '找零', 'pos.confirmPayment': '确认付款', 'pos.validating': '处理中...', 'pos.lastTicket': '上一张票', 'pos.caisseClosed': '收银机已关闭。请从仪表盘打开。', 'pos.insufficientCash': '现金不足', 'pos.insufficientCard': '卡余额不足', 'pos.saleValidated': '销售已确认！', 'pos.emptyCartAlert': '购物车空', 'pos.designation': '名称', 'pos.stockInsufficient': '库存不足',
    'devis.title': '报价与发票', 'devis.subtitle': '价格计算文档。', 'devis.noDoc': '未找到文档', 'devis.type': '类型', 'devis.convertConfirm': '将报价转为订单？', 'devis.orderCreated': '订单已创建', 'devis.deleteConfirm': '删除此文档？', 'devis.deleted': '文档已删除',
    'devDep.title': '上门报价', 'devDep.subtitle': '管理上门维修报价', 'devDep.new': '新报价', 'devDep.edit': '编辑报价', 'devDep.clientName': '客户姓名', 'devDep.clientPhone': '电话', 'devDep.clientEmail': '邮箱', 'devDep.clientAddress': '地址', 'devDep.repairDesc': '维修说明', 'devDep.lines': '报价项目', 'devDep.addLine': '添加', 'devDep.travelFee': '上门费', 'devDep.sendByEmail': '邮件发送', 'devDep.sending': '发送中...', 'devDep.pdfDevis': 'PDF报价', 'devDep.pdfBon': 'PDF订购单', 'devDep.pdfFacture': 'PDF发票', 'devDep.searchPlaceholder': '按编号、姓名、邮箱搜索...', 'devDep.allStatuses': '所有状态', 'devDep.pending': '待处理', 'devDep.accepted': '已接受', 'devDep.refused': '已拒绝', 'devDep.depositPaid': '定金已付', 'devDep.fullyPaid': '已付清', 'devDep.stats': '统计', 'devDep.revenues': '收入', 'devDep.activity30d': '近30天活动', 'devDep.remind': '提醒', 'devDep.noDevis': '无报价', 'devDep.noResults': '无结果', 'devDep.bon': '订购单', 'devDep.facture': '发票', 'devDep.emailSent': '邮件已发送', 'devDep.reminderSent': '提醒已发送',
    'rep.title': '维修', 'rep.search': '搜索维修...', 'rep.new': '新维修', 'rep.deviceRef': '设备编号', 'rep.brand': '品牌', 'rep.model': '型号', 'rep.problem': '问题', 'rep.technician': '技师', 'rep.timeline': '时间线',
    'cmd.title': '订单', 'cmd.search': '搜索订单...', 'cmd.piece': '零件', 'cmd.supplier': '供应商', 'cmd.deposit': '定金', 'cmd.remaining': '余额',
    'clients.title': '客户', 'clients.search': '搜索客户...', 'clients.name': '姓名', 'clients.address': '地址', 'clients.addClient': '新客户',
    'stock.title': '库存管理', 'stock.search': '搜索商品...', 'stock.addArticle': '添加商品', 'stock.category': '类别', 'stock.buyPrice': '进价', 'stock.sellPrice': '售价', 'stock.available': '可用',
    'dash.title': '仪表盘', 'dash.openCaisse': '开启收银', 'dash.closeCaisse': '关闭收银', 'dash.todaySales': '今日销售', 'dash.monthSales': '月销售', 'dash.activeRepairs': '进行中维修', 'dash.pendingOrders': '待处理订单',
    'login.title': '登录', 'login.username': '用户名', 'login.password': '访问码', 'login.submit': '登录', 'login.clientAccess': '客户入口', 'login.staffAccess': '员工入口', 'lang.select': '语言',
    'client.space': '客户专区', 'client.repairs': '维修', 'client.boutique': '商店', 'client.orders': '订单', 'client.messages': '消息', 'client.devis': '报价', 'client.trackRepairs': '跟踪维修', 'client.noRepairs': '无维修', 'client.trackOrders': '跟踪订单', 'client.noOrders': '无订单', 'client.shop': '在线商店', 'client.noProducts': '无商品', 'client.addToCart': '加入购物车', 'client.yourMessages': '您的消息', 'client.noMessages': '无消息', 'client.send': '发送', 'client.brand': '品牌', 'client.model': '型号', 'client.problem': '问题', 'client.status': '状态', 'client.deposit': '定金', 'client.remaining': '余额', 'client.total': '合计', 'client.timeline': '时间线', 'client.noDevis': '无报价', 'client.acceptRefuse': '接受 / 拒绝', 'client.pay': '支付',
      // Translated keys
    'adminB2b.actions': '操作', 'adminB2b.address': '地址', 'adminB2b.all': '全部', 'adminB2b.awaitingPayment': '等待付款', 'adminB2b.b2bRepairs': 'B2B维修', 'adminB2b.backGlassBroken': '后盖玻璃损坏', 'adminB2b.bcValidated': '订单已确认', 'adminB2b.brandModel': '品牌 / 型号', 'adminB2b.changeStatus': '更改状态', 'adminB2b.clearFilter': '清除', 'adminB2b.clientPart': '客户配件', 'adminB2b.combined': '组合', 'adminB2b.companies': '企业', 'adminB2b.company': '企业', 'adminB2b.confirmReception': '确认接收', 'adminB2b.confirmRefuse': '拒绝这家企业？', 'adminB2b.confirmSuspend': '暂停这家企业？', 'adminB2b.confirmValidate': '确认这家企业？', 'adminB2b.delivery': '交付', 'adminB2b.diagPrice': '诊断价格', 'adminB2b.diagnostic': '诊断', 'adminB2b.downloadKbis': '下载KBIS', 'adminB2b.existingInvoices': '现有发票', 'adminB2b.filter': '筛选', 'adminB2b.filterCompany': '企业', 'adminB2b.filterDateEnd': '结束日期', 'adminB2b.filterDateStart': '开始日期', 'adminB2b.finalize': '完成开票', 'adminB2b.home': '首页', 'adminB2b.inStore': '到店', 'adminB2b.invoice': '发票', 'adminB2b.invoiceCancelled': '发票已取消', 'adminB2b.locked': '已锁定（已付）', 'adminB2b.markPaid': '标记已付', 'adminB2b.monthPrompt': '月份（1-12）？留空为上月：', 'adminB2b.monthlyRecap': '月度总结', 'adminB2b.noCompany': '未找到企业', 'adminB2b.noPayments': '无B2B付款', 'adminB2b.noRepairs': '无B2B维修', 'adminB2b.paidMethod': '已付', 'adminB2b.payHistoryTitle': 'B2B付款记录', 'adminB2b.paymentHistory': '付款记录', 'adminB2b.paymentMethodPrompt': '付款方式？', 'adminB2b.payments': '笔付款', 'adminB2b.pending': '待处理', 'adminB2b.pendingReception': '等待接收', 'adminB2b.phone': '电话', 'adminB2b.pickup': '上门取件', 'adminB2b.postal': '邮寄', 'adminB2b.price': '价格', 'adminB2b.problem': '问题', 'adminB2b.recapError': '错误', 'adminB2b.recapSent': '已发送', 'adminB2b.recapSkipped': '无维修', 'adminB2b.recapTitle': '月度总结结果', 'adminB2b.ref': '编号', 'adminB2b.refuse': '拒绝', 'adminB2b.refused': '已拒绝', 'adminB2b.registeredOn': '注册于', 'adminB2b.repair': '维修', 'adminB2b.repairPrice': '维修价格', 'adminB2b.search': '搜索...', 'adminB2b.sending': '正在发送...', 'adminB2b.setPrice': '设定价格', 'adminB2b.siret': 'SIRET', 'adminB2b.status': '状态', 'adminB2b.suspend': '暂停', 'adminB2b.suspended': '已暂停', 'adminB2b.title': 'B2B管理', 'adminB2b.total': '合计', 'adminB2b.totalCollected': '总收款', 'adminB2b.validate': '确认', 'adminB2b.validated': '已确认', 'adminB2b.validatedBy': '确认人', 'adminB2b.yearPrompt': '年份？',
    'adminDb.accessDenied': '访问被拒绝', 'adminDb.adminOnly': '仅限管理员', 'adminDb.clients': '客户', 'adminDb.exportBtn': '完整导出', 'adminDb.exportConfirm': '导出完整数据库？', 'adminDb.exportDesc': '将所有数据导出为JSON文件。', 'adminDb.exportError': '导出错误', 'adminDb.exportSuccess': '导出成功！', 'adminDb.exportTitle': '导出数据库', 'adminDb.fileSelected': '已选择文件', 'adminDb.importClientsBtn': '导入客户', 'adminDb.importClientsConfirm': '导入客户？将以电话号码创建账户。', 'adminDb.importConfirm': '警告：这将替换现有数据。继续？', 'adminDb.importDesc': '导入JSON文件以恢复或迁移数据。', 'adminDb.importDone': '导入完成！', 'adminDb.importError': '导入错误', 'adminDb.importFullBtn': '完整导入', 'adminDb.importSuccess': '导入成功！', 'adminDb.importTitle': '导入数据库', 'adminDb.importWarning': '完整导入将替换现有数据', 'adminDb.logsTitle': '操作日志', 'adminDb.noLogs': '无记录', 'adminDb.repairs': '维修', 'adminDb.selectFile': '选择文件', 'adminDb.selectFileClients': '选择包含客户的JSON文件', 'adminDb.stockArticles': '库存商品', 'adminDb.subtitle': '导出、导入和数据管理', 'adminDb.title': '数据库管理', 'adminDb.uploading': '正在上传...', 'adminDb.users': '用户',
    'adminSettings.accentColor': '强调色（hex）', 'adminSettings.addImage': '添加图片', 'adminSettings.bgImage': '背景图片', 'adminSettings.capital': '注册资本', 'adminSettings.change': '更改', 'adminSettings.companyInfo': '公司信息', 'adminSettings.companyName': '公司名称', 'adminSettings.companyType': '类型（SAS, SARL...）', 'adminSettings.contactHours': '联系方式和营业时间', 'adminSettings.email': '邮箱', 'adminSettings.error': '错误', 'adminSettings.euid': 'EUID', 'adminSettings.gallery': '图片库', 'adminSettings.googleMaps': 'Google地图搜索', 'adminSettings.headquarters': '总部', 'adminSettings.heroSection': '头部区域', 'adminSettings.mainTitle': '主标题', 'adminSettings.phone': '电话', 'adminSettings.preview': '预览', 'adminSettings.rcs': 'RCS', 'adminSettings.salesPoint': '销售点', 'adminSettings.save': '保存', 'adminSettings.saved': '已保存！', 'adminSettings.saving': '正在保存...', 'adminSettings.siret': 'SIRET', 'adminSettings.subtitle': '副标题', 'adminSettings.title': '首页设置', 'adminSettings.whatsapp': 'WhatsApp',
    'b2b.actions': '操作', 'b2b.addPhotos': '点击添加照片', 'b2b.additionalNotes': '附加说明', 'b2b.allStatus': '全部', 'b2b.amount': '金额', 'b2b.anotherRepair': '新维修', 'b2b.backGlass': '后盖玻璃', 'b2b.backGlassBroken': '后盖玻璃损坏', 'b2b.backGlassOk': '后盖玻璃完好', 'b2b.brand': '品牌', 'b2b.brandModelRequired': '品牌和型号必填', 'b2b.brokenParts': '损坏部件', 'b2b.clear': '清除', 'b2b.completed': '已完成', 'b2b.createdOn': '创建于', 'b2b.date': '日期', 'b2b.delivered': '已交付', 'b2b.deliveryMethod': '送达方式', 'b2b.device': '设备', 'b2b.deviceInfo': '设备信息', 'b2b.devicePhotos': '设备照片', 'b2b.diagPrice': '诊断价格', 'b2b.documents': '文件和发票', 'b2b.documentsDesc': '确认订单并下载发票', 'b2b.enterCode': '输入邮件中收到的验证码确认订单。', 'b2b.history': '历史记录', 'b2b.inProgress': '进行中', 'b2b.inStore': '到店', 'b2b.inStoreDesc': '送到店铺', 'b2b.invoices': '发票', 'b2b.lockCode': '锁屏密码', 'b2b.lockTypeCode': '密码（数字/字母）', 'b2b.lockTypeSchema': '图案', 'b2b.model': '型号', 'b2b.myRepairs': '我的维修', 'b2b.newRepair': '新维修', 'b2b.noInvoices': '无发票', 'b2b.noPhotos': '无照片', 'b2b.noRepairFound': '未找到维修记录', 'b2b.noRepairs': '无维修', 'b2b.orderValidated': '订单已确认', 'b2b.paid': '已付', 'b2b.partByShop': 'R.E.Mobiles提供配件', 'b2b.pendingValidation': '待确认订单', 'b2b.pickup': '上门取件', 'b2b.pickupAddress': '取件地址', 'b2b.pickupDesc': '我们上门取', 'b2b.postal': '邮寄', 'b2b.postalDesc': '含跟踪号', 'b2b.priceWaiting': '待定 - 将由R.E.Mobiles确定', 'b2b.problem': '问题 / 描述', 'b2b.providePart': '我提供配件', 'b2b.received': '已接收', 'b2b.recentRepairs': '最近维修', 'b2b.reference': '编号', 'b2b.registerDevice': '登记设备', 'b2b.repairAccepted': '维修已接受', 'b2b.repairPrice': '维修价格', 'b2b.repairRefused': '维修已拒绝', 'b2b.repairRegistered': '维修已登记', 'b2b.submitRepair': '提交维修', 'b2b.submitting': '正在提交...', 'b2b.thisMonth': '本月', 'b2b.trackingNumber': '跟踪号', 'b2b.validate': '确认', 'b2b.viewAll': '查看全部', 'b2b.viewDetails': '查看详情', 'b2b.waitingParts': '等待配件', 'b2b.waitingReception': '等待接收', 'b2b.welcome': '欢迎',
    'b2bDevis.acceptFirst': '请先接受报价再进行验证。', 'b2bDevis.alreadyPaid': '已支付', 'b2bDevis.codeHint': '输入邮件中收到的6位验证码。', 'b2bDevis.invoiceDownload': '下载发票', 'b2bDevis.noDevis': '无报价', 'b2bDevis.noDevisDesc': '暂时没有上门报价。', 'b2bDevis.orderDownload': '下载订单', 'b2bDevis.payDeposit': '支付50%定金', 'b2bDevis.payFull': '全额支付', 'b2bDevis.payRemaining': '支付余额', 'b2bDevis.pending': '待处理', 'b2bDevis.quoteDownload': '下载报价', 'b2bDevis.remaining': '待付', 'b2bDevis.title': '上门报价', 'b2bDevis.travelFee': '上门费', 'b2bDevis.validationCode': '验证码',
    'b2bPay.noPayments': '无付款', 'b2bPay.title': 'B2B付款',
    'b2bRegister.address': '地址', 'b2bRegister.alreadyAccount': '已注册？', 'b2bRegister.companyName': '公司名称', 'b2bRegister.confirmPassword': '确认密码', 'b2bRegister.creating': '正在注册...', 'b2bRegister.dropFile': '点击或拖放文件到此处', 'b2bRegister.fillAll': '请填写所有必填项', 'b2bRegister.goLogin': '前往登录', 'b2bRegister.kbis': 'KBIS证明（PDF）', 'b2bRegister.kbisDesc': '上传KBIS证明或相关文件（PDF）', 'b2bRegister.kbisRequired': '请上传KBIS证明', 'b2bRegister.managerName': '负责人姓名', 'b2bRegister.password': '密码', 'b2bRegister.phone': '电话', 'b2bRegister.proEmail': '工作邮箱', 'b2bRegister.pwdMinLength': '密码至少6个字符', 'b2bRegister.pwdNoMatch': '密码不匹配', 'b2bRegister.siret': 'SIRET', 'b2bRegister.siretError': 'SIRET必须包含14位数字', 'b2bRegister.submit': '注册', 'b2bRegister.subtitle': '创建您的企业账户', 'b2bRegister.success': '注册成功！', 'b2bRegister.successMsg': '您的账户正在审核中，您将收到确认邮件。', 'b2bRegister.title': '企业注册',
    'boutique.clientName': '客户', 'boutique.noOrders': '无订单', 'boutique.orderRef': '订单编号', 'boutique.status': '状态', 'boutique.title': '店铺订单', 'boutique.total': '合计',
    'brands.addBrand': '添加品牌', 'brands.addModel': '添加型号', 'brands.deleteConfirm': '删除此品牌？', 'brands.noBrands': '无品牌', 'brands.title': '品牌和型号',
    'caisse.closeDate': '关闭', 'caisse.closingAmount': '关台金额', 'caisse.noCaisse': '无收银台', 'caisse.openDate': '开启', 'caisse.openedBy': '由...打开', 'caisse.openingAmount': '开台金额', 'caisse.sales': '销售', 'caisse.title': '收银记录',
    'calc.generateInvoice': '生成发票', 'calc.generateQuote': '生成报价', 'calc.searchDevice': '搜索设备...', 'calc.selectRepair': '选择维修', 'calc.title': '价格计算器',
    'chat.noConversations': '无对话', 'chat.title': '消息', 'chat.typeMessage': '输入消息...',
    'clientPwd.generatePin': '生成PIN', 'clientPwd.noClients': '无客户', 'clientPwd.search': '搜索客户...', 'clientPwd.sendByEmail': '邮件发送', 'clientPwd.title': '客户密码',
    'clients.account': '账户', 'clients.activeAccount': '活跃', 'clients.add': '添加', 'clients.business': '企业', 'clients.clientType': '客户类型', 'clients.company': '公司', 'clients.deleteConfirm': '删除此客户？', 'clients.discount': '折扣', 'clients.discountPct': '折扣（%）', 'clients.editClient': '编辑客户', 'clients.individual': '个人', 'clients.manage': '客户管理', 'clients.newClient': '新客户', 'clients.noClients': '未找到客户', 'clients.noEmail': '无邮箱', 'clients.page': '页', 'clients.sent': '已发送', 'clients.total': '位客户', 'clients.type': '类型',
    'closeCaisse.actualTotal': '实际合计', 'closeCaisse.close': '关闭收银台', 'closeCaisse.closing': '正在关闭...', 'closeCaisse.countCoins': '现金盘点', 'closeCaisse.difference': '差额', 'closeCaisse.theoreticalTotal': '理论合计', 'closeCaisse.title': '关闭收银台',
    'cmd.addOrder': '新订单', 'cmd.allStatuses': '所有状态', 'cmd.cancelled': '已取消', 'cmd.deleteConfirm': '删除此订单？', 'cmd.editOrder': '编辑订单', 'cmd.manage': '订单管理', 'cmd.noOrders': '无订单', 'cmd.ordered': '已下单', 'cmd.received': '已收货', 'cmd.ref': '编号', 'cmd.status': '状态',
    'dash.activeRepairs': '活跃维修', 'dash.addDevice': '添加', 'dash.b2bPaymentsDesc': '发票和付款跟踪', 'dash.b2bPaymentsLabel': 'B2B付款', 'dash.brandsModelsDesc': '管理设备目录', 'dash.brandsModelsLabel': '品牌和型号', 'dash.caisseOpen': '收银台已开启', 'dash.calculation': '计算器', 'dash.clients': '客户', 'dash.closeCaisseReminder': '记得关闭收银台', 'dash.closeNormal': '正常关闭', 'dash.closing': '正在关闭...', 'dash.completed': '已完成', 'dash.contactAdmin': '请联系管理员关闭。', 'dash.dontOpen': '不打开（继续）', 'dash.errorForceClose': '强制关闭出错', 'dash.errorOpenCaisse': '打开收银台出错', 'dash.forceClose': '强制关闭', 'dash.forceCloseConfirm': '强制关闭收银台从', 'dash.hello': '您好', 'dash.inProgress': '进行中', 'dash.loggedAs': '当前登录', 'dash.lowStock': '库存不足的产品', 'dash.mustClose': '必须先关闭才能继续。', 'dash.noCaisse': '没有已开启的收银台', 'dash.noCaisseToday': '今天没有开启的收银台。', 'dash.noClient': '无客户', 'dash.noResults': '无结果', 'dash.open': '打开', 'dash.openCaisseTitle': '打开收银台', 'dash.openQuestion': '要现在打开收银台吗？', 'dash.openTotal': '开台金额', 'dash.openedBy': '由...打开', 'dash.opening': '正在打开...', 'dash.outOfStock': '已缺货', 'dash.recentRepairs': '最近维修', 'dash.registeredMonth': '本月注册', 'dash.repairs': '维修', 'dash.repairsSub': '维修', 'dash.salesBlocked': '收银台打开前销售将被阻止。', 'dash.searchPlaceholder': '按编号、客户、电话搜索...', 'dash.statsDesc': '收入、维修、B2B、客户', 'dash.statsTitle': '统计与分析', 'dash.stockAlerts': '库存警报', 'dash.thisMonth': '本月', 'dash.today': '今天', 'dash.todaySales': '今日销售', 'dash.unclosedNotClosed': '未关闭', 'dash.unclosedTitle': '收银台未关闭', 'dash.unknown': '未知', 'dash.waitingParts': '其中等待配件',
    'devDep.remindConfirm': '向报价超过3天的客户发送提醒？',
    'devisAccept.accept': '接受报价', 'devisAccept.accepted': '报价已接受！', 'devisAccept.acceptedMsg': '感谢您接受报价', 'devisAccept.alreadyAccepted': '此报价已被接受。', 'devisAccept.alreadyRefused': '此报价已被拒绝。', 'devisAccept.bonCommande': '订单', 'devisAccept.confirmRefuse': '确定要拒绝此报价吗？', 'devisAccept.deposit50': '定金50%', 'devisAccept.designation': '项目描述', 'devisAccept.emailSent': '已发送包含订单、验证码和登录信息的邮件。', 'devisAccept.error': '错误', 'devisAccept.facture': '发票', 'devisAccept.findBelow': '报价详情如下：', 'devisAccept.fullPayment': '全额付款', 'devisAccept.hello': '您好', 'devisAccept.homeRepairQuote': '上门维修报价', 'devisAccept.notFound': '报价未找到', 'devisAccept.payDeposit': '支付50%定金', 'devisAccept.paymentMsg': '请支付定金或全款以完成订单：', 'devisAccept.proceedPayment': '继续付款', 'devisAccept.refuse': '拒绝', 'devisAccept.refused': '报价已拒绝', 'devisAccept.refusedMsg': '您已拒绝此报价', 'devisAccept.statusMsg': '报价状态', 'devisAccept.thanks': '感谢您的反馈。', 'devisAccept.travelFee': '上门费', 'devisAccept.tvaNote': '不适用增值税。报价有效期30天。',
    'hist.amount': '金额', 'hist.articles': '商品', 'hist.client': '客户', 'hist.date': '日期', 'hist.noSales': '无销售', 'hist.payment': '付款', 'hist.ref': '编号', 'hist.refund': '退款', 'hist.refundConfirm': '退还此销售？', 'hist.search': '搜索销售...', 'hist.title': '销售记录',
    'labels.noLabels': '无标签', 'labels.print': '打印', 'labels.search': '搜索...', 'labels.selectAll': '全选', 'labels.title': '标签',
    'landing.allRights': '版权所有', 'landing.heroSubtitle': '您在圭亚那的手机维修专家', 'landing.mondayFriday': '周一 - 周五', 'landing.saturday': '周六', 'landing.sunday': '周日', 'landing.closed': '休息', 'landing.companyType': '简化股份有限公司 (SAS)', 'landing.openMaps': '在地图中打开', 'landing.rcs': '商业注册', 'landing.siret': '企业注册号', 'landing.euid': '欧盟企业标识', 'landing.shopAddress': '门店地址', 'landing.businessDesc': 'B2B门户', 'landing.businessSpace': '企业区域', 'landing.callWhatsapp': '电话和WhatsApp', 'landing.capital': '注册资本', 'landing.clientDesc': '维修跟踪', 'landing.clientSpace': '客户区域', 'landing.contact': '联系我们', 'landing.headquarters': '总部', 'landing.hours': '营业时间', 'landing.legal': '法律信息', 'landing.mobileRepair': '法属圭亚那手机维修', 'landing.staffDesc': '技术团队入口', 'landing.staffSpace': '员工区域', 'landing.writeUs': '直接联系我们',
    'login.b2bPassword': '密码', 'login.b2bPlaceholder': '您的密码', 'login.backHome': '返回首页', 'login.businessRegister': '企业注册', 'login.businessSpace': '企业区域', 'login.caricature': '创建我的头像', 'login.clientSpace': '客户区域', 'login.connect': '登录', 'login.connectYou': '登录', 'login.connecting': '正在连接...', 'login.createAccount': '创建账户', 'login.forgotPwd': '忘记密码？', 'login.noAccount': '还没有账户？', 'login.notRegistered': '还未注册？', 'login.phoneNumber': '手机号码', 'login.pin': 'PIN码（4或6位）', 'login.pinError': 'PIN必须为4或6位数字', 'login.pinHint': '请使用键盘输入密码。', 'login.proEmail': '工作邮箱', 'login.secure': '安全连接', 'login.staffSpace': '员工区域', 'login.wrongCredentials': '登录信息错误', 'login.yourId': '您的账号',
    'notes.deleteConfirm': '删除此备注？', 'notes.new': '新备注', 'notes.noNotes': '无备注', 'notes.title': '备注',
    'pay.amount': '金额', 'pay.client': '客户', 'pay.date': '日期', 'pay.noPayments': '无付款', 'pay.ref': '编号', 'pay.search': '搜索...', 'pay.status': '状态', 'pay.title': '在线付款', 'pay.type': '类型',
    'paySuccess.amountPaid': '已付金额', 'paySuccess.checking': '正在验证...', 'paySuccess.confirmed': '付款已确认！', 'paySuccess.depositDone': '已记录。', 'paySuccess.depositFor': '您的报价定金', 'paySuccess.depositRegistered': '定金已记录！', 'paySuccess.loginClient': '进入客户区域', 'paySuccess.payRemaining': '支付余额', 'paySuccess.paymentFor': '您的报价付款', 'paySuccess.pleaseWait': '正在验证您的付款，请稍候。', 'paySuccess.processing': '您的付款正在处理中，您将收到确认邮件。', 'paySuccess.registered': '已成功记录。', 'paySuccess.remaining': '待付', 'paySuccess.totalInvoice': '发票总额', 'paySuccess.waitingConfirm': '等待确认',
    'payment.accessClient': '进入客户区域', 'payment.alreadyPaid': '已全额支付。', 'payment.alreadyPaidAmount': '已支付', 'payment.amountToPay': '应付金额', 'payment.backToDevis': '返回报价', 'payment.client': '客户', 'payment.creationError': '创建支付出错', 'payment.deposit50': '定金50%', 'payment.depositPercent': '定金（50%）', 'payment.devis': '报价', 'payment.error': '错误', 'payment.fullPayment': '全额付款', 'payment.fullyPaid': '发票已全额支付', 'payment.mustAcceptFirst': '请先接受报价再进行付款。', 'payment.notAccepted': '报价未接受', 'payment.pay': '支付', 'payment.redirecting': '正在跳转到Stripe...', 'payment.remaining': '待付', 'payment.secure': '安全支付', 'payment.securedBy': '由Stripe保障支付安全', 'payment.totalDevis': '报价总额', 'payment.urlNotAvailable': '支付链接不可用', 'payment.viewDevis': '查看报价',
    'register.address': '地址（选填）', 'register.alreadyAccount': '已有账户？', 'register.backHome': '返回首页', 'register.clientTitle': '创建客户账户', 'register.confirmPin': '确认PIN码', 'register.createAccount': '创建我的账户', 'register.creating': '正在创建...', 'register.email': '邮箱（选填）', 'register.fullName': '全名', 'register.login': '登录', 'register.phone': '电话', 'register.pin': 'PIN码（4或6位）', 'register.pinError': 'PIN必须为4或6位数字', 'register.pinMinLength': 'PIN至少需要4位数字', 'register.pinNoMatch': 'PIN码不匹配',
    'remcaches.noItems': '无项目', 'remcaches.title': '现金汇款',
    'rep.addDeposit': '添加定金', 'rep.allStatuses': '所有状态', 'rep.changeStatus': '更改状态', 'rep.client': '客户', 'rep.date': '日期', 'rep.deleteConfirm': '删除此维修？', 'rep.deposit': '定金', 'rep.depositAmount': '定金金额', 'rep.depositHistory': '定金记录', 'rep.imei': 'IMEI / 序列号', 'rep.manage': '维修管理', 'rep.noRepairs': '无维修', 'rep.noTimeline': '无事件', 'rep.notes': '内部备注', 'rep.paymentMode': '付款方式', 'rep.phone': '电话', 'rep.printEtiquette': '打印标签', 'rep.printFiche': '打印记录', 'rep.sendChat': '发送消息', 'rep.totalDeposits': '定金总额',
    'repForm.brand': '品牌', 'repForm.client': '客户', 'repForm.editTitle': '编辑维修', 'repForm.imei': 'IMEI / 序列号', 'repForm.lockCode': '锁屏密码', 'repForm.model': '型号', 'repForm.price': '维修价格', 'repForm.problem': '发现的问题', 'repForm.submit': '保存', 'repForm.submitting': '正在保存...', 'repForm.technician': '指定技师', 'repForm.title': '添加设备',
    'reset.backLogin': '返回登录', 'reset.clientEmail': '账户邮箱', 'reset.confirmPwd': '确认密码', 'reset.emailSent': '邮件已发送', 'reset.emailSentMsg': '如果账户存在，您将收到密码重置链接。', 'reset.enterEmail': '输入您的邮箱', 'reset.error': '发生错误', 'reset.forgotDesc': '通过邮件接收重置链接', 'reset.forgotTitle': '忘记密码', 'reset.linkValid': '链接有效期1小时。', 'reset.newPwd': '新密码', 'reset.newPwdDesc': '选择您的新密码', 'reset.newPwdTitle': '新密码', 'reset.pwdMinLength': '密码至少4个字符', 'reset.pwdNoMatch': '密码不匹配', 'reset.pwdReset': '密码已重置', 'reset.pwdResetMsg': '您的密码已成功更改。', 'reset.resetPwd': '重置密码', 'reset.resetting': '正在重置...', 'reset.sendLink': '发送重置链接', 'reset.sending': '正在发送...',
    'stats.avgRepairTime': '平均时长', 'stats.b2b': 'B2B', 'stats.b2bByCompany': '按企业', 'stats.b2bCompanies': 'B2B企业', 'stats.b2bRepairs': 'B2B维修', 'stats.b2bRevenue': 'B2B收入', 'stats.back': '返回', 'stats.clients': '客户', 'stats.clientsByType': '按类型', 'stats.completionRate': '完成率', 'stats.monthly': '月度趋势', 'stats.monthlyRevenue': '月收入', 'stats.newThisMonth': '本月新增', 'stats.noData': '无数据', 'stats.registrations': '月注册量', 'stats.repairs': '维修', 'stats.repairsByBrand': '按品牌', 'stats.repairsByStatus': '按状态', 'stats.revenue': '收入', 'stats.revenueByPayment': '按付款方式', 'stats.revenueByType': '按类型', 'stats.title': '统计与分析', 'stats.topModels': '热门型号', 'stats.totalClients': '总客户', 'stats.totalRepairs': '总维修', 'stats.totalRevenue': '总收入（12个月）', 'stats.withAccount': '有账户',
    'stock.addForm': '添加商品', 'stock.alert': '警告', 'stock.barcode': '条形码', 'stock.deleteConfirm': '删除此商品？', 'stock.editForm': '编辑商品', 'stock.lowStockAlert': '库存不足', 'stock.manage': '库存管理', 'stock.noItems': '无商品', 'stock.reference': '编号',
    'users.accessDenied': '仅限管理员', 'users.active': '活跃', 'users.count': '位用户', 'users.createdAt': '创建于', 'users.deleteConfirm': '删除此用户？', 'users.edit': '编辑', 'users.inactive': '停用', 'users.new': '新用户', 'users.newPassword': '新密码（留空保持不变）', 'users.noUsers': '无用户', 'users.password': '密码', 'users.role': '角色', 'users.roleAdmin': '管理员', 'users.roleTech': '技师', 'users.roleUser': '销售员', 'users.status': '状态', 'users.title': '用户管理', 'users.username': '用户名',
    'pos.adminCode': '管理员代码', 'pos.adminId': '管理员ID', 'pos.adminOverride': '管理员覆盖', 'pos.clientOptional': '客户（可选）', 'pos.manualAdd': '添加缺货商品', 'pos.mixedMustEqual': '混合支付必须等于总额', 'pos.outOfStockProduct': '缺货商品', 'pos.selectPayment': '请选择支付方式',
    'sumup.acceptOnlinePayment': '接受在线支付（SumUp）', 'sumup.acceptOnlinePaymentDesc': '客户可以请求SumUp支付链接', 'sumup.requestLink': '请求SumUp支付链接', 'sumup.requestSent': '请求已发送！您将很快收到链接。', 'sumup.alreadyRequested': '请求已在处理中。', 'sumup.onlinePayment': 'SumUp在线支付', 'sumup.receiveLink': '通过电子邮件接收安全支付链接', 'sumup.linkRequested': '链接已请求', 'sumup.pendingRequests': 'SumUp链接请求', 'sumup.pending': '等待中', 'sumup.pasteLinkHere': '在此粘贴SumUp链接...', 'sumup.send': '发送', 'sumup.linkSent': 'SumUp链接已通过邮件发送给客户！',
};

export default zh;
